// src/schemas/PowercloudEvent/PowercloudEvent.ts
import { z as z24 } from "zod";

// src/schemas/PowercloudEvent/AccountPayment.ts
import { z } from "zod";
var AccountPaymentSchema = z.looseObject({
  type: z.string().nullable().optional()
});

// src/schemas/PowercloudEvent/AccountSettledReceivable.ts
import { z as z2 } from "zod";
var AccountSettledReceivableSchema = z2.looseObject({
  type: z2.string().nullable().optional()
});

// src/schemas/PowercloudEvent/Action.ts
import { z as z3 } from "zod";
var ActionSchema = z3.looseObject({
  handler: z3.string().nullable().optional(),
  handlerTitle: z3.string().nullable().optional(),
  handlerState: z3.string().nullable().optional(),
  handlerStateMessage: z3.string().nullable().optional()
});

// src/schemas/PowercloudEvent/Contract.ts
import { z as z8 } from "zod";

// src/schemas/PowercloudEvent/Customer.ts
import { z as z7 } from "zod";

// src/schemas/PowercloudEvent/CustomerGroup.ts
import { z as z4 } from "zod";
var CustomerGroupSchema = z4.looseObject({
  id: z4.string().nullable().optional(),
  additionalData: z4.array(z4.unknown()),
  data: z4.looseObject({
    name: z4.string().nullable().optional(),
    type: z4.string().nullable().optional(),
    extendedData: z4.looseObject({
      categories: z4.unknown(),
      values: z4.unknown()
    })
  })
});

// src/schemas/PowercloudEvent/ExtendedData.ts
import { z as z6 } from "zod";

// src/schemas/PowercloudEvent/shared.ts
import { z as z5 } from "zod";
var EventTypesSchema = z5.enum(["order", "contract", "invoice"]);
var VersandartSchema = z5.enum(["E-Mail", "Brief"]);
var BrandDataSchema = z5.looseObject({
  id: z5.string().nullable().optional(),
  name: z5.string().nullable().optional(),
  isDeleted: z5.string().nullable().optional(),
  createdBy: z5.string().nullable().optional(),
  createdAt: z5.string().nullable().optional()
});
var BrandSchema = z5.looseObject({
  id: z5.string().nullable().optional(),
  data: BrandDataSchema,
  additionalData: z5.array(z5.unknown()).nullable().optional()
});
var BankingDataSchema = z5.looseObject({
  activeFrom: z5.string().nullable().optional(),
  activeUntil: z5.string().nullable().optional(),
  alternativeAccountHolder: z5.string().nullable().optional(),
  bank: z5.string().nullable().optional(),
  bic: z5.string().nullable().optional(),
  directDebit: z5.boolean().nullable().optional(),
  direction: z5.string().nullable().optional(),
  iban: z5.string().nullable().optional(),
  paymentProvider: z5.string().nullable().optional(),
  replacedBankId: z5.string().nullable().optional(),
  sepaMandate: z5.string().nullable().optional()
});
var AddressFieldsSchema = z5.looseObject({
  zip: z5.string().nullable().optional(),
  city: z5.string().nullable().optional(),
  street: z5.string().nullable().optional(),
  houseNumber: z5.string().nullable().optional()
});

// src/schemas/PowercloudEvent/ExtendedData.ts
var ExtendedDatumSchema = z6.looseObject({
  name: z6.string().nullable().optional(),
  technicalKey: z6.string().nullable().optional(),
  type: z6.string().nullable().optional(),
  value: z6.string().nullable().optional(),
  createdAt: z6.string().nullable().optional(),
  position: z6.string().nullable().optional(),
  fieldValueId: z6.string().nullable().optional()
});
var ExtendedDatumCategorySchema = z6.looseObject({
  technicalKey: z6.string().nullable().optional(),
  createdAt: z6.string().nullable().optional(),
  name: z6.string().nullable().optional(),
  position: z6.string().nullable().optional()
});
var ExtendedDataSchema = z6.looseObject({
  values: z6.record(z6.string(), z6.array(ExtendedDatumSchema))
});
var ExtendedDataWithVartSchema = z6.looseObject({
  categories: z6.record(z6.string(), ExtendedDatumCategorySchema),
  values: z6.looseObject({
    VART: z6.tuple([
      ExtendedDatumSchema.extend({
        value: VersandartSchema
      })
    ]).optional(),
    ZSTURVORHANDEN: z6.tuple([
      ExtendedDatumSchema.extend({
        value: z6.enum(["1", "0"])
      })
    ]).optional()
  }).and(z6.record(z6.string(), z6.array(ExtendedDatumSchema)))
});
var ExtendedDataCustomerSchema = z6.looseObject({
  categories: z6.record(z6.string(), ExtendedDatumCategorySchema),
  values: z6.looseObject({
    // Kundenpräferenz der Versandart
    VART_KD: z6.tuple([
      ExtendedDatumSchema.extend({
        value: z6.enum(["1", "0"])
      })
    ]).nullable().optional()
  }).and(z6.record(z6.string(), z6.array(ExtendedDatumSchema)))
});

// src/schemas/PowercloudEvent/Customer.ts
var CustomerCommunicationTypeSchema = z7.enum(["0", "1", "2"]);
var CustomerCommunicationType = {
  NichtGesetzt: "0",
  Briefpost: "1",
  Email: "2"
};
var SalutationSchema = z7.string();
var AddressFieldsSchema2 = z7.looseObject({
  zip: z7.string().nullable().optional(),
  city: z7.string().nullable().optional(),
  street: z7.string().nullable().optional(),
  houseNumber: z7.string().nullable().optional()
});
var CustomerSchema = z7.looseObject({
  authorizedAt: z7.unknown().nullable().optional(),
  createdAt: z7.string().nullable().optional(),
  // Address fields
  ...AddressFieldsSchema2.shape,
  country: z7.string().nullable().optional(),
  countryName: z7.string().nullable().optional(),
  business: z7.string().nullable().optional(),
  unknown: z7.string().nullable().optional(),
  company: z7.string().nullable().optional(),
  countryId: z7.string().nullable().optional(),
  customerId: z7.string().nullable().optional(),
  status: z7.string().nullable().optional(),
  externalId: z7.unknown().nullable().optional(),
  // Personal details
  salutation: SalutationSchema,
  firstname: z7.string().nullable().optional(),
  title: z7.unknown().nullable().optional(),
  surname: z7.string().nullable().optional(),
  dateOfBirth: z7.string().nullable().optional(),
  // Notifications and auth
  availableSentNotification: z7.string().nullable().optional(),
  authUserName: z7.string().nullable().optional(),
  authEnabled: z7.string().nullable().optional(),
  accountUsername: z7.unknown().nullable().optional(),
  accountUseremail: z7.unknown().nullable().optional(),
  // Phone contacts
  phoneMobileAreaCode: z7.string().nullable().optional(),
  phoneMobile: z7.string().nullable().optional(),
  phoneHomeAreaCode: z7.string().nullable().optional(),
  phoneHome: z7.string().nullable().optional(),
  phoneBusinessAreaCode: z7.string().nullable().optional(),
  phoneBusiness: z7.string().nullable().optional(),
  // Email contacts
  emailPrivate: z7.string().nullable().optional(),
  emailBusiness: z7.string().nullable().optional(),
  // Marketing preferences
  adsMail: z7.string().nullable().optional(),
  adsPhone: z7.string().nullable().optional(),
  adsPost: z7.string().nullable().optional(),
  customerCommunicationType: CustomerCommunicationTypeSchema,
  // Extended data and related arrays
  extendedData: ExtendedDataCustomerSchema,
  customerGroups: z7.array(CustomerGroupSchema),
  customer_insolvencies: z7.array(z7.unknown()).nullable().optional()
});

// src/schemas/PowercloudEvent/Contract.ts
var BankingDataInOutSchema = z8.looseObject({
  in: z8.array(BankingDataSchema),
  out: z8.array(BankingDataSchema)
});
var ContractSchema = z8.looseObject({
  id: z8.string().nullable().optional(),
  accountId: z8.string().nullable().optional(),
  externalContractId: z8.unknown().nullable().optional(),
  bundleContractId: z8.unknown().nullable().optional(),
  authorizedAt: z8.unknown().nullable().optional(),
  type: z8.string().nullable().optional(),
  energy: z8.string().nullable().optional(),
  isFlatrate: z8.boolean().nullable().optional(),
  billing_alternativeAddress: z8.boolean().nullable().optional(),
  relocationPossible: z8.boolean().nullable().optional(),
  relocationContractId: z8.unknown().nullable().optional(),
  relatedContractType: z8.unknown().nullable().optional(),
  relatedContractId: z8.unknown().nullable().optional(),
  relocationAt: z8.unknown().nullable().optional(),
  business: z8.boolean().nullable().optional(),
  company: z8.unknown().nullable().optional(),
  countryId: z8.string().nullable().optional(),
  // Basic address fields
  ...AddressFieldsSchema.shape,
  floor: z8.unknown().nullable().optional(),
  phone: z8.string().nullable().optional(),
  fax: z8.string().nullable().optional(),
  email: z8.string().nullable().optional(),
  // Cancellation fields
  cancelledBy: z8.string().nullable().optional(),
  cancellationReason: z8.string().nullable().optional(),
  cancellationTriggeredDate: z8.string().nullable().optional(),
  // Billing address fields
  billing_salutation: SalutationSchema,
  billing_title: z8.string().nullable().optional(),
  billing_firstname: z8.string().nullable().optional(),
  billing_surname: z8.string().nullable().optional(),
  billing_careOfRecipient: z8.string().nullable().optional(),
  billing_company: z8.string().nullable().optional(),
  billing_zip: z8.string().nullable().optional(),
  billing_city: z8.string().nullable().optional(),
  billing_street: z8.string().nullable().optional(),
  billing_houseNumber: z8.string().nullable().optional(),
  billing_phone: z8.string().nullable().optional(),
  billing_email: z8.string().nullable().optional(),
  billing_country: z8.string().nullable().optional(),
  billing_countryAlpha2: z8.string().nullable().optional(),
  // Counter and meter fields
  counterNumber: z8.string().nullable().optional(),
  counterType: z8.string().nullable().optional(),
  counterTypeName: z8.string().nullable().optional(),
  meterPointIdentifier: z8.unknown().nullable().optional(),
  marketLocation: z8.string().nullable().optional(),
  meterLocation: z8.string().nullable().optional(),
  complexSystem: z8.boolean().nullable().optional(),
  // Customer information
  customerId: z8.string().nullable().optional(),
  externalCustomerNumber: z8.unknown().nullable().optional(),
  customerCommunicationType: z8.string().nullable().optional(),
  salutation: SalutationSchema,
  firstname: z8.string().nullable().optional(),
  surname: z8.string().nullable().optional(),
  dateOfBirth: z8.unknown().nullable().optional(),
  // Contract status
  status: z8.string().nullable().optional(),
  statusCode: z8.string().nullable().optional(),
  statusCodeTitle: z8.string().nullable().optional(),
  revocation: z8.boolean().nullable().optional(),
  dateOfRevocation: z8.unknown().nullable().optional(),
  lastRevocationDate: z8.string().nullable().optional(),
  // Contract dates
  startDate: z8.string().nullable().optional(),
  desiredStartDate: z8.string().nullable().optional(),
  simulationTurnus: z8.number().nullable().optional(),
  nextInvoiceInformationDate: z8.string().nullable().optional(),
  endDate: z8.string().nullable().optional(),
  desiredEndDate: z8.string().nullable().optional(),
  orderId: z8.string().nullable().optional(),
  nextPossibleCancellationByLfa: z8.unknown().nullable().optional(),
  customerSpecification: z8.string().nullable().optional(),
  signatureDate: z8.string().nullable().optional(),
  cancelledAt: z8.unknown().nullable().optional(),
  filingDateCancellation: z8.unknown().nullable().optional(),
  cancellationTechKey: z8.string().nullable().optional(),
  // Network delivery
  netDeliveryStartConfirmed: z8.string().nullable().optional(),
  netDeliveryEndConfirmed: z8.string().nullable().optional(),
  // Usage information
  usage: z8.string().nullable().optional(),
  usageNet: z8.string().nullable().optional(),
  usagePrevious: z8.string().nullable().optional(),
  brandId: z8.string().nullable().optional(),
  // Banking information
  directDebit: z8.boolean().nullable().optional(),
  direction: z8.string().nullable().optional(),
  activeFrom: z8.string().nullable().optional(),
  activeUntil: z8.unknown().nullable().optional(),
  iban: z8.string().nullable().optional(),
  bic: z8.string().nullable().optional(),
  bank: z8.string().nullable().optional(),
  paymentProvider: z8.string().nullable().optional(),
  paymentProviderData: z8.array(z8.unknown()).optional(),
  replacedBankId: z8.number().nullable().optional(),
  bankAccountNumber: z8.string().nullable().optional(),
  bankCode: z8.string().nullable().optional(),
  alternativeAccountHolder: z8.string().nullable().optional(),
  sepaMandate: z8.string().nullable().optional(),
  futureBankingData: z8.array(z8.unknown()),
  // Provider information
  previousProvider: z8.string().nullable().optional(),
  customerNumber: z8.string().nullable().optional(),
  cancellationPreviousProviderSent: z8.string().nullable().optional(),
  cancellationPreviousProviderConfirmed: z8.string().nullable().optional(),
  netDeliveryStartSent: z8.string().nullable().optional(),
  // Contract terms
  minimumRuntime: z8.string().nullable().optional(),
  minimumRuntimeUnit: z8.string().nullable().optional(),
  extensionTime: z8.string().nullable().optional(),
  extensionTimeUnit: z8.string().nullable().optional(),
  cancellationPeriod: z8.string().nullable().optional(),
  cancellationPeriodUnit: z8.string().nullable().optional(),
  nextCancellationDate: z8.string().nullable().optional(),
  latestCancelationByCustomer: z8.string().nullable().optional(),
  // External identifiers
  externalId: z8.string().nullable().optional(),
  externalOrderId: z8.unknown().nullable().optional(),
  extendedData: ExtendedDataWithVartSchema,
  // Invoice information
  desiredInvoiceDate: z8.string().nullable().optional(),
  invoicePeriodStartDate: z8.string().nullable().optional(),
  invoicePeriodEndDate: z8.string().nullable().optional(),
  // Dunning information
  dunningLocked: z8.boolean().nullable().optional(),
  dunningLockedUntil: z8.unknown().nullable().optional(),
  dunningLockReason: z8.string().nullable().optional(),
  paymentLockedOut: z8.boolean().nullable().optional(),
  paymentLockedOutUntil: z8.string().nullable().optional(),
  paymentLockedIn: z8.boolean().nullable().optional(),
  paymentLockedInUntil: z8.string().nullable().optional(),
  // Tax information
  taxRate: z8.unknown().nullable().optional(),
  taxRateReason: z8.unknown().nullable().optional(),
  taxRatePermission: z8.unknown().nullable().optional(),
  energyTaxExemptionRate: z8.unknown().nullable().optional(),
  energyTaxExemptionReason: z8.unknown().nullable().optional(),
  energyTaxExemptionPermission: z8.unknown().nullable().optional(),
  legalCase: z8.unknown().nullable().optional(),
  desiredInvoiceReason: z8.unknown().nullable().optional(),
  dunningProcedure: z8.string().nullable().optional(),
  meterPricing: z8.string().nullable().optional(),
  additionalValues: z8.array(z8.unknown()),
  // Optional banking data collections
  InOutActiveBankingData: BankingDataInOutSchema.nullable().optional(),
  InOutFutureBankingData: BankingDataInOutSchema.nullable().optional()
});

// src/schemas/PowercloudEvent/ContractChangeCustomerDataBankData.ts
import { z as z9 } from "zod";
var ContractChangeCustomerDataBankDataSchema = z9.object({
  contract_change_customer_data_id: z9.number().nullable().optional(),
  contract_change_customer_data_active_from: z9.string().nullable().optional(),
  contract_change_customer_data_active_until: z9.string().nullable().optional(),
  contract_change_customer_data_sepa_mandate: z9.string().nullable().optional(),
  contract_change_customer_data_iban: z9.string().nullable().optional(),
  contract_change_customer_data_bic: z9.string().nullable().optional(),
  contract_change_customer_data_bank: z9.string().nullable().optional(),
  contract_change_customer_data_replaced_bank_id: z9.number().nullable().optional(),
  contract_change_customer_data_account_holder: z9.string().nullable().optional(),
  contract_change_customer_data_directdebit: z9.boolean().nullable().optional(),
  contract_change_customer_data_dunning_locked: z9.boolean().nullable().optional(),
  contract_change_customer_data_dunning_locked_until: z9.string().nullable().optional(),
  contract_change_customer_data_manual_billing_blocked: z9.boolean().nullable().optional(),
  contract_change_customer_data_direction: z9.string().nullable().optional(),
  contract_change_customer_data_payment_provider_key: z9.string().nullable().optional()
});

// src/schemas/PowercloudEvent/ContractCounter.ts
import { z as z10 } from "zod";
var RegisterSchema = z10.looseObject({
  activeFrom: z10.string().nullable().optional(),
  activeUntil: z10.string().nullable().optional(),
  obis: z10.string().nullable().optional(),
  description: z10.string().nullable().optional(),
  digits: z10.string().nullable().optional(),
  precision: z10.string().nullable().optional(),
  llc: z10.string().nullable().optional(),
  billingrelevant: z10.boolean().nullable().optional()
});
var ContractCounterSchema = z10.looseObject({
  createdAt: z10.string().nullable().optional(),
  createdByAgent: z10.string().nullable().optional(),
  id: z10.string().nullable().optional(),
  counterNumber: z10.string().nullable().optional(),
  counterSize: z10.unknown().nullable().optional(),
  activeFrom: z10.string().nullable().optional(),
  activeUntil: z10.string().nullable().optional(),
  type: z10.string().nullable().optional(),
  typeName: z10.string().nullable().optional(),
  energyDirection: z10.string().nullable().optional(),
  dataAcquisition: z10.string().nullable().optional(),
  tariffCount: z10.string().nullable().optional(),
  exchangeType: z10.unknown().nullable().optional(),
  exchangeValue: z10.string().nullable().optional(),
  registers: z10.array(RegisterSchema).nullable().optional(),
  additionalValues: z10.array(z10.unknown())
});

// src/schemas/PowercloudEvent/ContractDunnedReceivable.ts
import { z as z11 } from "zod";
var ContractDunnedReceivableSchema = z11.looseObject({
  id: z11.number().nullable().optional(),
  bookingNumber: z11.number().nullable().optional(),
  payableAt: z11.string().nullable().optional(),
  type: z11.string().nullable().optional(),
  grossAmount: z11.number().nullable().optional(),
  settledAmount: z11.number().nullable().optional(),
  tax: z11.union([z11.number(), z11.string()]),
  notice: z11.string().nullable().optional(),
  contractId: z11.number().nullable().optional(),
  level: z11.number().nullable().optional(),
  levelName: z11.string().nullable().optional(),
  settlementDeadline: z11.string().nullable().optional(),
  unsettledAmount: z11.number().nullable().optional(),
  chargedDepositForMonth: z11.string().nullable().optional(),
  dunnable: z11.boolean().nullable().optional()
});

// src/schemas/PowercloudEvent/ContractDunningAdditionalReceivable.ts
import { z as z12 } from "zod";
var ContractDunningAdditionalReceivableSchema = z12.looseObject({
  bookingNumber: z12.number().nullable().optional(),
  payableAt: z12.string().nullable().optional(),
  chargedDepositForMonth: z12.string().nullable().optional(),
  type: z12.string().nullable().optional(),
  grossAmount: z12.number().nullable().optional(),
  settledAmount: z12.number().nullable().optional(),
  tax: z12.union([z12.number(), z12.string()]),
  dunnable: z12.boolean().nullable().optional(),
  unsettledAmount: z12.number().nullable().optional(),
  id: z12.number().nullable().optional(),
  netAmount: z12.number().nullable().optional(),
  taxAmount: z12.number().nullable().optional(),
  notice: z12.string().nullable().optional()
});

// src/schemas/PowercloudEvent/ContractProduct.ts
import { z as z13 } from "zod";
var ContractProductSchema = z13.looseObject({
  contractProductId: z13.string().nullable().optional(),
  createdAt: z13.string().nullable().optional(),
  productName: z13.string().nullable().optional(),
  productCode: z13.string().nullable().optional(),
  productVersion: z13.string().nullable().optional(),
  productType: z13.string().nullable().optional(),
  excludedTaxesAndLevies: z13.array(z13.unknown()).nullable().optional(),
  flexibleAddons: z13.array(z13.unknown()).nullable().optional(),
  addOnOf: z13.unknown().nullable().optional(),
  mandatoryAddOn: z13.string().nullable().optional(),
  activeFrom: z13.string().nullable().optional(),
  activeUntil: z13.string().nullable().optional(),
  contractProductStatus: z13.string().nullable().optional(),
  quantity: z13.string().nullable().optional(),
  externalOrderNumber: z13.unknown().nullable().optional(),
  waitForConfirmationUntil: z13.unknown().nullable().optional(),
  confirmedAt: z13.unknown().nullable().optional(),
  overwriteUseUsageSplitForElectricity: z13.boolean().nullable().optional(),
  additionalTerminationRightBeforeDelivery: z13.boolean().nullable().optional()
});

// src/schemas/PowercloudEvent/ContractTariffChangeNextProduct.ts
import { z as z14 } from "zod";
var ContractTariffChangeNextProductSchema = z14.looseObject({
  contractProductId: z14.string().nullable().optional(),
  createdAt: z14.string().nullable().optional(),
  productName: z14.string().nullable().optional(),
  productCode: z14.string().nullable().optional(),
  productVersion: z14.string().nullable().optional(),
  productType: z14.string().nullable().optional(),
  excludedTaxesAndLevies: z14.array(z14.any()).nullable().optional(),
  flexibleAddons: z14.array(z14.any()).nullable().optional(),
  addOnOf: z14.string().nullable().optional(),
  mandatoryAddOn: z14.string().nullable().optional(),
  activeFrom: z14.string().nullable().optional(),
  activeUntil: z14.string().nullable().optional(),
  contractProductStatus: z14.string().nullable().optional(),
  quantity: z14.string().nullable().optional(),
  externalOrderNumber: z14.string().nullable().optional(),
  waitForConfirmationUntil: z14.string().nullable().optional(),
  confirmedAt: z14.string().nullable().optional(),
  overwriteUseUsageSplitForElectricity: z14.boolean().nullable().optional(),
  additionalTerminationRightBeforeDelivery: z14.boolean().nullable().optional()
});

// src/schemas/PowercloudEvent/ContractTariffRevoked.ts
import { z as z15 } from "zod";
var ContractTariffRevokedSchema = z15.looseObject({
  product: z15.string().nullable().optional(),
  productCode: z15.string().nullable().optional(),
  id: z15.string().nullable().optional()
});

// src/schemas/PowercloudEvent/ContractTariffRevokeDate.ts
import { z as z16 } from "zod";
var ContractTariffRevokeDateSchema = z16.looseObject({
  date: z16.string().nullable().optional(),
  timezone: z16.string().nullable().optional(),
  timezone_type: z16.number().nullable().optional()
});

// src/schemas/PowercloudEvent/HighestDunningLevel.ts
import { z as z17 } from "zod";
var HighestDunningLevelSchema = z17.looseObject({
  level: z17.number().nullable().optional(),
  levelName: z17.string().nullable().optional()
});

// src/schemas/PowercloudEvent/InstallmentPlan.ts
import { z as z18 } from "zod";
var AccountReceivableDataSchema = z18.looseObject({
  id: z18.string().nullable().optional(),
  bookingNumber: z18.string().nullable().optional(),
  createdAt: z18.string().nullable().optional(),
  type: z18.string().nullable().optional(),
  energy: z18.string().nullable().optional(),
  payableAt: z18.string().nullable().optional(),
  grossAmount: z18.number().nullable().optional(),
  settledAmount: z18.number().nullable().optional(),
  tax: z18.string().nullable().optional(),
  notice: z18.string().nullable().optional(),
  dunnable: z18.boolean().nullable().optional(),
  dunningLocked: z18.boolean().nullable().optional(),
  dunningLockedUntil: z18.any().nullable().optional(),
  locks: z18.array(z18.unknown()).nullable().optional(),
  deletedLocks: z18.array(z18.unknown()).nullable().optional(),
  nextDunningAt: z18.any().nullable().optional(),
  invoiceId: z18.string().nullable().optional(),
  unsettledAmount: z18.number().nullable().optional()
});
var AccountReceivableSchema = z18.looseObject({
  id: z18.string().nullable().optional(),
  data: AccountReceivableDataSchema,
  additionalData: z18.array(z18.unknown()).nullable().optional()
});
var ReceivableDataSchema = z18.looseObject({
  id: z18.number().nullable().optional(),
  clientId: z18.number().nullable().optional(),
  accountId: z18.number().nullable().optional(),
  receivableId: z18.string().nullable().optional(),
  initialUnsettledAmount: z18.string().nullable().optional(),
  account_receivable: AccountReceivableSchema
});
var ReceivableSchema = z18.looseObject({
  id: z18.string().nullable().optional(),
  data: ReceivableDataSchema,
  additionalData: z18.array(z18.unknown()).nullable().optional()
});
var InstallmentDataSchema = z18.looseObject({
  id: z18.number().nullable().optional(),
  clientId: z18.number().nullable().optional(),
  accountId: z18.number().nullable().optional(),
  grossAmount: z18.string().nullable().optional(),
  settledAmount: z18.string().nullable().optional(),
  payableAt: z18.string().nullable().optional(),
  createdAt: z18.string().nullable().optional()
});
var InstallmentSchema = z18.looseObject({
  id: z18.string().nullable().optional(),
  data: InstallmentDataSchema,
  additionalData: z18.array(z18.unknown()).nullable().optional()
});
var ExcludedReceivableDataSchema = z18.looseObject({
  id: z18.string().nullable().optional(),
  bookingNumber: z18.union([z18.null(), z18.string()]),
  createdAt: z18.string().nullable().optional(),
  type: z18.string().nullable().optional(),
  energy: z18.string().nullable().optional(),
  payableAt: z18.string().nullable().optional(),
  grossAmount: z18.number().nullable().optional(),
  settledAmount: z18.number().nullable().optional(),
  tax: z18.string().nullable().optional(),
  notice: z18.string().nullable().optional(),
  dunnable: z18.boolean().nullable().optional(),
  dunningLocked: z18.boolean().nullable().optional(),
  dunningLockedUntil: z18.any().nullable().optional(),
  locks: z18.array(z18.unknown()).nullable().optional(),
  deletedLocks: z18.array(z18.unknown()).nullable().optional(),
  nextDunningAt: z18.any().nullable().optional(),
  invoiceId: z18.string().nullable().optional(),
  unsettledAmount: z18.number().nullable().optional()
});
var ExcludedReceivableSchema = z18.looseObject({
  id: z18.string().nullable().optional(),
  data: ExcludedReceivableDataSchema,
  additionalData: z18.array(z18.unknown()).nullable().optional()
});
var InstallmentPlanSchema = z18.looseObject({
  id: z18.number().nullable().optional(),
  clientId: z18.number().nullable().optional(),
  accountId: z18.number().nullable().optional(),
  isActive: z18.string().nullable().optional(),
  useDirectDebit: z18.string().nullable().optional(),
  createdAt: z18.string().nullable().optional(),
  templateId: z18.string().nullable().optional(),
  total_receivable_amount: z18.string().nullable().optional(),
  total_overdue_receivable_amount: z18.string().nullable().optional(),
  total_installment_amount: z18.string().nullable().optional(),
  total_settled_installment_amount: z18.string().nullable().optional(),
  total_unsettled_installment_amount: z18.string().nullable().optional(),
  excluded_receivables: z18.array(ExcludedReceivableSchema),
  installments: z18.array(InstallmentSchema),
  receivables: z18.array(ReceivableSchema)
});

// src/schemas/PowercloudEvent/MarketLocation.ts
import { z as z19 } from "zod";
var MarketLocationSchema = z19.looseObject({
  id: z19.string().nullable().optional(),
  clientId: z19.string().nullable().optional(),
  note: z19.string().nullable().optional(),
  identifier: z19.string().nullable().optional(),
  additionalValues: z19.array(z19.unknown()).nullable().optional()
});

// src/schemas/PowercloudEvent/MarketLocationNetworkCarrier.ts
import { z as z20 } from "zod";
var MarketLocationNetworkCarrierSchema = z20.looseObject({
  organization: z20.string().nullable().optional()
});

// src/schemas/PowercloudEvent/Order.ts
import { z as z21 } from "zod";
var OrderSchema = z21.looseObject({
  id: z21.string().nullable().optional(),
  createdAt: z21.string().nullable().optional(),
  orderedAt: z21.string().nullable().optional(),
  status: z21.string().nullable().optional(),
  revokedAt: z21.string().nullable().optional(),
  relevantStreet: z21.string().nullable().optional(),
  // Basic address fields
  ...AddressFieldsSchema.shape,
  business: z21.string().nullable().optional(),
  company: z21.string().nullable().optional(),
  customerId: z21.string().nullable().optional(),
  // Personal details
  salutation: SalutationSchema,
  firstname: z21.string().nullable().optional(),
  surname: z21.string().nullable().optional(),
  dateOfBirth: z21.string().nullable().optional(),
  pointOfDeliveryInBasicSupplyArea: z21.string().nullable().optional(),
  externalId: z21.unknown().nullable().optional(),
  // Contract relations
  relocationContractId: z21.unknown().nullable().optional(),
  relatedContractType: z21.unknown().nullable().optional(),
  relatedContractId: z21.unknown().nullable().optional(),
  // Phone contacts
  phoneMobileAreaCode: z21.string().nullable().optional(),
  phoneMobile: z21.string().nullable().optional(),
  phoneHomeAreaCode: z21.string().nullable().optional(),
  phoneHome: z21.string().nullable().optional(),
  phoneBusinessAreaCode: z21.string().nullable().optional(),
  phoneBusiness: z21.string().nullable().optional(),
  // Email contacts
  emailPrivate: z21.unknown().nullable().optional(),
  emailBusiness: z21.string().nullable().optional(),
  researchedCustomer: z21.string().nullable().optional(),
  energy: z21.string().nullable().optional(),
  // Billing address fields
  billing_alternativeAddress: z21.string().nullable().optional(),
  billing_company: z21.string().nullable().optional(),
  billing_salutation: SalutationSchema,
  billing_firstname: z21.string().nullable().optional(),
  billing_surname: z21.string().nullable().optional(),
  billing_careOfRecipient: z21.string().nullable().optional(),
  billing_zip: z21.string().nullable().optional(),
  billing_country: z21.string().nullable().optional(),
  billing_countryAlpha2: z21.string().nullable().optional(),
  billing_city: z21.string().nullable().optional(),
  billing_street: z21.string().nullable().optional(),
  billing_houseNumber: z21.string().nullable().optional(),
  billing_fax: z21.string().nullable().optional(),
  billing_phone: z21.string().nullable().optional(),
  billing_email: z21.string().nullable().optional(),
  relocationAddressTransfer: z21.string().nullable().optional(),
  // Banking details
  iban: z21.string().nullable().optional(),
  bic: z21.string().nullable().optional(),
  bank: z21.string().nullable().optional(),
  alternativeAccountHolder: z21.string().nullable().optional(),
  directDebit: z21.boolean().nullable().optional(),
  paymentProvider: z21.string().nullable().optional(),
  paymentProviderData: z21.array(z21.unknown()).nullable().optional(),
  // Campaign and sales
  campaign: z21.string().nullable().optional(),
  campaignId: z21.string().nullable().optional(),
  exportAt: z21.string().nullable().optional(),
  salesChannel: z21.string().nullable().optional(),
  inputChannel: z21.string().nullable().optional(),
  // Marketing preferences
  adsMail: z21.string().nullable().optional(),
  adsPhone: z21.string().nullable().optional(),
  adsPost: z21.string().nullable().optional(),
  // Provider information
  previousProvider: z21.string().nullable().optional(),
  previousProduct: z21.string().nullable().optional(),
  previousProviderCodeNumber: z21.string().nullable().optional(),
  previousProviderCodeNumberProvider: z21.string().nullable().optional(),
  netCodeNumber: z21.string().nullable().optional(),
  netCodeNumberProvider: z21.string().nullable().optional(),
  customerNumber: z21.string().nullable().optional(),
  customerSpecification: z21.string().nullable().optional(),
  // Dates
  relocationAt: z21.string().nullable().optional(),
  desiredDate: z21.string().nullable().optional(),
  terminatedAt: z21.unknown().nullable().optional(),
  basicSupplyAt: z21.unknown().nullable().optional(),
  // Product details
  provider: z21.string().nullable().optional(),
  providerId: z21.string().nullable().optional(),
  product: z21.string().nullable().optional(),
  productId: z21.string().nullable().optional(),
  productCode: z21.string().nullable().optional(),
  productEco: z21.string().nullable().optional(),
  variant: z21.string().nullable().optional(),
  productType: z21.string().nullable().optional(),
  priceKey: z21.string().nullable().optional(),
  counterNumber: z21.string().nullable().optional(),
  marketLocationIdentifier: z21.string().nullable().optional(),
  usageInclusive: z21.string().nullable().optional(),
  usage: z21.string().nullable().optional(),
  complexPrice: z21.boolean().nullable().optional(),
  complexPrices: z21.object({
    id: z21.string().nullable().optional(),
    data: z21.object({
      complexPrice: z21.array(
        z21.object({
          usageFrom: z21.number().nullable().optional(),
          usageUntil: z21.number().nullable().optional(),
          basePriceNetto: z21.string().nullable().optional(),
          basePriceBrutto: z21.string().nullable().optional(),
          basePriceTax: z21.string().nullable().optional(),
          basePriceTaxRate: z21.string().nullable().optional(),
          workingPrices: z21.array(
            z21.object({
              registerName: z21.string().nullable().optional(),
              workingPriceNetto: z21.string().nullable().optional(),
              workingPriceBrutto: z21.string().nullable().optional(),
              workingPriceTax: z21.string().nullable().optional(),
              workingPriceTaxRate: z21.string().nullable().optional()
            })
          ).nullable().optional()
        })
      ).nullable().optional(),
      meterPrices: z21.array(z21.unknown()).nullable().optional()
    }).nullable().optional(),
    additionalData: z21.array(z21.unknown()).nullable().optional()
  }).nullable().optional(),
  // Pricing details
  productWorkingPrice: z21.string().nullable().optional(),
  productBasePrice: z21.string().nullable().optional(),
  overConsumptionWorkingPrice: z21.string().nullable().optional(),
  productWorkingPriceNetto: z21.string().nullable().optional(),
  productBasePriceNetto: z21.string().nullable().optional(),
  productBonusNetto: z21.string().nullable().optional(),
  productInstantBonusNetto: z21.string().nullable().optional(),
  energyTax: z21.string().nullable().optional(),
  productWorkingPriceTax: z21.string().nullable().optional(),
  productBasePriceTax: z21.string().nullable().optional(),
  productBonusTax: z21.string().nullable().optional(),
  productInstantBonusTax: z21.string().nullable().optional(),
  productBonus: z21.string().nullable().optional(),
  productBonusPercent: z21.string().nullable().optional(),
  productInstantBonus: z21.string().nullable().optional(),
  // Contract terms
  fixedPriceType: z21.string().nullable().optional(),
  fixedPriceMonths: z21.string().nullable().optional(),
  fixedPriceDate: z21.unknown().nullable().optional(),
  cancellationPeriod: z21.string().nullable().optional(),
  cancellationPeriodUnit: z21.string().nullable().optional(),
  minimumRuntime: z21.string().nullable().optional(),
  minimumRuntimeUnit: z21.string().nullable().optional(),
  extensionTime: z21.string().nullable().optional(),
  extensionTimeUnit: z21.string().nullable().optional(),
  // Process identifiers
  ediProcessId: z21.unknown().nullable().optional(),
  vpCode: z21.unknown().nullable().optional(),
  uvpCode: z21.unknown().nullable().optional(),
  // Extended data and related
  extendedData: ExtendedDataWithVartSchema,
  createdBy: z21.string().nullable().optional(),
  signatureDate: z21.string().nullable().optional(),
  notifier: z21.unknown().nullable().optional(),
  waitForConfirmationUntil: z21.unknown().nullable().optional(),
  confirmedAt: z21.unknown().nullable().optional(),
  additionalValues: z21.array(z21.unknown()).nullable().optional(),
  flexbonus: z21.array(z21.unknown()).nullable().optional(),
  brand: BrandSchema.nullish()
});

// src/schemas/PowercloudEvent/ProductAddOn.ts
import { z as z22 } from "zod";
var ProductAddOnSchema = z22.looseObject({
  productCode: z22.string().nullable().optional(),
  productName: z22.string().nullable().optional(),
  commodityProductCode: z22.string().nullable().optional(),
  commodityProductName: z22.string().nullable().optional(),
  activeFrom: z22.string().nullable().optional(),
  activeUntil: z22.string().nullable().optional(),
  validFrom: z22.string().nullable().optional(),
  validUntil: z22.string().nullable().optional()
});

// src/schemas/PowercloudEvent/ProductVersion.ts
import { z as z23 } from "zod";
var ProductVersionBrandDataSchema = z23.looseObject({
  id: z23.string().nullable().optional(),
  name: z23.enum(["EWE", "WERDER STROM", "Friesensport", "Jouneo"]).nullable().optional(),
  isDeleted: z23.string().nullable().optional(),
  createdBy: z23.string().nullable().optional(),
  createdAt: z23.string().nullable().optional()
}).optional();
var ProductVersionBrandSchema = z23.looseObject({
  id: z23.string().nullable().optional(),
  data: ProductVersionBrandDataSchema,
  additionalData: z23.array(z23.unknown()).nullable().optional()
});
var ProductVersionSchema = z23.looseObject({
  productId: z23.string().nullable().optional(),
  version: z23.string().nullable().optional(),
  status: z23.string().nullable().optional(),
  supplyType: z23.string().nullable().optional(),
  consumptionType: z23.string().nullable().optional(),
  priceType: z23.string().nullable().optional(),
  business: z23.string().nullable().optional(),
  pricingType: z23.string().nullable().optional(),
  usageNtPercentage: z23.string().nullable().optional(),
  createdAt: z23.string().nullable().optional(),
  updatedAt: z23.string().nullable().optional(),
  releaseRequestedAt: z23.unknown().nullable().optional(),
  releasedAt: z23.string().nullable().optional(),
  deprecatedAt: z23.string().nullable().optional(),
  lockedAt: z23.unknown().nullable().optional(),
  name: z23.string().nullable().optional(),
  validFrom: z23.string().nullable().optional(),
  validUntil: z23.string().nullable().optional(),
  kind: z23.string().nullable().optional(),
  eco: z23.string().nullable().optional(),
  invoiceBase: z23.string().nullable().optional(),
  contractInvoiceCycle: z23.string().nullable().optional(),
  contractInvoiceCycleInterval: z23.string().nullable().optional(),
  contractInvoiceCycleIntervalType: z23.string().nullable().optional(),
  contractInitialDuration: z23.string().nullable().optional(),
  contractInitialDurationType: z23.string().nullable().optional(),
  contractExtensionTime: z23.string().nullable().optional(),
  contractExtensionTimeType: z23.string().nullable().optional(),
  contractCancellationPeriod: z23.string().nullable().optional(),
  contractCancellationPeriodType: z23.string().nullable().optional(),
  // ERP fields
  erpExternalId: z23.unknown().nullable().optional(),
  erpWeight: z23.unknown().nullable().optional(),
  erpStatisticGroup: z23.unknown().nullable().optional(),
  erpVolume: z23.unknown().nullable().optional(),
  erpVariantGroupCode: z23.unknown().nullable().optional(),
  erpProductLink: z23.unknown().nullable().optional(),
  erpManufacturer: z23.unknown().nullable().optional(),
  erpManufacturerNumber: z23.unknown().nullable().optional(),
  erpAccount: z23.unknown().nullable().optional(),
  erpAllowSplitAmount: z23.string().nullable().optional(),
  // CMS fields
  cmsAgb: z23.string().nullable().optional(),
  cmsProperties: z23.string().nullable().optional(),
  cmsDescriptionInternal: z23.string().nullable().optional(),
  cmsDescriptionExternal: z23.string().nullable().optional(),
  cmsFileId: z23.unknown().nullable().optional(),
  noteFreetext: z23.string().nullable().optional(),
  everyTimeCancellable: z23.string().nullable().optional(),
  relocationProhibited: z23.string().nullable().optional(),
  meterPricing: z23.string().nullable().optional(),
  brand: ProductVersionBrandSchema,
  additionalTerminationRightBeforeDelivery: z23.boolean().nullable().optional(),
  billingRuleTemplateId: z23.unknown().nullable().optional()
});

// src/schemas/PowercloudEvent/PowercloudEvent.ts
var OrderEventNamesSchema = z24.enum([
  "order_confirmed",
  "order_denial_blacklist",
  "order_denial_credit_check",
  "order_denial_duplicate",
  "order_revoked",
  "order_status_revoked",
  "order_status_cancelled",
  "order_status_check",
  "order_status_done",
  "order_status_open",
  "order_status_waiting"
]);
var ContractEventNamesSchema = z24.enum([
  "debitor_account_receivable_changed",
  "debitor_account_receivable_settled",
  "disconnection_announcement",
  "contract_legal_case_debt_collection_add",
  "disconnection_done",
  "contract_cancellation_var",
  "contract_denial_duration",
  "contract_dunning",
  "contract_dunlevel2_cancelled",
  "contract_request_customer_reading",
  "contract_revoke_confirmation",
  "contract_revoke_rejected",
  "contract_tariff_change_confirmed",
  "contract_termination_confirmed",
  "contract_welcome_letter",
  "contract_welcome_letter_deposit_changed",
  "contract_status_active",
  "contract_status_cancellation_previous",
  "contract_dunning_counter_blocking",
  "user_interaction_required",
  "contract_smart_metering_system_based_on_values_accounting_started",
  "contract_welcome_letter_non_commodity",
  "contract_status_cancelled",
  "contract_status_delivery_net",
  "contract_status_expired",
  "contract_status_open",
  "contract_status_terminated",
  "contract_status_waiting",
  "contract_reading_invoice_correction_needed",
  "contract_reading_saved",
  "contract_invoice_created",
  "customer_data_changed",
  "contract_information_required",
  "contract_reading_plausible",
  "contract_tariff_changed_price_adjustment",
  "contract_reading_unplausible",
  "contract_tariff_change_revoked",
  "contract_deposit_changed",
  "contract_change_customer_data",
  "contract_tariff_change_revoke_rejected",
  "contract_cancellation_confirmed",
  "contract_products_created",
  "contract_add_on_selected",
  "contract_add_on_cancelled",
  "contract_dunning_cancelled",
  "contract_credit_rebooked",
  "contract_installment_plan_activated",
  "contract_installment_plan_deleted",
  "contract_installment_plan_ended",
  "contract_product_change_confirmed",
  "account_collection_created",
  "account_collection_closed",
  "contract_customer_research_successful",
  "contract_invoice_desired_date_created",
  "contract_flex_bonus_added",
  "contract_change_customer_bank_data",
  "contract_extended_data_saved",
  "contract_invoice_created_non_commodity",
  "contract_product_cancelled"
]);
var InvoiceEventNamesSchema = z24.enum([
  "invoice_created_electricity",
  "invoice_created_electricity_simulation",
  "invoice_created_gas",
  "invoice_created_gas_simulation",
  "invoice_cancelled",
  "invoice_created_non_commodity",
  "invoice_created_non_commodity_simulation"
]);
var AllEventNamesSchema = z24.union([
  OrderEventNamesSchema,
  ContractEventNamesSchema,
  InvoiceEventNamesSchema
]);
var ClientSchema = z24.looseObject({
  creditorId: z24.string().nullable().optional()
});
var ContractDepositSchema = z24.looseObject({
  activeFrom: z24.string().nullable().optional(),
  activeUntil: z24.string().nullable().optional(),
  grossAmount: z24.number().nullable().optional(),
  alternativeDayOfMonth: z24.string().nullable().optional(),
  netAmount: z24.number().nullable().optional(),
  taxRate: z24.number().nullable().optional(),
  taxAmount: z24.number().nullable().optional(),
  nextExecution: z24.object({
    useAt: z24.string().nullable().optional()
  }).nullable().optional()
});
var BaseEventContentSchema = z24.looseObject({
  version: z24.number().nullable().optional(),
  customer: CustomerSchema.nullable().optional(),
  client: ClientSchema.nullable().optional()
});
var OrderEventContentSchema = BaseEventContentSchema.extend({
  product_version: ProductVersionSchema.nullable().optional(),
  order: OrderSchema.nullable().optional()
});
var ContractDisconnectionFeeSchema = z24.coerce.string().nullable().optional();
var ContractEventContentSchema = BaseEventContentSchema.extend({
  product_version: ProductVersionSchema.nullable().optional(),
  contract: ContractSchema.nullable().optional(),
  action: ActionSchema.nullable().optional(),
  market_location: MarketLocationSchema.optional(),
  market_location_network_carrier: MarketLocationNetworkCarrierSchema.nullable().optional(),
  order: OrderSchema.optional(),
  contract_counter: ContractCounterSchema.nullable().optional(),
  contract_relocation_title: z24.string().nullable().optional(),
  installmentPlan: InstallmentPlanSchema.nullable().optional(),
  contract_product: ContractProductSchema.nullable().optional(),
  contract_deposit_change_process: z24.string().nullable().optional(),
  contract_next_deposit: ContractDepositSchema.nullable().optional(),
  contract_total_unpaid: z24.number().nullable().optional(),
  contract_total_dunned_unpaid: z24.number().nullable().optional(),
  contract_cancellation_title: z24.string().nullable().optional(),
  contract_cancellation_var_reason: z24.string().nullable().optional(),
  contract_reading_request_reason: z24.string().nullable().optional(),
  cancellation_triggered_through: z24.string().nullable().optional(),
  contract_tariff_revoke_date: z24.union([ContractTariffRevokeDateSchema, z24.string()]).nullable().optional(),
  contract_tariff_revoked: ContractTariffRevokedSchema.nullable().optional(),
  contract_tariff_change_next_product: ContractTariffChangeNextProductSchema.nullable().optional(),
  cancelDate: z24.string().nullable().optional(),
  cancellationType: z24.string().nullable().optional(),
  revoking_date: z24.string().nullable().optional(),
  contract_dunning_additional_receivables: z24.array(ContractDunningAdditionalReceivableSchema).nullable().optional(),
  contract_dunned_receivables: z24.array(ContractDunnedReceivableSchema).nullable().optional(),
  contract_installment_plan_end_reason: z24.string().nullable().optional(),
  contract_changed_installment_plan: InstallmentPlanSchema.nullable().optional(),
  disconnection_fee: ContractDisconnectionFeeSchema,
  notificationType: z24.string().nullable().optional(),
  contract_dunnable_amount: z24.number().nullable().optional(),
  highest_dunning_level: HighestDunningLevelSchema.nullable().optional(),
  additional_fee_amount: z24.number().nullable().optional(),
  settlement_deadline: z24.string().nullable().optional(),
  // Additional fields from test data
  contract_reading_request_days: z24.string().nullable().optional(),
  contract_invoice_date: z24.string().nullable().optional(),
  contract_days_before_estimation: z24.string().nullable().optional(),
  contract_read_at_before_invoice_date: z24.string().nullable().optional(),
  contract_deposit: ContractDepositSchema.nullable().optional(),
  contract_change_customer_data_date: z24.string().nullable().optional(),
  contract_change_customer_data_reason: z24.string().nullable().optional(),
  contract_change_customer_data_contract_banking_data_direction: z24.string().nullable().optional(),
  contract_change_customer_data_by: z24.string().nullable().optional(),
  contract_change_customer_data_relevant_for_communication: z24.boolean().nullable().optional(),
  contract_change_customer_data_old_bank_data: ContractChangeCustomerDataBankDataSchema.nullable().optional(),
  contract_change_customer_data_new_bank_data: ContractChangeCustomerDataBankDataSchema.nullable().optional(),
  contract_denial_duration_date: z24.string().nullable().optional(),
  account_payment: AccountPaymentSchema.nullable().optional(),
  account_settled_receivable: AccountSettledReceivableSchema.nullable().optional(),
  product_addOns: z24.array(ProductAddOnSchema).nullable().optional()
});
var InvoiceEventContentSchema = BaseEventContentSchema.extend({
  contracts: z24.array(
    z24.looseObject({
      contract: ContractSchema.nullable().optional(),
      contract_counter: ContractCounterSchema.nullable().optional(),
      market_location: MarketLocationSchema.optional(),
      product_version: ProductVersionSchema.nullable().optional(),
      order: OrderSchema.nullable().optional()
    })
  ).optional()
});
var PowercloudEventBaseSchema = z24.looseObject({
  EventId: z24.string(),
  EventName: z24.string(),
  Environment: z24.string().nullable().optional(),
  TenantId: z24.string().nullable().optional(),
  CreatedAt: z24.string().nullable().optional(),
  CreatedFrom: z24.string().nullable().optional(),
  Version: z24.number().nullable().optional(),
  EventInstance: z24.string().nullable().optional()
});
var PowercloudEventSchema = z24.discriminatedUnion("EventName", [
  // Order events
  z24.looseObject({
    ...PowercloudEventBaseSchema.shape,
    EventName: OrderEventNamesSchema,
    Content: OrderEventContentSchema
  }),
  // Contract events
  z24.looseObject({
    ...PowercloudEventBaseSchema.shape,
    EventName: ContractEventNamesSchema,
    Content: ContractEventContentSchema
  }),
  // Invoice events
  z24.looseObject({
    ...PowercloudEventBaseSchema.shape,
    EventName: InvoiceEventNamesSchema,
    Content: InvoiceEventContentSchema
  })
]);
var PowercloudOrderEventSchema = z24.looseObject({
  ...PowercloudEventBaseSchema.shape,
  EventName: OrderEventNamesSchema,
  Content: OrderEventContentSchema
});
var PowercloudContractEventSchema = z24.looseObject({
  ...PowercloudEventBaseSchema.shape,
  EventName: ContractEventNamesSchema,
  Content: ContractEventContentSchema
});
var PowercloudInvoiceEventSchema = z24.looseObject({
  ...PowercloudEventBaseSchema.shape,
  EventName: InvoiceEventNamesSchema,
  Content: InvoiceEventContentSchema
});

// src/examples/contract/contract-request-customer-reading-1.json
var contract_request_customer_reading_1_default = {
  EventName: "contract_request_customer_reading",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  Content: {
    version: 5,
    contract: {
      id: "1000820476",
      accountId: "722939",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "49696",
      city: "Molbergen",
      street: "XXX",
      houseNumber: "3 a",
      floor: null,
      phone: "XXX / XXX",
      fax: "",
      email: "XXX",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      billing_salutation: "2",
      billing_title: "",
      billing_firstname: "Annekatrin",
      billing_surname: "XXX",
      billing_careOfRecipient: "",
      billing_company: "",
      billing_zip: "49696",
      billing_city: "Molbergen",
      billing_street: "XXX",
      billing_houseNumber: "3 a",
      billing_phone: "XXX / XXX",
      billing_email: "XXX",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "XXX",
      counterType: "EHZ",
      counterTypeName: "Elektronischer Haushaltsz\xE4hler",
      meterPointIdentifier: null,
      marketLocation: "50363870690",
      meterLocation: "DE0004964969600000000000011918966",
      complexSystem: false,
      customerId: "20193333",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "2",
      firstname: "Annekatrin",
      surname: "XXX",
      dateOfBirth: null,
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      dateOfRevocation: null,
      lastRevocationDate: "2021-08-12",
      startDate: "2021-08-13",
      desiredStartDate: "2021-08-13",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2023-02-12",
      endDate: null,
      desiredEndDate: null,
      orderId: "741706",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "earliest_possible_date",
      signatureDate: "2021-07-27",
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      netDeliveryStartConfirmed: "2021-07-29 04:19:00",
      netDeliveryEndConfirmed: null,
      usage: "2141",
      usageNet: "2231",
      usagePrevious: "1986",
      brandId: "1",
      directDebit: true,
      direction: "inout",
      activeFrom: "2021-07-27",
      activeUntil: null,
      iban: "XXX",
      bic: "OLBODEH2XXX",
      bank: "OLDENBURGISCHE LANDESBANK AG",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "3009127600",
      bankCode: "28020050",
      alternativeAccountHolder: "Christian G\xF6thert",
      sepaMandate: "EWE-20193333-1000820476-1",
      futureBankingData: [],
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: "79354053",
      cancellationPreviousProviderSent: "2021-07-27 13:07:49",
      cancellationPreviousProviderConfirmed: "2021-08-12 00:00:00",
      netDeliveryStartSent: "2021-07-28 17:29:37",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      nextCancellationDate: "2024-08-12",
      latestCancelationByCustomer: "2024-07-12",
      externalId: "5c28a118-a0e9-45d9-a1a1-4a8676a5c726",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "5"
          },
          MATARIFINFO: {
            technicalKey: "MATARIFINFO",
            createdAt: "2021-06-07 16:37:56",
            name: "Mitarbeiter Infos",
            position: "9"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2021-07-27 13:07:48",
              position: "2",
              fieldValueId: "1514617"
            }
          ],
          MATARIFINFO: [
            {
              name: "Gesellschaft",
              technicalKey: "GESELLSCHAFT",
              type: "text",
              value: "EWE",
              createdAt: "2021-07-27 13:07:48",
              position: "2",
              fieldValueId: "1514618"
            },
            {
              name: "AzureObjectID",
              technicalKey: "AZUREOBJECTID",
              type: "text",
              value: "e48b9821-564d-47ad-8cc0-086630db2bf5",
              createdAt: "2021-07-27 13:07:48",
              position: "3",
              fieldValueId: "1514619"
            }
          ]
        }
      },
      desiredInvoiceDate: "2023-08-12",
      invoicePeriodStartDate: "2022-08-13",
      invoicePeriodEndDate: "2023-08-12",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "CAIGVV",
      meterPricing: "included",
      additionalValues: []
    },
    customer: {
      authorizedAt: null,
      createdAt: "2021-01-29 13:10:16",
      zip: "49696",
      city: "Molbergen",
      street: "XXX",
      houseNumber: "3 a",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: "",
      countryId: "48",
      customerId: "20193333",
      status: "active",
      externalId: null,
      salutation: "2",
      firstname: "Annekatrin",
      title: null,
      surname: "XXX",
      dateOfBirth: null,
      availableSentNotification: "1",
      authUserName: "EFFF9C49-9C60-44AC-AB7D-21E8E22B7EDC",
      authEnabled: "1",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: "XXX",
      phoneHome: "XXX",
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: "XXX",
      emailBusiness: "",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "4"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2022-07-29 10:02:01",
              position: "2",
              fieldValueId: "4546964"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    contract_reading_request_reason: "mscons_reading_regular",
    contract_reading_request_days: "15",
    contract_invoice_date: "2023-08-12",
    contract_days_before_estimation: "14",
    contract_read_at_before_invoice_date: "5",
    contract_counter: {
      createdAt: "2021-07-29 16:57:25",
      createdByAgent: "0",
      id: "599101",
      counterNumber: "XXX",
      counterSize: null,
      activeFrom: "2021-08-13 00:00:00",
      activeUntil: null,
      type: "EHZ",
      typeName: "Elektronischer Haushaltsz\xE4hler",
      energyDirection: "ZRZ",
      dataAcquisition: "MMR",
      tariffCount: "ETZ",
      exchangeType: null,
      exchangeValue: "1",
      registers: [
        {
          activeFrom: "2021-08-13 00:00:00",
          activeUntil: null,
          obis: "1-1:1.8.0",
          description: null,
          digits: "6",
          precision: "0",
          llc: "Z59",
          billingrelevant: true
        }
      ],
      additionalValues: []
    },
    order: {
      id: "741706",
      createdAt: "2021-07-27 13:07:45",
      orderedAt: "2021-07-27 13:07:45",
      status: "done",
      revokedAt: null,
      relevantStreet: "0",
      zip: "49696",
      city: "Molbergen",
      street: "XXX",
      houseNumber: "3 a",
      business: "0",
      company: null,
      customerId: "20193333",
      salutation: "2",
      firstname: "Annekatrin",
      surname: "XXX",
      dateOfBirth: null,
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: "5c28a118-a0e9-45d9-a1a1-4a8676a5c726",
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: "XXX",
      phoneHome: "XXX",
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: "XXX",
      emailBusiness: null,
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "0",
      billing_company: null,
      billing_salutation: "2",
      billing_firstname: "Annekatrin",
      billing_surname: "XXX",
      billing_careOfRecipient: "",
      billing_zip: "49696",
      billing_country: "",
      billing_countryAlpha2: "",
      billing_city: "Molbergen",
      billing_street: "XXX",
      billing_houseNumber: "3 a",
      billing_fax: "",
      billing_phone: "XXX / XXX",
      billing_email: "XXX",
      relocationAddressTransfer: "",
      iban: "XXX",
      bic: "OLBODEH2XXX",
      bank: "OLDENBURGISCHE LANDESBANK AG",
      alternativeAccountHolder: "Christian G\xF6thert",
      directDebit: true,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "MITARBEITERTARIF",
      campaignId: "25",
      exportAt: "2021-07-27",
      salesChannel: "any",
      inputChannel: null,
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "",
      previousProviderCodeNumber: "9903324000006",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900496000005",
      netCodeNumberProvider: "bdew",
      customerNumber: "79354053",
      customerSpecification: "earliest_possible_date",
      relocationAt: null,
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: null,
      provider: "EWE VERTRIEB GmbH",
      providerId: "-7",
      product: "Strom Zuhause+ M (12 Monate)",
      productId: "383",
      productCode: "ST-ZH12MA-PC",
      productEco: "1",
      variant: "0",
      productType: "standard",
      priceKey: "ST-ZH12MA-PC",
      counterNumber: "XXX",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "2300",
      complexPrice: false,
      productWorkingPrice: "26.52",
      productBasePrice: "179.69",
      overConsumptionWorkingPrice: "0",
      productWorkingPriceNetto: "22.2857",
      productBasePriceNetto: "151",
      productBonusNetto: "36.97",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productWorkingPriceTax: "4.2343",
      productBasePriceTax: "28.69",
      productBonusTax: "7.03",
      productInstantBonusTax: "0",
      productBonus: "44.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "energy",
      fixedPriceMonths: "12",
      fixedPriceDate: null,
      cancellationPeriod: "28",
      cancellationPeriodUnit: "days",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "12",
      extensionTimeUnit: "months",
      ediProcessId: null,
      vpCode: "22222",
      uvpCode: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "5"
          },
          MATARIFINFO: {
            technicalKey: "MATARIFINFO",
            createdAt: "2021-06-07 16:37:56",
            name: "Mitarbeiter Infos",
            position: "9"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2021-07-27 13:07:47",
              position: "2",
              fieldValueId: "1514612"
            }
          ],
          MATARIFINFO: [
            {
              name: "Gesellschaft",
              technicalKey: "GESELLSCHAFT",
              type: "text",
              value: "EWE",
              createdAt: "2021-07-27 13:07:47",
              position: "2",
              fieldValueId: "1514613"
            },
            {
              name: "AzureObjectID",
              technicalKey: "AZUREOBJECTID",
              type: "text",
              value: "e48b9821-564d-47ad-8cc0-086630db2bf5",
              createdAt: "2021-07-27 13:07:47",
              position: "3",
              fieldValueId: "1514614"
            }
          ]
        }
      },
      createdBy: "12",
      signatureDate: "2021-07-27",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    market_location: {
      id: "569675",
      clientId: "3",
      identifier: "50363870690",
      additionalValues: [],
      note: null
    },
    contract_product: {
      contractProductId: "737021",
      createdAt: "2021-07-27 13:07:48",
      productName: "Strom Zuhause+ M (12 Monate)",
      productCode: "ST-ZH12MA-PC",
      productVersion: "3",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2021-08-13",
      activeUntil: "2023-08-12",
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    product_version: {
      productId: "94",
      version: "3",
      status: "deprecated",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "private",
      pricingType: "fixed_pricing",
      usageNtPercentage: "40",
      createdAt: "2021-06-22 10:21:10",
      updatedAt: "2021-06-22 10:24:19",
      releaseRequestedAt: null,
      releasedAt: "2021-06-22 10:24:19",
      deprecatedAt: "2021-08-06 12:20:01",
      lockedAt: null,
      name: "Strom Zuhause+ M (12 Monate)",
      validFrom: "2021-06-15",
      validUntil: "9999-12-31",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "12",
      contractExtensionTimeType: "months",
      contractCancellationPeriod: "28",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-10.json
var contract_request_customer_reading_10_default = {
  EventId: "438609527",
  EventName: "contract_installment_plan_ended",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 16,
    contract: {
      id: "1000101549",
      accountId: "2444",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: true,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: "Firma Anonym",
      countryId: "DE",
      zip: "47447",
      city: "Moers",
      street: "Feuerbachstr.",
      houseNumber: "1",
      floor: null,
      phone: "01234 / 1234578",
      fax: "",
      email: "test.anonym@ewe.de",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "2",
      billing_title: "",
      billing_firstname: "Ingrid",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_company: "Firma Anonym",
      billing_zip: "47447",
      billing_city: "Moers",
      billing_street: "Feuerbachstr.",
      billing_houseNumber: "1",
      billing_phone: "01234 / 12345678",
      billing_fax: "",
      billing_email: "test.anonym@ewe.de",
      billing_country: "",
      billing_countryAlpha2: "",
      counterNumber: "1APA0198890511",
      counterType: "MME",
      counterTypeName: "moderne Messeinrichtung",
      invoice_email: "test.anonym@ewe.de",
      invoice_phone: "01234 / 12345678",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50502013936",
      meterLocation: "DE0010384744700000000000000039064",
      complexSystem: false,
      customerId: "20001639",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "2",
      firstname: "Ingrid",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2019-02-19",
      dateOfRevocation: null,
      startDate: "2019-04-01",
      desiredStartDate: "2019-04-01",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-09-30",
      endDate: null,
      desiredEndDate: null,
      orderId: "1660",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "desired_date",
      signatureDate: "2019-02-01",
      netDeliveryStartConfirmed: "2019-02-05 23:15:09",
      netDeliveryEndConfirmed: null,
      usage: "3146",
      usageNet: "3191",
      usagePrevious: null,
      brandId: "1",
      directDebit: true,
      direction: "inout",
      activeFrom: "2019-02-04",
      activeUntil: null,
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0000202051",
      bankCode: "12030000",
      alternativeAccountHolder: "Test Test",
      sepaMandate: "EWE-20001639-1000101549-1",
      futureBankingData: [
        {
          activeFrom: "2019-02-04",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "inout",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-20001639-1000101549-1"
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            id: 1392,
            activeFrom: "2019-02-04",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20001639-1000101549-1"
          }
        ],
        out: [
          {
            id: 1392,
            activeFrom: "2019-02-04",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20001639-1000101549-1"
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "SWK ENERGIE GmbH",
      customerNumber: "",
      cancellationPreviousProviderSent: "2019-02-04 14:18:59",
      cancellationPreviousProviderConfirmed: "2019-03-31 00:00:00",
      netDeliveryStartSent: "2019-02-04 15:45:16",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "12",
      extensionTimeUnit: "months",
      cancellationPeriod: "28",
      cancellationPeriodUnit: "days",
      nextCancellationDate: "2026-03-31",
      latestCancelationByCustomer: "2026-03-03",
      externalId: "24245501",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "6"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2020-09-11 12:00:00",
              position: "2",
              fieldValueId: "67702"
            }
          ]
        }
      },
      desiredInvoiceDate: "2026-03-31",
      invoicePeriodStartDate: "2025-04-01",
      invoicePeriodEndDate: "2026-03-31",
      dunningLocked: true,
      dunningLockedUntil: "2025-08-30",
      dunningLockReason: "TestMahnmodul",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "DUMMY (JDS)",
      meterPricing: "included",
      cityId: "8862",
      additionalValues: []
    },
    contract_changed_installment_plan: {
      id: 180466,
      clientId: 3,
      accountId: 2444,
      isActive: "0",
      useDirectDebit: "1",
      createdAt: "2025-05-21 16:53:07",
      total_receivable_amount: "283.12",
      total_overdue_receivable_amount: "283.12",
      total_installment_amount: "283.12",
      total_settled_installment_amount: "0.00",
      total_unsettled_installment_amount: "283.12",
      excluded_receivables: [],
      installments: [
        {
          id: "2107221",
          data: {
            id: 2107221,
            clientId: 3,
            accountId: 2444,
            grossAmount: "47.19",
            settledAmount: "0.00",
            payableAt: "2025-05-28",
            createdAt: "2025-05-21 16:53:07"
          },
          additionalData: []
        },
        {
          id: "2107222",
          data: {
            id: 2107222,
            clientId: 3,
            accountId: 2444,
            grossAmount: "47.19",
            settledAmount: "0.00",
            payableAt: "2025-06-02",
            createdAt: "2025-05-21 16:53:07"
          },
          additionalData: []
        },
        {
          id: "2107223",
          data: {
            id: 2107223,
            clientId: 3,
            accountId: 2444,
            grossAmount: "47.19",
            settledAmount: "0.00",
            payableAt: "2025-07-01",
            createdAt: "2025-05-21 16:53:07"
          },
          additionalData: []
        },
        {
          id: "2107224",
          data: {
            id: 2107224,
            clientId: 3,
            accountId: 2444,
            grossAmount: "47.19",
            settledAmount: "0.00",
            payableAt: "2025-08-01",
            createdAt: "2025-05-21 16:53:07"
          },
          additionalData: []
        },
        {
          id: "2107225",
          data: {
            id: 2107225,
            clientId: 3,
            accountId: 2444,
            grossAmount: "47.19",
            settledAmount: "0.00",
            payableAt: "2025-09-01",
            createdAt: "2025-05-21 16:53:07"
          },
          additionalData: []
        },
        {
          id: "2107226",
          data: {
            id: 2107226,
            clientId: 3,
            accountId: 2444,
            grossAmount: "47.17",
            settledAmount: "0.00",
            payableAt: "2025-10-01",
            createdAt: "2025-05-21 16:53:07"
          },
          additionalData: []
        }
      ],
      receivables: [
        {
          id: "786058",
          data: {
            id: 786058,
            clientId: 3,
            accountId: 2444,
            receivableId: "151715645",
            initialUnsettledAmount: "109.00",
            account_receivable: {
              id: "151715645",
              data: {
                id: "151715645",
                bookingNumber: "254760367",
                createdAt: "2025-03-29 15:04:18",
                type: "deposit",
                energy: "electricity",
                payableAt: "2025-04-01",
                grossAmount: 109,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) M\xE4rz / 2025 Kunden-Nr. 20001639 / 1000101549",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [
                  {
                    id: "2946164",
                    data: {
                      createdAt: "2025-05-21 16:54:00",
                      createdBy: "Hintergrunddienste System",
                      originCreatedAt: "2025-05-21 16:53:11",
                      deletedAt: "2025-05-21 16:54:00",
                      deletedBy: "Frederik Michan",
                      lockReason: {
                        id: "56",
                        data: {
                          id: "56",
                          public: false,
                          techKey: "RATENPLAN",
                          text: "Ratenplan",
                          revenueBlocker: false,
                          isActive: true,
                          maxDunningDuration: "0",
                          clientId: "3",
                          defaultReasonForActions: false,
                          deleted: false,
                          modificationDate: "2024-02-01 15:10:21",
                          daysTillCheck: null,
                          allowDebtCollections: false,
                          type: "dunning_lock_reason",
                          access: [
                            "DunningLock_Standard",
                            "DunningLock_Expert",
                            "DunningLock_CRON"
                          ]
                        },
                        additionalData: []
                      }
                    },
                    additionalData: []
                  }
                ],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 109
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "786059",
          data: {
            id: 786059,
            clientId: 3,
            accountId: 2444,
            receivableId: "152192872",
            invoiceNumber: 6408940,
            initialUnsettledAmount: "72.12",
            account_receivable: {
              id: "152192872",
              data: {
                id: "152192872",
                bookingNumber: "255224379",
                createdAt: "2025-04-16 10:26:35",
                type: "invoice",
                energy: "electricity",
                payableAt: "2025-04-30",
                grossAmount: 72.12,
                settledAmount: 0,
                tax: "19.00",
                notice: "Turnusrechnung: 01.04.2024 - 31.03.2025",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [
                  {
                    id: "2946165",
                    data: {
                      createdAt: "2025-05-21 16:54:00",
                      createdBy: "Hintergrunddienste System",
                      originCreatedAt: "2025-05-21 16:53:12",
                      deletedAt: "2025-05-21 16:54:00",
                      deletedBy: "Frederik Michan",
                      lockReason: {
                        id: "56",
                        data: {
                          id: "56",
                          public: false,
                          techKey: "RATENPLAN",
                          text: "Ratenplan",
                          revenueBlocker: false,
                          isActive: true,
                          maxDunningDuration: "0",
                          clientId: "3",
                          defaultReasonForActions: false,
                          deleted: false,
                          modificationDate: "2024-02-01 15:10:21",
                          daysTillCheck: null,
                          allowDebtCollections: false,
                          type: "dunning_lock_reason",
                          access: [
                            "DunningLock_Standard",
                            "DunningLock_Expert",
                            "DunningLock_CRON"
                          ]
                        },
                        additionalData: []
                      }
                    },
                    additionalData: []
                  }
                ],
                nextDunningAt: null,
                invoiceId: "8296692",
                unsettledAmount: 72.12
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "786060",
          data: {
            id: 786060,
            clientId: 3,
            accountId: 2444,
            receivableId: "153672882",
            initialUnsettledAmount: "102.00",
            account_receivable: {
              id: "153672882",
              data: {
                id: "153672882",
                bookingNumber: "256700387",
                createdAt: "2025-04-19 21:09:22",
                type: "deposit",
                energy: "electricity",
                payableAt: "2025-05-02",
                grossAmount: 102,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) April / 2025 Kunden-Nr. 20001639 / 1000101549",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [
                  {
                    id: "2946166",
                    data: {
                      createdAt: "2025-05-21 16:54:00",
                      createdBy: "Hintergrunddienste System",
                      originCreatedAt: "2025-05-21 16:53:12",
                      deletedAt: "2025-05-21 16:54:00",
                      deletedBy: "Frederik Michan",
                      lockReason: {
                        id: "56",
                        data: {
                          id: "56",
                          public: false,
                          techKey: "RATENPLAN",
                          text: "Ratenplan",
                          revenueBlocker: false,
                          isActive: true,
                          maxDunningDuration: "0",
                          clientId: "3",
                          defaultReasonForActions: false,
                          deleted: false,
                          modificationDate: "2024-02-01 15:10:21",
                          daysTillCheck: null,
                          allowDebtCollections: false,
                          type: "dunning_lock_reason",
                          access: [
                            "DunningLock_Standard",
                            "DunningLock_Expert",
                            "DunningLock_CRON"
                          ]
                        },
                        additionalData: []
                      }
                    },
                    additionalData: []
                  }
                ],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 102
              },
              additionalData: []
            }
          },
          additionalData: []
        }
      ]
    },
    contract_installment_plan_end_reason: "manual_ending",
    customer: {
      authorizedAt: null,
      createdAt: "2024-09-10 18:33:14",
      zip: "47447",
      city: "Moers",
      street: "Feuerbachstr.",
      houseNumber: "1",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: "Firma Anonym",
      countryId: "48",
      customerId: "20001639",
      status: "active",
      externalId: null,
      salutation: "2",
      firstname: "Ingrid",
      title: null,
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      availableSentNotification: "1",
      authEnabled: "1",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "12345678",
      phoneHomeAreaCode: "01234",
      phoneHome: "12345678",
      phoneBusinessAreaCode: "1234",
      phoneBusiness: "12345678",
      emailPrivate: "test.anonym@ewe.de",
      emailBusiness: "test.anonym@ewe.de",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "5"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "B",
              createdAt: "2022-07-29 10:24:10",
              position: "2",
              fieldValueId: "5668861"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "1214",
      clientId: "3",
      identifier: "50502013936",
      additionalValues: [],
      note: null
    },
    product_version: {
      productId: "2",
      version: "9",
      status: "deprecated",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "both",
      pricingType: "fixed_pricing",
      usageNtPercentage: null,
      createdAt: "2018-11-02 15:28:01",
      updatedAt: "2018-11-02 15:40:19",
      releaseRequestedAt: null,
      releasedAt: "2019-01-31 15:40:19",
      deprecatedAt: "2019-03-20 11:43:13",
      lockedAt: null,
      name: "Strom Zuhause+ (12 Monate)",
      validFrom: "2018-07-14",
      validUntil: "9999-10-02",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "12",
      contractExtensionTimeType: "months",
      contractCancellationPeriod: "28",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-2.json
var contract_request_customer_reading_2_default = {
  EventId: "211430022",
  EventName: "contract_change_customer_bank_data",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 10,
    contract: {
      id: "1003020517",
      accountId: "2923237",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "49393",
      city: "Lohne",
      street: "Hauptstr.",
      houseNumber: "88",
      floor: null,
      phone: "",
      fax: "",
      email: "",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "1",
      billing_title: "",
      billing_firstname: "Franz",
      billing_surname: "Baumh\xF6he",
      billing_careOfRecipient: "",
      billing_company: "",
      billing_zip: "49393",
      billing_city: "Lohne",
      billing_street: "Hauptstr.",
      billing_houseNumber: "88",
      billing_phone: "",
      billing_fax: "",
      billing_email: "",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "333IZZTH845434",
      counterType: "MME",
      counterTypeName: "moderne Messeinrichtung",
      invoice_email: "",
      invoice_phone: "",
      invoice_fax: "",
      meterPointIdentifier: null,
      marketLocation: "45391113930",
      meterLocation: "DE00012326121LBB00000045391113946",
      complexSystem: false,
      customerId: "21714675",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "1",
      firstname: "Franz",
      surname: "Baumh\xF6he",
      dateOfBirth: "1980-01-10",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2022-10-14",
      dateOfRevocation: null,
      startDate: "2024-04-01",
      desiredStartDate: "2024-04-01",
      simulationTurnus: 6,
      nextInvoiceInformationDate: null,
      endDate: null,
      desiredEndDate: null,
      orderId: "2970394",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "relocation_at",
      signatureDate: "2024-04-01",
      netDeliveryStartConfirmed: "2022-09-30 16:39:00",
      netDeliveryEndConfirmed: null,
      usage: "2500",
      usageNet: "15000",
      usagePrevious: null,
      brandId: "1",
      directDebit: true,
      direction: "in",
      activeFrom: "2024-04-10",
      activeUntil: null,
      iban: "DE02300209000106531065",
      bic: "CMCIDEDDXXX",
      bank: "TARGOBANK AG",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0106531065",
      bankCode: "30020900",
      alternativeAccountHolder: "Franz Baumh\xF6he",
      sepaMandate: "EWE-21714675-1003020517-2",
      futureBankingData: [
        {
          activeFrom: "2024-04-10",
          activeUntil: null,
          alternativeAccountHolder: "Franz Baumh\xF6he",
          bank: "TARGOBANK AG",
          bankAccountNumber: "0106531065",
          bankCode: "30020900",
          bic: "CMCIDEDDXXX",
          directDebit: true,
          direction: "in",
          iban: "DE02300209000106531065",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-21714675-1003020517-2"
        },
        {
          activeFrom: "2024-04-10",
          activeUntil: null,
          alternativeAccountHolder: "Franz Baumh\xF6he",
          bank: "TARGOBANK AG",
          bankAccountNumber: "0106531065",
          bankCode: "30020900",
          bic: "CMCIDEDDXXX",
          directDebit: false,
          direction: "out",
          iban: "DE02300209000106531065",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: ""
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            activeFrom: "2024-04-10",
            activeUntil: null,
            alternativeAccountHolder: "Franz Baumh\xF6he",
            bank: "TARGOBANK AG",
            bic: "CMCIDEDDXXX",
            directDebit: true,
            direction: "in",
            iban: "DE02300209000106531065",
            paymentProvider: "SEPA Bank",
            replacedBankId: null,
            sepaMandate: "EWE-21714675-1003020517-2"
          }
        ],
        out: [
          {
            activeFrom: "2024-04-10",
            activeUntil: null,
            alternativeAccountHolder: "Franz Baumh\xF6he",
            bank: "TARGOBANK AG",
            bic: "CMCIDEDDXXX",
            directDebit: false,
            direction: "out",
            iban: "DE02300209000106531065",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: ""
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: null,
      cancellationPreviousProviderConfirmed: null,
      netDeliveryStartSent: "2024-04-09 11:37:05",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      nextCancellationDate: "2025-03-31",
      latestCancelationByCustomer: "2025-03-03",
      externalId: null,
      externalOrderId: null,
      extendedData: {
        categories: {},
        values: {}
      },
      desiredInvoiceDate: null,
      invoicePeriodStartDate: "2024-04-01",
      invoicePeriodEndDate: "2024-04-30",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "kein Mahnverfahren hinterlegt (JDS)",
      meterPricing: "included",
      cityId: "8999",
      additionalValues: []
    },
    contract_change_customer_data_date: "2024-04-10",
    contract_change_customer_data_old_bank_data: {
      contract_change_customer_data_id: null,
      contract_change_customer_data_active_from: null,
      contract_change_customer_data_active_until: null,
      contract_change_customer_data_sepa_mandate: null,
      contract_change_customer_data_iban: "",
      contract_change_customer_data_bic: "",
      contract_change_customer_data_bank: "",
      contract_change_customer_data_replaced_bank_id: null,
      contract_change_customer_data_account_holder: "",
      contract_change_customer_data_directdebit: false,
      contract_change_customer_data_dunning_locked: false,
      contract_change_customer_data_dunning_locked_until: null,
      contract_change_customer_data_manual_billing_blocked: false,
      contract_change_customer_data_direction: "",
      contract_change_customer_data_payment_provider_key: null
    },
    contract_change_customer_data_old_other_directional_banking_data: null,
    contract_change_customer_data_new_bank_data: {
      contract_change_customer_data_id: 4038390,
      contract_change_customer_data_active_from: "2024-04-10",
      contract_change_customer_data_active_until: null,
      contract_change_customer_data_sepa_mandate: "EWE-21714675-1003020517-2",
      contract_change_customer_data_iban: "DE02300209000106531065",
      contract_change_customer_data_bic: "CMCIDEDDXXX",
      contract_change_customer_data_bank: "TARGOBANK AG",
      contract_change_customer_data_replaced_bank_id: null,
      contract_change_customer_data_account_holder: "Franz Baumh\xF6he",
      contract_change_customer_data_directdebit: true,
      contract_change_customer_data_dunning_locked: false,
      contract_change_customer_data_dunning_locked_until: null,
      contract_change_customer_data_manual_billing_blocked: false,
      contract_change_customer_data_direction: "in",
      contract_change_customer_data_payment_provider_key: "SEPA Bank"
    },
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE81280200501446416800",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "18",
          data: {
            id: "18",
            type: "",
            iban: "DE22280400460405354200",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    order: {
      id: "2970394",
      createdAt: "2024-04-09 10:57:00",
      orderedAt: "2024-04-09 10:57:00",
      status: "done",
      revokedAt: null,
      relevantStreet: "0",
      zip: "49393",
      city: "Lohne",
      street: "Hauptstr.",
      houseNumber: "88",
      business: "0",
      company: null,
      customerId: "21714675",
      salutation: "1",
      firstname: "Franz",
      surname: "Baumh\xF6he",
      dateOfBirth: "1980-01-10",
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: null,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "0",
      billing_company: null,
      billing_salutation: "1",
      billing_title: null,
      billing_firstname: "Franz",
      billing_surname: "Baumh\xF6he",
      billing_careOfRecipient: "",
      billing_zip: "49393",
      billing_country: "",
      billing_countryAlpha2: "",
      billing_city: "Lohne",
      billing_street: "Hauptstr.",
      billing_houseNumber: "88",
      billing_fax: "",
      billing_phone: null,
      billing_email: null,
      relocationAddressTransfer: "",
      iban: null,
      bic: null,
      bank: null,
      alternativeAccountHolder: null,
      directDebit: false,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "DYHOMEPAGE",
      campaignId: "33",
      exportAt: "2024-04-09",
      salesChannel: "online",
      inputChannel: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "",
      previousProviderCodeNumber: "9903324000006",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900496000005",
      netCodeNumberProvider: "bdew",
      customerNumber: null,
      customerSpecification: "relocation_at",
      relocationAt: "2024-04-01",
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: null,
      provider: "EWE VERTRIEB GmbH",
      providerId: "-4",
      product: "EWE Zuhause+ Gr\xFCnstrom 12 dynamisch (\xDCbergang)",
      productId: "138",
      productCode: "ST-ZHDYUP-04",
      productEco: "1",
      variant: "0",
      productType: "standard",
      priceKey: null,
      counterNumber: "333IZZTH845434",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "2500",
      complexPrice: false,
      productWorkingPrice: "0",
      productBasePrice: "0",
      overConsumptionWorkingPrice: "0",
      productWorkingPriceNetto: "0",
      productBasePriceNetto: "0",
      productBonusNetto: "0",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productWorkingPriceTax: "0",
      productBasePriceTax: "0",
      productBonusTax: "0",
      productInstantBonusTax: "0",
      productBonus: "0.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "none",
      fixedPriceMonths: null,
      fixedPriceDate: null,
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      ediProcessId: null,
      vpCode: null,
      uvpCode: null,
      extendedData: {
        categories: {},
        values: {}
      },
      createdBy: "12",
      signatureDate: "2024-04-01",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-04-09 10:57:12",
      zip: "49393",
      city: "Lohne",
      street: "Hauptstr.",
      houseNumber: "88",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "21714675",
      status: "active",
      externalId: null,
      salutation: "1",
      firstname: "Franz",
      title: null,
      surname: "Baumh\xF6he",
      dateOfBirth: "1980-01-10",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      customerCommunicationType: "0",
      extendedData: {
        categories: {},
        values: {}
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "1949155",
      clientId: "3",
      identifier: "45391113930",
      additionalValues: [],
      note: null
    },
    contract_tariff: {
      id: "11585066",
      createdAt: "2024-04-09 11:36:56",
      product: "EWE Zuhause+ Gr\xFCnstrom 12 dynamisch (\xDCbergang)",
      productCode: "ST-ZHDYUP-04",
      activeFrom: "2024-04-01",
      activeUntil: null,
      productEco: "1",
      productType: "standard",
      activeFromOriginal: null,
      basePrice: 0,
      meterCharge: "0",
      contractPrice: false,
      workingPrice: 0,
      complexPrice: false,
      overConsumptionWorkingPrice: "0",
      usageCustomer: "2500",
      productBonus: "0.000000",
      productBonusPercent: "0",
      instantBonus: "0",
      instantBonusDate: "2024-04-29",
      includeBonusInDepositCalculation: "0",
      fixedPriceType: "none",
      fixedPriceDate: null,
      fixedPriceMonths: null,
      priceKey: null,
      priceAdjustmentOf: null,
      priceAdjustmentReason: null,
      billingPeriod: "1",
      minimumRuntime: "12",
      extensionTime: "1",
      cancellationPeriod: "1",
      contractProductId: "3700491",
      waitForConfirmationUntil: null,
      confirmedAt: null,
      energyTax: 0.19,
      depositDivisor: "1",
      tariffChangeDate: null,
      basePriceNetto: 0,
      workingPriceNetto: 0,
      productBonusNetto: 0,
      instantBonusNetto: 0,
      basePriceTax: 0,
      workingPriceTax: 0,
      productBonusTax: 0,
      instantBonusTax: 0,
      instantBonusTaxRate: 19,
      additionalValues: [],
      calculatedFixedPriceDate: null,
      meterPricing: "included",
      flexbonus: [],
      minimumConsumption: null,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_product: {
      contractProductId: "3700491",
      createdAt: "2024-04-09 11:36:56",
      productName: "EWE Zuhause+ Gr\xFCnstrom 12 dynamisch (\xDCbergang)",
      productCode: "ST-ZHDYUP-04",
      productVersion: "8",
      productType: "rlm",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-04-01",
      activeUntil: null,
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_banking_data: [
      {
        id: "4038390",
        iban: "DE02300209000106531065",
        bic: "CMCIDEDDXXX",
        bank: "TARGOBANK AG",
        activeFrom: "2024-04-10",
        activeUntil: null,
        sepaMandate: "EWE-21714675-1003020517-2",
        accountHolder: "Franz Baumh\xF6he",
        direction: "in",
        directDebit: "1",
        createdAt: "2024-04-10 14:02:26"
      },
      {
        id: "4038391",
        iban: "DE02300209000106531065",
        bic: "CMCIDEDDXXX",
        bank: "TARGOBANK AG",
        activeFrom: "2024-04-10",
        activeUntil: null,
        sepaMandate: "",
        accountHolder: "Franz Baumh\xF6he",
        direction: "out",
        directDebit: "0",
        createdAt: "2024-04-10 14:02:26"
      }
    ],
    product_version: {
      productId: "190",
      version: "8",
      status: "released",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "private",
      pricingType: "fixed_pricing",
      usageNtPercentage: null,
      createdAt: "2023-10-30 14:24:07",
      updatedAt: "2023-10-30 14:24:07",
      releaseRequestedAt: null,
      releasedAt: "2024-01-29 14:24:07",
      deprecatedAt: null,
      lockedAt: null,
      name: "EWE Zuhause+ Gr\xFCnstrom 12 dynamisch (\xDCbergang)",
      validFrom: "2023-06-03",
      validUntil: "9999-09-18",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "1",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "1",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "1",
      contractCancellationPeriodType: "months",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: "1"
    }
  }
};

// src/examples/contract/contract-request-customer-reading-3.json
var contract_request_customer_reading_3_default = {
  EventId: "438408306",
  EventName: "contract_deposit_changed",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 10,
    contract: {
      id: "1003023039",
      accountId: "2925761",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "26133",
      city: "Oldenburg",
      street: "An den Vo\xDFbergen",
      houseNumber: "29",
      floor: null,
      phone: "",
      fax: "",
      email: "",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "9",
      billing_title: null,
      billing_firstname: "Jazdin Nadjman",
      billing_surname: "Zaydin",
      billing_careOfRecipient: "",
      billing_company: "",
      billing_zip: "26133",
      billing_city: "Oldenburg",
      billing_street: "An den Vo\xDFbergen",
      billing_houseNumber: "29",
      billing_phone: "",
      billing_fax: "",
      billing_email: "",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "1HLY0200737683",
      counterType: "EHZ",
      counterTypeName: "Elektronischer Haushaltsz\xE4hler",
      invoice_email: "",
      invoice_phone: "",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50354447565",
      meterLocation: "DE0004962613300000000000010330154",
      complexSystem: false,
      customerId: "21720542",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "9",
      firstname: "Jazdin Nadjman",
      surname: "Zaydin",
      dateOfBirth: null,
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2024-09-26",
      dateOfRevocation: null,
      startDate: "2024-09-23",
      desiredStartDate: "2024-09-23",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-03-23",
      endDate: null,
      desiredEndDate: null,
      orderId: "2973163",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "basic_supply_registration",
      signatureDate: "2024-09-23",
      netDeliveryStartConfirmed: "2024-09-12 00:00:00",
      netDeliveryEndConfirmed: null,
      usage: "3844",
      usageNet: "3844",
      usagePrevious: null,
      brandId: "1",
      directDebit: false,
      direction: null,
      activeFrom: null,
      activeUntil: null,
      iban: null,
      bic: null,
      bank: null,
      paymentProvider: "SEPA Bank",
      replacedBankId: null,
      bankAccountNumber: "",
      bankCode: "",
      alternativeAccountHolder: null,
      sepaMandate: null,
      futureBankingData: [],
      InOutActiveBankingData: {
        in: [],
        out: []
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: null,
      cancellationPreviousProviderConfirmed: null,
      netDeliveryStartSent: null,
      minimumRuntime: "0",
      minimumRuntimeUnit: "days",
      extensionTime: "0",
      extensionTimeUnit: "days",
      cancellationPeriod: "14",
      cancellationPeriodUnit: "days",
      nextCancellationDate: "2024-10-09",
      latestCancelationByCustomer: "2024-09-25",
      externalId: null,
      externalOrderId: null,
      extendedData: {
        categories: {
          MPKD: {
            technicalKey: "MPKD",
            createdAt: "2024-04-29 08:02:13",
            name: "Marktpartner",
            position: "15"
          }
        },
        values: {
          MPKD: [
            {
              name: "Marktpartner",
              technicalKey: "MPKD",
              type: "select",
              value: "LVB",
              createdAt: "2024-09-25 15:49:55",
              position: "4",
              fieldValueId: "8031035"
            },
            {
              name: "Identifikationsnummer MP",
              technicalKey: "INMP",
              type: "text",
              value: "1234567890",
              createdAt: "2024-09-25 15:49:55",
              position: "5",
              fieldValueId: "8031036"
            }
          ]
        }
      },
      desiredInvoiceDate: null,
      invoicePeriodStartDate: "2024-09-23",
      invoicePeriodEndDate: "2025-09-22",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "STANDARD",
      meterPricing: "included",
      cityId: "6411",
      additionalValues: []
    },
    contract_ideal_deposit_value: 135.0564,
    contract_deposit_changed_by: "customer_service",
    contract_deposit_change_process: "process_customer",
    contract_next_deposit: {
      id: 16338535,
      clientId: 3,
      contractId: 1003023039,
      contractTariffId: 12015685,
      createdAt: "2024-09-12 18:14:01",
      createdBy: "11",
      activeFrom: "2024-09-12",
      activeUntil: null,
      updatedAt: "2024-09-25 15:50:03",
      updatedBy: "22",
      grossAmount: 137,
      blockedUntil: null,
      alternativeDayOfMonth: null,
      nextGenerationAt: "2024-10-21",
      ruleId: "11",
      frequency: 1,
      techKey: "default",
      isSplitted: "0",
      depositSplits: [],
      netAmount: 115.13,
      taxRate: 0.19,
      taxAmount: 21.87,
      nextExecution: {
        useAt: "2024-11-04",
        useFor: "2024-10-01",
        useForPeriodStart: "2024-10-01",
        useForPeriodEnd: "2024-10-31",
        generateAt: "2024-10-21",
        sepaGenerateAt: "2024-10-28"
      }
    },
    contract_current_deposit: {
      id: 16338535,
      clientId: 3,
      contractId: 1003023039,
      contractTariffId: 12015685,
      createdAt: "2024-09-12 18:14:01",
      createdBy: "11",
      activeFrom: "2024-09-12",
      activeUntil: null,
      updatedAt: "2024-09-12 18:14:01",
      updatedBy: "11",
      grossAmount: 136,
      blockedUntil: null,
      alternativeDayOfMonth: null,
      nextGenerationAt: "2024-10-21",
      ruleId: "11",
      frequency: "1",
      techKey: "default",
      isSplitted: "0",
      depositSplits: [],
      netAmount: 114.29,
      taxRate: 0.19,
      taxAmount: 21.71,
      nextExecution: {
        useAt: "2024-11-04",
        useFor: "2024-10-01",
        useForPeriodStart: "2024-10-01",
        useForPeriodEnd: "2024-10-31",
        generateAt: "2024-10-21",
        sepaGenerateAt: "2024-10-28"
      }
    },
    futureDepositAmounts: [
      {
        dueDate: "2024-11-04",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2024-12-02",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-01-02",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-02-03",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-03-03",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-04-01",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-05-02",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-06-02",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-07-01",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-08-01",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-09-01",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      },
      {
        dueDate: "2025-10-01",
        amountNet: "115.13",
        amountTax: "21.87",
        amountGross: "137.00",
        taxRate: 19,
        taxKey: "M19",
        frequency: 1
      }
    ],
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE81280200501446416800",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "18",
          data: {
            id: "18",
            type: "",
            iban: "DE22280400460405354200",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "19",
          data: {
            id: "19",
            type: "",
            iban: "DE11280400460405354204",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    order: {
      id: "2973163",
      createdAt: "2024-09-12 18:11:13",
      orderedAt: "2024-09-12 18:11:13",
      status: "done",
      revokedAt: null,
      relevantStreet: "0",
      zip: "26133",
      city: "Oldenburg",
      street: "An den Vo\xDFbergen",
      houseNumber: "29",
      business: "0",
      company: null,
      customerId: "21720542",
      salutation: "9",
      firstname: "Jazdin Nadjman",
      surname: "Zaydin",
      dateOfBirth: null,
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: null,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "0",
      billing_company: null,
      billing_salutation: "9",
      billing_title: null,
      billing_firstname: "Jazdin Nadjman",
      billing_surname: "Zaydin",
      billing_careOfRecipient: "",
      billing_zip: "26133",
      billing_country: "",
      billing_countryAlpha2: "",
      billing_city: "Oldenburg",
      billing_street: "An den Vo\xDFbergen",
      billing_houseNumber: "29",
      billing_fax: "",
      billing_phone: null,
      billing_email: null,
      relocationAddressTransfer: "",
      iban: null,
      bic: null,
      bank: null,
      alternativeAccountHolder: null,
      directDebit: false,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "GRUNDVERSORGUNG",
      campaignId: "24",
      exportAt: "2024-09-12",
      salesChannel: "any",
      inputChannel: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "",
      previousProviderCodeNumber: "9903324000006",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900496000005",
      netCodeNumberProvider: "bdew",
      customerNumber: null,
      customerSpecification: "basic_supply_registration",
      relocationAt: null,
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: "2024-09-23",
      provider: "EWE VERTRIEB GmbH",
      providerId: "-7",
      product: "EWE Strom comfort",
      productId: "2395",
      productCode: "ST-COMFXX-PC",
      productEco: "1",
      variant: "0",
      productType: "standard",
      priceKey: "ST-COMFXX-PC",
      counterNumber: "1HLY0200737683",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "3844",
      complexPrice: true,
      complexUsages: {
        id: "1340597",
        data: {
          complexUsage: {
            totalUsage: 3844,
            usageForCalculation: 3844,
            usages: [
              {
                registerName: "HT",
                usage: 3844
              }
            ]
          }
        },
        additionalData: []
      },
      complexPrices: {
        id: "2836786",
        data: {
          complexPrice: [
            {
              usageFrom: 0,
              usageUntil: 64,
              basePriceNetto: "159.1176",
              basePriceBrutto: "189.35",
              basePriceTax: "30.2324",
              basePriceTaxRate: "19",
              workingPrices: [
                {
                  registerName: "HT",
                  workingPriceNetto: "44.5798",
                  workingPriceBrutto: "53.05",
                  workingPriceTax: "8.4702",
                  workingPriceTaxRate: "19"
                }
              ]
            },
            {
              usageFrom: 65,
              usageUntil: 1e5,
              basePriceNetto: "167.6891",
              basePriceBrutto: "199.55",
              basePriceTax: "31.8609",
              basePriceTaxRate: "19",
              workingPrices: [
                {
                  registerName: "HT",
                  workingPriceNetto: "31.0672",
                  workingPriceBrutto: "36.97",
                  workingPriceTax: "5.9028",
                  workingPriceTaxRate: "19"
                }
              ]
            }
          ],
          meterPrices: []
        },
        additionalData: []
      },
      overConsumptionWorkingPrice: "0",
      productBonusNetto: "0",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productBonusTax: "0",
      productInstantBonusTax: "0",
      productBonus: "0.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "none",
      fixedPriceMonths: null,
      fixedPriceDate: null,
      cancellationPeriod: "14",
      cancellationPeriodUnit: "days",
      minimumRuntime: "0",
      minimumRuntimeUnit: "days",
      extensionTime: "0",
      extensionTimeUnit: "days",
      ediProcessId: "147459482",
      vpCode: null,
      uvpCode: null,
      extendedData: {
        categories: {},
        values: {}
      },
      createdBy: "11",
      signatureDate: "2024-09-23",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-09-12 18:11:17",
      zip: "26133",
      city: "Oldenburg",
      street: "An den Vo\xDFbergen",
      houseNumber: "29",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: null,
      company: null,
      countryId: "48",
      customerId: "21720542",
      status: "active",
      externalId: null,
      salutation: "9",
      firstname: "Jazdin Nadjman",
      title: null,
      surname: "Zaydin",
      dateOfBirth: null,
      availableSentNotification: "0",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "5"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2024-09-13 06:04:54",
              position: "5",
              fieldValueId: "8030428"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_partner: {
      id: "8858",
      partnerId: "9900496000005",
      type: "net",
      externalId: "",
      organization: "EWE NETZ GmbH",
      phone: "",
      activeFrom: null,
      activeUntil: null,
      zip: "26133",
      city: "Oldenburg",
      street: "Cloppenburger Str.",
      energy: "electricity",
      iban: "DE02280400460402349500",
      bic: "COBADEFFXXX",
      accountingAllocationIndicator: "affiliated_with_tax"
    },
    market_location: {
      id: "1752015",
      clientId: "3",
      identifier: "50354447565",
      additionalValues: [],
      note: "GSG Whg.: 394.0001"
    },
    market_location_classifications: [
      {
        id: "1015316",
        activeFrom: "2022-11-01",
        activeUntil: null,
        metrologicalClassification: "Z53",
        accountingMethodRight: null,
        marketLocationId: "1752015"
      }
    ],
    meter_location: {
      id: "1749188",
      clientId: "3",
      identifier: "DE0004962613300000000000010330154"
    },
    meter_locations_list: [
      {
        id: "1749188",
        clientId: "3",
        identifier: "DE0004962613300000000000010330154"
      }
    ],
    market_structure: [
      {
        id: "1752015",
        identifier: "50354447565",
        assignedFrom: "2024-09-23",
        assignedTo: null,
        meter_locations: [
          {
            id: "1749188",
            identifier: "DE0004962613300000000000010330154",
            activeFrom: "2022-11-01",
            activeUntil: null,
            isPositive: true,
            counters: [
              {
                id: "2804320",
                counterNumber: "1HLY0200737683",
                energy: "electricity",
                type: "EHZ",
                activeFrom: "2024-09-23 00:00:00",
                activeUntil: null,
                registers: [
                  {
                    id: "3216358",
                    description: "HT",
                    obis: "1-1:1.8.0",
                    activeFrom: "2024-09-23 00:00:00",
                    activeUntil: null,
                    nonBillingRelevantRegisterId: false
                  }
                ],
                gateways: [],
                converters: [],
                control_boxes: [],
                communication_devices: [],
                controllers: [],
                quantity_transformers: []
              },
              {
                id: "2178053",
                counterNumber: "1HLY0200737683",
                energy: "electricity",
                type: "EHZ",
                activeFrom: "2022-11-01 00:00:00",
                activeUntil: "2022-10-31 23:59:59",
                registers: [
                  {
                    id: "2251491",
                    description: null,
                    obis: "1-1:1.8.0",
                    activeFrom: "2022-11-01 00:00:00",
                    activeUntil: "2022-10-31 23:59:59",
                    nonBillingRelevantRegisterId: false
                  }
                ],
                gateways: [],
                converters: [],
                control_boxes: [],
                communication_devices: [],
                controllers: [],
                quantity_transformers: []
              },
              {
                id: "2246565",
                counterNumber: "1HLY0200737683",
                energy: "electricity",
                type: "EHZ",
                activeFrom: "2022-11-01 00:00:00",
                activeUntil: "2024-09-22 23:59:59",
                registers: [
                  {
                    id: "2327308",
                    description: null,
                    obis: "1-1:1.8.0",
                    activeFrom: "2022-11-01 00:00:00",
                    activeUntil: "2024-09-22 23:59:59",
                    nonBillingRelevantRegisterId: false
                  }
                ],
                gateways: [],
                converters: [],
                control_boxes: [],
                communication_devices: [],
                controllers: [],
                quantity_transformers: []
              }
            ]
          }
        ]
      }
    ],
    market_location_measuring_point_operators: [
      {
        zip: "26133",
        city: "Oldenburg",
        street: "Cloppenburger Str.",
        houseNumber: "302",
        organization: "EWE NETZ GmbH",
        partnerId: "9904455000006",
        measuringPointOperatorType: "gMSB",
        activeFrom: "2022-11-01",
        activeUntil: null,
        registerCourt: "Amtsgericht Oldenburg",
        registerNumber: "HRB5236",
        viaNne: "0",
        invoicingOfMme: null
      }
    ],
    meter_location_measuring_point_operators: [
      {
        zip: "26133",
        city: "Oldenburg",
        street: "Cloppenburger Str.",
        houseNumber: "302",
        organization: "EWE NETZ GmbH",
        partnerId: "9904455000006",
        measuringPointOperatorType: "gMSB",
        activeFrom: "2022-11-01",
        activeUntil: "2024-09-22",
        registerCourt: "Amtsgericht Oldenburg",
        registerNumber: "HRB5236"
      },
      {
        zip: "26133",
        city: "Oldenburg",
        street: "Cloppenburger Str.",
        houseNumber: "302",
        organization: "EWE NETZ GmbH",
        partnerId: "9904455000006",
        measuringPointOperatorType: "gMSB",
        activeFrom: "2024-09-23",
        activeUntil: null,
        registerCourt: "Amtsgericht Oldenburg",
        registerNumber: "HRB5236"
      }
    ],
    contract_product: {
      contractProductId: "3708202",
      createdAt: "2024-09-12 18:12:11",
      productName: "EWE Strom comfort",
      productCode: "ST-COMFXX-PC",
      productVersion: "21",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-09-12",
      activeUntil: null,
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_properties: [
      {
        propertyKey: "counting_procedure"
      },
      {
        propertyKey: "deposit_rule_id",
        propertyValue: 11
      },
      {
        propertyKey: "loc_thermal",
        propertyValue: {
          type: null,
          identifier: null,
          serviceProvider: null,
          serviceProviderType: null
        }
      },
      {
        propertyKey: "order_initiator",
        propertyValue: "thirdParty"
      }
    ],
    contract_deposit: {
      id: 16338535,
      clientId: 3,
      contractId: 1003023039,
      contractTariffId: 12015685,
      createdAt: "2024-09-12 18:14:01",
      createdBy: "11",
      activeFrom: "2024-09-12",
      activeUntil: null,
      updatedAt: "2024-09-25 15:50:03",
      updatedBy: "22",
      grossAmount: 137,
      blockedUntil: null,
      alternativeDayOfMonth: null,
      nextGenerationAt: "2024-10-21",
      ruleId: "11",
      frequency: "1",
      techKey: "default",
      isSplitted: "0",
      depositSplits: [],
      netAmount: 115.13,
      taxRate: 0.19,
      taxAmount: 21.87,
      nextExecution: {
        useAt: "2024-11-04",
        useFor: "2024-10-01",
        useForPeriodStart: "2024-10-01",
        useForPeriodEnd: "2024-10-31",
        generateAt: "2024-10-21",
        sepaGenerateAt: "2024-10-28"
      }
    },
    contract_counter: {
      createdAt: "2024-09-12 18:13:04",
      createdByAgent: "0",
      id: "2804320",
      counterNumber: "1HLY0200737683",
      counterSize: null,
      activeFrom: "2024-09-23 00:00:00",
      activeUntil: null,
      type: "EHZ",
      typeName: "Elektronischer Haushaltsz\xE4hler",
      energyDirection: "ZRZ",
      dataAcquisition: "MMR",
      tariffCount: "ETZ",
      exchangeType: null,
      exchangeValue: "1",
      registers: [
        {
          activeFrom: "2024-09-23 00:00:00",
          activeUntil: null,
          obis: "1-1:1.8.0",
          description: "HT",
          digits: "6",
          precision: "0",
          llc: "Z59",
          billingrelevant: true
        }
      ],
      additionalValues: []
    },
    contract_counters: [
      {
        createdAt: "2024-09-12 18:13:04",
        createdByAgent: "0",
        id: "2804320",
        counterNumber: "1HLY0200737683",
        counterSize: null,
        activeFrom: "2024-09-23 00:00:00",
        activeUntil: null,
        type: "EHZ",
        typeName: "Elektronischer Haushaltsz\xE4hler",
        energyDirection: "ZRZ",
        dataAcquisition: "MMR",
        tariffCount: "ETZ",
        exchangeType: null,
        exchangeValue: "1",
        registers: [
          {
            activeFrom: "2024-09-23 00:00:00",
            activeUntil: null,
            obis: "1-1:1.8.0",
            description: "HT",
            digits: "6",
            precision: "0",
            llc: "Z59",
            billingrelevant: true
          }
        ],
        additionalValues: []
      }
    ],
    product_version: {
      productId: "36",
      version: "21",
      status: "released",
      supplyType: "basic_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "both",
      pricingType: "quantity_scale_pricing",
      usageNtPercentage: "40",
      createdAt: "2018-09-27 16:20:42",
      updatedAt: "2018-09-27 16:20:42",
      releaseRequestedAt: null,
      releasedAt: "2024-01-23 16:20:43",
      deprecatedAt: null,
      lockedAt: null,
      name: "EWE Strom comfort",
      validFrom: "2014-12-05",
      validUntil: "9994-09-04",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "0",
      contractInitialDurationType: "days",
      contractExtensionTime: "0",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "14",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-4.json
var contract_request_customer_reading_4_default = {
  EventId: "438609527",
  EventName: "contract_tariff_change_revoke_rejected",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 4,
    contract: {
      id: "1002751928",
      accountId: "2654619",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: true,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: true,
      company: "Firma Anonym",
      countryId: "DE",
      zip: "26131",
      city: "Oldenburg",
      street: "Tegelkamp",
      houseNumber: "1",
      floor: null,
      phone: "01234 / 1234578",
      fax: "",
      email: "test.anonym@ewe.de",
      cancelledBy: "agent",
      cancellationReason: "K\xFCndigung durch Kunde",
      cancellationTriggeredDate: null,
      cancelledAt: "2024-03-12 00:00:00",
      filingDateCancellation: "2024-02-28",
      cancellationTechKey: "KUENDIGUNGKUNDE",
      cancellationSource: "cancellation",
      billing_salutation: "2",
      billing_title: "",
      billing_firstname: "Johanna",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_company: "Firma Anonym",
      billing_zip: "26123",
      billing_city: "Oldenburg",
      billing_street: "Maastrichter Str.",
      billing_houseNumber: "1",
      billing_phone: "01234 / 12345678",
      billing_fax: "",
      billing_email: "test.anonym@ewe.de",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "74754",
      counterType: "AHZ",
      counterTypeName: "Analoger Haushaltsz\xE4hler",
      invoice_email: "",
      invoice_phone: "",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50354293223",
      meterLocation: "DE0004962613100000000000010167063",
      complexSystem: false,
      customerId: "20802882",
      externalCustomerNumber: "",
      customerCommunicationType: "0",
      salutation: "1",
      firstname: "",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2022-12-06",
      dateOfRevocation: null,
      startDate: "2023-03-05",
      desiredStartDate: "2023-03-05",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-05-02",
      endDate: null,
      desiredEndDate: "2024-10-10",
      orderId: "2696652",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "relocation_at",
      signatureDate: "2022-11-20",
      netDeliveryStartConfirmed: "2022-11-22 05:35:00",
      netDeliveryEndConfirmed: null,
      usage: "5200",
      usageNet: "1916",
      usagePrevious: null,
      brandId: "1",
      directDebit: true,
      direction: "in",
      activeFrom: "2022-11-20",
      activeUntil: null,
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDIT BANK A.G. BERLIN",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0000202051",
      bankCode: "12030000",
      alternativeAccountHolder: "Test Test",
      sepaMandate: "EWE-20802882-1002751928-1",
      futureBankingData: [
        {
          activeFrom: "2022-11-20",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "out",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: ""
        },
        {
          activeFrom: "2022-11-20",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDIT BANK A.G. BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "in",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-20802882-1002751928-1"
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            id: 3501925,
            activeFrom: "2022-11-20",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDIT BANK A.G. BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "in",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20802882-1002751928-1"
          }
        ],
        out: [
          {
            id: 3501924,
            activeFrom: "2022-11-20",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "out",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: ""
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: null,
      cancellationPreviousProviderConfirmed: null,
      netDeliveryStartSent: "2022-11-21 09:19:53",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      nextCancellationDate: "2026-03-04",
      latestCancelationByCustomer: "2026-02-04",
      externalId: "1b373a36-aae4-4f1a-b075-42082c472b43",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "6"
          },
          MPKD: {
            technicalKey: "MPKD",
            createdAt: "2024-04-29 08:02:13",
            name: "Marktpartner",
            position: "15"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2023-07-20 15:33:39",
              position: "5",
              fieldValueId: "7195066"
            }
          ],
          MPKD: [
            {
              name: "Marktpartner",
              technicalKey: "MPKD",
              type: "select",
              value: "LVB",
              createdAt: "2024-09-27 12:24:19",
              position: "4",
              fieldValueId: "8031097"
            },
            {
              name: "Identifikationsnummer MP",
              technicalKey: "INMP",
              type: "text",
              value: "rzrezt43563456",
              createdAt: "2024-09-27 12:24:19",
              position: "5",
              fieldValueId: "8031098"
            }
          ]
        }
      },
      desiredInvoiceDate: null,
      invoicePeriodStartDate: "2023-03-05",
      invoicePeriodEndDate: "2024-03-04",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "CAIGVV",
      meterPricing: "included",
      cityId: "6410",
      additionalValues: []
    },
    contract_tariff_revoked: {
      id: "12060157",
      createdAt: "2024-08-28 14:27:45",
      product: "EWE business Gr\xFCnstrom basis",
      productCode: "ST-BU12BS-05",
      activeFrom: "2025-03-05",
      activeUntil: null,
      productEco: "1",
      productType: "standard",
      activeFromOriginal: null,
      basePrice: 219.36,
      meterCharge: "0",
      contractPrice: false,
      workingPrice: 29.45,
      complexPrice: false,
      overConsumptionWorkingPrice: "0",
      usageCustomer: "5200",
      productBonus: "0.000000",
      productBonusPercent: "0",
      instantBonus: "0",
      instantBonusDate: "2023-04-02",
      includeBonusInDepositCalculation: "0",
      fixedPriceType: "fix",
      fixedPriceDate: null,
      fixedPriceMonths: "12",
      priceKey: "ST-BU12BS-05",
      priceAdjustmentOf: null,
      priceAdjustmentReason: null,
      billingPeriod: "12",
      minimumRuntime: "12",
      extensionTime: "1",
      cancellationPeriod: "1",
      contractProductId: "3708762",
      waitForConfirmationUntil: null,
      confirmedAt: null,
      energyTax: 0.19,
      depositDivisor: "12",
      tariffChangeDate: null,
      basePriceNetto: 184.34,
      workingPriceNetto: 24.7479,
      productBonusNetto: 0,
      instantBonusNetto: 0,
      basePriceTax: 35.02,
      workingPriceTax: 4.7021,
      productBonusTax: 0,
      instantBonusTax: 0,
      instantBonusTaxRate: 19,
      additionalValues: [],
      calculatedFixedPriceDate: null,
      meterPricing: "included",
      flexbonus: [],
      minimumConsumption: null,
      additionalTerminationRightBeforeDelivery: false,
      contractTariffSpecialTerminationExemption: false
    },
    contract_tariff_revoke_date: {
      date: "2024-09-24 00:00:00.000000",
      timezone_type: 3,
      timezone: "Europe/Berlin"
    },
    revoking_error_message: "Revocation manually refused",
    order: {
      id: "2696652",
      createdAt: "2023-07-20 15:33:32",
      orderedAt: "2023-07-20 15:33:32",
      status: "done",
      revokedAt: null,
      relevantStreet: "0",
      zip: "26131",
      city: "Oldenburg",
      street: "Tegelkamp",
      houseNumber: "1",
      business: "1",
      company: "Firma Anonym",
      customerId: "20802882",
      salutation: "2",
      firstname: "Johanna",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: "1b373a36-aae4-4f1a-b075-42082c472b43",
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "01234567",
      phoneHomeAreaCode: "0123",
      phoneHome: "01234567",
      phoneBusinessAreaCode: "0123",
      phoneBusiness: "01234567",
      emailPrivate: "test.anonym@ewe.de",
      emailBusiness: "test.anonym@ewe.de",
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "1",
      billing_company: null,
      billing_salutation: "2",
      billing_title: null,
      billing_firstname: "Johanna",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_zip: "26123",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      billing_city: "Oldenburg",
      billing_street: "Maastrichter Str.",
      billing_houseNumber: "1",
      billing_fax: "",
      billing_phone: "0123 / 0123456",
      billing_email: "test.anonym@ewe.de",
      relocationAddressTransfer: "",
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      alternativeAccountHolder: null,
      directDebit: true,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "INBOUND",
      campaignId: "11",
      exportAt: "2023-07-20",
      salesChannel: "any",
      inputChannel: "phone",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "",
      previousProviderCodeNumber: "9903324000006",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900496000005",
      netCodeNumberProvider: "bdew",
      customerNumber: null,
      customerSpecification: "relocation_at",
      relocationAt: "2023-11-02",
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: null,
      provider: "EWE VERTRIEB GmbH",
      providerId: "-7",
      product: "EWE business Strom 12",
      productId: "1857",
      productCode: "ST-BU12XX-01",
      productEco: "1",
      variant: "0",
      productType: "standard",
      priceKey: "ST-BU12XX-01",
      counterNumber: "S02302AAD74754",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "5200",
      complexPrice: false,
      productWorkingPrice: "30.66",
      productBasePrice: "248.14",
      overConsumptionWorkingPrice: "0",
      productWorkingPriceNetto: "25.7647",
      productBasePriceNetto: "208.52",
      productBonusNetto: "0",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productWorkingPriceTax: "4.8953",
      productBasePriceTax: "39.62",
      productBonusTax: "0",
      productInstantBonusTax: "0",
      productBonus: "0.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "months_price_excluding_vat_and_new_taxes",
      fixedPriceMonths: "12",
      fixedPriceDate: null,
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      ediProcessId: null,
      vpCode: "93450",
      uvpCode: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "6"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2023-07-20 15:33:34",
              position: "5",
              fieldValueId: "7195065"
            }
          ]
        }
      },
      createdBy: "12",
      signatureDate: "2023-07-20",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-09-26 14:59:59",
      zip: "26123",
      city: "Oldenburg",
      street: "Maastrichter Str.",
      houseNumber: "1",
      country: "DE",
      countryName: "Deutschland",
      business: "1",
      unknown: "0",
      company: "Firma Anonym",
      countryId: "48",
      customerId: "20802882",
      status: "active",
      externalId: "",
      salutation: "1",
      firstname: "",
      title: "",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "12345678",
      phoneHomeAreaCode: "01234",
      phoneHome: "12345678",
      phoneBusinessAreaCode: "1234",
      phoneBusiness: "12345678",
      emailPrivate: 'marco&"?.#wer2@ewe.de',
      emailBusiness: "test.anonym@ewe.de",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "5"
          },
          QUALITAET_KUNDENDATEN: {
            technicalKey: "QUALITAET_KUNDENDATEN",
            createdAt: "2023-10-06 13:50:45",
            name: "Qualit\xE4t Kundendaten",
            position: "19"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2023-02-18 05:01:13",
              position: "5",
              fieldValueId: "6645922"
            }
          ],
          QUALITAET_KUNDENDATEN: [
            {
              name: "Qualifizierung E-Mail",
              technicalKey: "QUALITAET_EMAIL",
              type: "date",
              value: "2023-10-19",
              createdAt: "2023-10-19 08:11:47",
              position: "6",
              fieldValueId: "7440589"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "1880640",
      clientId: "3",
      identifier: "50354293223",
      additionalValues: [],
      note: null
    },
    contract_tariff: {
      id: "12060152",
      createdAt: "2024-02-28 13:10:53",
      product: "EWE business Gr\xFCnstrom basis",
      productCode: "ST-BU12BS-05",
      activeFrom: "2024-03-05",
      activeUntil: "2025-03-04",
      productEco: "1",
      productType: "standard",
      activeFromOriginal: null,
      basePrice: 219.36,
      meterCharge: "0",
      contractPrice: false,
      workingPrice: 29.45,
      complexPrice: false,
      overConsumptionWorkingPrice: "0",
      usageCustomer: "5200",
      productBonus: "0.000000",
      productBonusPercent: "0",
      instantBonus: "0",
      instantBonusDate: "2023-04-02",
      includeBonusInDepositCalculation: "0",
      fixedPriceType: "fix",
      fixedPriceDate: null,
      fixedPriceMonths: "12",
      priceKey: "ST-BU12BS-05",
      priceAdjustmentOf: null,
      priceAdjustmentReason: null,
      billingPeriod: "12",
      minimumRuntime: "12",
      extensionTime: "1",
      cancellationPeriod: "1",
      contractProductId: "3708757",
      waitForConfirmationUntil: null,
      confirmedAt: null,
      energyTax: 0.19,
      depositDivisor: "12",
      tariffChangeDate: null,
      basePriceNetto: 184.34,
      workingPriceNetto: 24.7479,
      productBonusNetto: 0,
      instantBonusNetto: 0,
      basePriceTax: 35.02,
      workingPriceTax: 4.7021,
      productBonusTax: 0,
      instantBonusTax: 0,
      instantBonusTaxRate: 19,
      additionalValues: [],
      calculatedFixedPriceDate: null,
      meterPricing: "included",
      flexbonus: [],
      minimumConsumption: null,
      additionalTerminationRightBeforeDelivery: false,
      contractTariffSpecialTerminationExemption: false
    },
    contract_product: {
      contractProductId: "3708756",
      createdAt: "2024-02-28 13:09:30",
      productName: "EWE business Gr\xFCnstrom basis",
      productCode: "ST-BU12BS-05",
      productVersion: "10",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-03-05",
      activeUntil: "2024-03-05",
      contractProductStatus: "revoked",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    product_version: {
      productId: "237",
      version: "10",
      status: "released",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "business",
      pricingType: "fixed_pricing",
      usageNtPercentage: null,
      createdAt: "2023-05-29 14:52:23",
      updatedAt: "2023-05-29 14:52:23",
      releaseRequestedAt: null,
      releasedAt: "2024-09-24 14:52:24",
      deprecatedAt: null,
      lockedAt: null,
      name: "EWE business Gr\xFCnstrom basis",
      validFrom: "2023-02-03",
      validUntil: "9998-09-03",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "1",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "1",
      contractCancellationPeriodType: "months",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-5.json
var contract_request_customer_reading_5_default = {
  EventId: "438609527",
  EventName: "contract_tariff_change_revoke_rejected",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 5,
    contract: {
      id: "1003025585",
      accountId: "2928307",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "27389",
      city: "Fintel",
      street: "Lauenbr\xFCcker Str.",
      houseNumber: "6",
      floor: null,
      phone: "",
      fax: "",
      email: "",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "9",
      billing_title: null,
      billing_firstname: "",
      billing_surname: "Gerhard J\xFCrges",
      billing_careOfRecipient: "",
      billing_company: "",
      billing_zip: "27389",
      billing_city: "Fintel",
      billing_street: "Lauenbr\xFCcker Str.",
      billing_houseNumber: "6",
      billing_phone: "",
      billing_fax: "",
      billing_email: "",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "1EMH0010463413",
      counterType: "MME",
      counterTypeName: "moderne Messeinrichtung",
      invoice_email: "",
      invoice_phone: "",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50360283763",
      meterLocation: "DE0004962738900000000000010957404",
      complexSystem: false,
      customerId: "21723582",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "9",
      firstname: null,
      surname: "Gerhard J\xFCrges",
      dateOfBirth: null,
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2024-12-11",
      dateOfRevocation: null,
      startDate: "2024-12-05",
      desiredStartDate: "2024-12-05",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-06-05",
      endDate: null,
      desiredEndDate: null,
      orderId: "2975945",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "basic_supply_registration",
      signatureDate: "2024-12-05",
      netDeliveryStartConfirmed: "2024-11-27 00:00:00",
      netDeliveryEndConfirmed: null,
      usage: "5053",
      usageNet: "5053",
      usagePrevious: null,
      brandId: "1",
      directDebit: false,
      direction: null,
      activeFrom: null,
      activeUntil: null,
      iban: null,
      bic: null,
      bank: null,
      paymentProvider: "SEPA Bank",
      replacedBankId: null,
      bankAccountNumber: "",
      bankCode: "",
      alternativeAccountHolder: null,
      sepaMandate: null,
      futureBankingData: [],
      InOutActiveBankingData: {
        in: [],
        out: []
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: null,
      cancellationPreviousProviderConfirmed: null,
      netDeliveryStartSent: null,
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      nextCancellationDate: "2025-12-19",
      latestCancelationByCustomer: "2025-11-19",
      externalId: null,
      externalOrderId: null,
      extendedData: {
        categories: {},
        values: {}
      },
      desiredInvoiceDate: null,
      invoicePeriodStartDate: "2024-12-05",
      invoicePeriodEndDate: "2025-12-04",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "CAIGVV",
      meterPricing: "included",
      cityId: "6614",
      additionalValues: []
    },
    contract_tariff_revoked: {
      id: "12340086",
      createdAt: "2024-12-19 15:34:56",
      product: "EWE Gr\xFCnstrom basis",
      productCode: "ST-BS12XX-05",
      activeFrom: "2024-12-20",
      activeUntil: null,
      productEco: "1",
      productType: "standard",
      activeFromOriginal: null,
      basePrice: 204.97,
      meterCharge: "0",
      contractPrice: false,
      workingPrice: 29.13,
      complexPrice: false,
      overConsumptionWorkingPrice: "0",
      usageCustomer: "5053",
      productBonus: "0.000000",
      productBonusPercent: "0",
      instantBonus: "0",
      instantBonusDate: "2025-01-02",
      includeBonusInDepositCalculation: "0",
      fixedPriceType: "fix",
      fixedPriceDate: null,
      fixedPriceMonths: "12",
      priceKey: "ST-BS12XX-05",
      priceAdjustmentOf: null,
      priceAdjustmentReason: null,
      billingPeriod: "12",
      minimumRuntime: "12",
      extensionTime: "1",
      cancellationPeriod: "1",
      contractProductId: "3712535",
      waitForConfirmationUntil: null,
      confirmedAt: null,
      energyTax: 0.19,
      depositDivisor: "12",
      tariffChangeDate: null,
      basePriceNetto: 172.24,
      workingPriceNetto: 24.479,
      productBonusNetto: 0,
      instantBonusNetto: 0,
      basePriceTax: 32.73,
      workingPriceTax: 4.651,
      productBonusTax: 0,
      instantBonusTax: 0,
      instantBonusTaxRate: 19,
      additionalValues: [],
      calculatedFixedPriceDate: null,
      meterPricing: "included",
      flexbonus: [],
      minimumConsumption: null,
      additionalTerminationRightBeforeDelivery: false,
      contractTariffSpecialTerminationExemption: false
    },
    contract_tariff_revoke_date: "2024-12-19",
    contract_tariff_change_next_product: {
      contractProductId: "3710812",
      createdAt: "2024-11-27 00:35:37",
      productName: "EWE Strom Ersatzversorgung",
      productCode: "ST-ERSAXX-PC",
      productVersion: "33",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-11-27",
      activeUntil: "2024-12-19",
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_tariff_revoked_campaign: {
      createdAt: "2020-05-07 09:01:39",
      releaseDelayDays: "0",
      name: "Produktwechsel",
      identifier: "PRODUKTWECHSEL",
      description: "Produktwechsel-Kampagne",
      default: "0",
      campaignType: "tariff_change",
      productType: "electricity_gas",
      salesChannel: "any",
      targetGroup: "mixed",
      active: "1",
      deleted: "0",
      deletedAt: null,
      exclusive: "0",
      validFrom: "2020-04-01",
      validTo: "9999-12-31",
      priority: "20",
      ignorePriceCheck: "0",
      upperWorkingPriceTolerance: "0.00",
      lowerWorkingPriceTolerance: "0.00",
      upperBasePriceTolerance: "0.00",
      lowerBasePriceTolerance: "0.00"
    },
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE81280200501446416800",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "18",
          data: {
            id: "18",
            type: "",
            iban: "DE22280400460405354200",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "19",
          data: {
            id: "19",
            type: "",
            iban: "DE11280400460405354204",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    order: {
      id: "2975945",
      createdAt: "2024-11-27 00:33:37",
      orderedAt: "2024-11-27 00:33:37",
      status: "done",
      revokedAt: null,
      relevantStreet: "0",
      zip: "27389",
      city: "Fintel",
      street: "Lauenbr\xFCcker Str.",
      houseNumber: "6",
      business: "0",
      company: null,
      customerId: "21723582",
      salutation: "9",
      firstname: null,
      surname: "Gerhard J\xFCrges",
      dateOfBirth: null,
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: null,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "0",
      billing_company: null,
      billing_salutation: "9",
      billing_title: null,
      billing_firstname: null,
      billing_surname: "Gerhard J\xFCrges",
      billing_careOfRecipient: "",
      billing_zip: "27389",
      billing_country: "",
      billing_countryAlpha2: "",
      billing_city: "Fintel",
      billing_street: "Lauenbr\xFCcker Str.",
      billing_houseNumber: "6",
      billing_fax: "",
      billing_phone: null,
      billing_email: null,
      relocationAddressTransfer: "",
      iban: null,
      bic: null,
      bank: null,
      alternativeAccountHolder: null,
      directDebit: false,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "GRUNDVERSORGUNG",
      campaignId: "24",
      exportAt: "2024-11-27",
      salesChannel: "any",
      inputChannel: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "",
      previousProviderCodeNumber: "9903324000006",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900496000005",
      netCodeNumberProvider: "bdew",
      customerNumber: null,
      customerSpecification: "basic_supply_registration",
      relocationAt: null,
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: "2024-12-05",
      provider: "EWE VERTRIEB GmbH",
      providerId: "-7",
      product: "EWE Strom Ersatzversorgung",
      productId: "2887",
      productCode: "ST-ERSAXX-PC",
      productEco: "0",
      variant: "0",
      productType: "standard",
      priceKey: "ST-ERSAXX-PC",
      counterNumber: "1EMH0010463413",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "5053",
      complexPrice: true,
      complexUsages: {
        id: "1342940",
        data: {
          complexUsage: {
            totalUsage: 5053,
            usageForCalculation: 5053,
            usages: [
              {
                registerName: "HT",
                usage: 5053
              }
            ]
          }
        },
        additionalData: []
      },
      complexPrices: {
        id: "2841604",
        data: {
          complexPrice: [
            {
              usageFrom: 0,
              usageUntil: 1e5,
              basePriceNetto: "173.6218",
              basePriceBrutto: "206.61",
              basePriceTax: "32.9882",
              basePriceTaxRate: "19",
              workingPrices: [
                {
                  registerName: "HT",
                  workingPriceNetto: "35.2941",
                  workingPriceBrutto: "42",
                  workingPriceTax: "6.7059",
                  workingPriceTaxRate: "19"
                }
              ]
            }
          ],
          meterPrices: []
        },
        additionalData: []
      },
      overConsumptionWorkingPrice: "0",
      productBonusNetto: "0",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productBonusTax: "0",
      productInstantBonusTax: "0",
      productBonus: "0.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "none",
      fixedPriceMonths: null,
      fixedPriceDate: null,
      cancellationPeriod: "0",
      cancellationPeriodUnit: "days",
      minimumRuntime: "0",
      minimumRuntimeUnit: "days",
      extensionTime: "0",
      extensionTimeUnit: "days",
      ediProcessId: "147891813",
      vpCode: null,
      uvpCode: null,
      extendedData: {
        categories: {},
        values: {}
      },
      createdBy: "11",
      signatureDate: "2024-12-05",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-11-27 00:33:23",
      zip: "27389",
      city: "Fintel",
      street: "Lauenbr\xFCcker Str.",
      houseNumber: "6",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: null,
      company: null,
      countryId: "48",
      customerId: "21723582",
      status: "active",
      externalId: null,
      salutation: "9",
      firstname: null,
      title: null,
      surname: "Gerhard J\xFCrges",
      dateOfBirth: null,
      availableSentNotification: "0",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "5"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2024-11-27 05:01:14",
              position: "5",
              fieldValueId: "8033757"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    contract_status: {
      id: "1003025585",
      changedAt: "2024-12-05 00:00:07",
      statusCode: "5000"
    },
    market_location: {
      id: "1956588",
      clientId: "3",
      identifier: "50360283763",
      additionalValues: [],
      note: null
    },
    contract_tariff: {
      id: "12246730",
      createdAt: "2024-11-27 00:35:37",
      product: "EWE Strom Ersatzversorgung",
      productCode: "ST-ERSAXX-PC",
      activeFrom: "2024-11-27",
      activeUntil: "2024-12-19",
      productEco: "0",
      productType: "standard",
      activeFromOriginal: null,
      meterCharge: "0",
      contractPrice: false,
      complexPrice: true,
      complexPrices: {
        id: "32052492",
        data: {
          complexPrice: [
            {
              usageFrom: "0",
              usageUntil: "100000",
              workingPrices: [
                {
                  registerName: "HT",
                  workingPriceNetto: "35.2941",
                  workingPriceBrutto: "42",
                  workingPriceTax: "6.7059",
                  workingPriceTaxRate: "19"
                }
              ],
              basePriceNetto: "173.6218",
              basePriceBrutto: "206.61",
              basePriceTax: "32.9882",
              basePriceTaxRate: "19"
            }
          ]
        },
        additionalData: []
      },
      overConsumptionWorkingPrice: "0",
      usageCustomer: "5053",
      productBonus: "0.000000",
      productBonusPercent: "0",
      instantBonus: "0",
      instantBonusDate: "2025-01-02",
      includeBonusInDepositCalculation: "0",
      fixedPriceType: "none",
      fixedPriceDate: null,
      fixedPriceMonths: null,
      priceKey: "ST-ERSAXX-PC",
      priceAdjustmentOf: null,
      priceAdjustmentReason: null,
      billingPeriod: "12",
      minimumRuntime: "0",
      extensionTime: "0",
      cancellationPeriod: "0",
      contractProductId: "3710812",
      waitForConfirmationUntil: null,
      confirmedAt: null,
      energyTax: 0.19,
      depositDivisor: "12",
      tariffChangeDate: null,
      basePriceNetto: 0,
      workingPriceNetto: 0,
      productBonusNetto: 0,
      instantBonusNetto: 0,
      basePriceTax: 0,
      workingPriceTax: 0,
      productBonusTax: 0,
      instantBonusTax: 0,
      instantBonusTaxRate: 19,
      additionalValues: [],
      calculatedFixedPriceDate: null,
      meterPricing: "included",
      flexbonus: [],
      minimumConsumption: null,
      additionalTerminationRightBeforeDelivery: false,
      contractTariffSpecialTerminationExemption: false
    },
    contract_product: {
      contractProductId: "3710812",
      createdAt: "2024-11-27 00:35:37",
      productName: "EWE Strom Ersatzversorgung",
      productCode: "ST-ERSAXX-PC",
      productVersion: "33",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-11-27",
      activeUntil: "2024-12-19",
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    product_version: {
      productId: "42",
      version: "33",
      status: "released",
      supplyType: "fallback_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "private",
      pricingType: "quantity_scale_pricing",
      usageNtPercentage: "40",
      createdAt: "2024-09-24 15:14:54",
      updatedAt: "2024-09-24 15:16:10",
      releaseRequestedAt: null,
      releasedAt: "2024-09-24 15:16:10",
      deprecatedAt: null,
      lockedAt: null,
      name: "EWE Strom Ersatzversorgung",
      validFrom: "2021-01-01",
      validUntil: "9999-12-31",
      kind: "contract",
      eco: "none",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "0",
      contractInitialDurationType: "days",
      contractExtensionTime: "0",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "0",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: "4"
    }
  }
};

// src/examples/contract/contract-request-customer-reading-6.json
var contract_request_customer_reading_6_default = {
  EventId: "438609527",
  EventName: "contract_tariff_change_revoke_rejected",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 84,
    disconnection_fee: "2333",
    contract: {
      id: "1000165246",
      accountId: "67525",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: true,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "26789",
      city: "Leer",
      street: "H\xE4ndelstr.",
      houseNumber: "1",
      floor: null,
      phone: "01234 / 1234578",
      fax: "",
      email: "test.anonym@ewe.de",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "1",
      billing_title: "",
      billing_firstname: "Manuel",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_company: "Firma Anonym",
      billing_zip: "26789",
      billing_city: "Leer",
      billing_street: "H\xE4ndelstr.",
      billing_houseNumber: "1",
      billing_phone: "01234 / 12345678",
      billing_fax: "",
      billing_email: "test.anonym@ewe.de",
      billing_country: "",
      billing_countryAlpha2: "",
      counterNumber: "1EMH0006065462",
      counterType: "EHZ",
      counterTypeName: "Elektronischer Haushaltsz\xE4hler",
      invoice_email: "test.anonym@ewe.de",
      invoice_phone: "01234 / 12345678",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50358302947",
      meterLocation: "DE0004962678900000000000010461451",
      complexSystem: false,
      customerId: "20060748",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "1",
      firstname: "Manuel",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2020-08-11",
      dateOfRevocation: null,
      startDate: "2020-08-24",
      desiredStartDate: "2020-08-24",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-03-22",
      endDate: null,
      desiredEndDate: null,
      orderId: "69812",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "desired_date",
      signatureDate: "2020-07-27",
      netDeliveryStartConfirmed: "2020-07-28 06:48:00",
      netDeliveryEndConfirmed: null,
      usage: "2681",
      usageNet: "2720",
      usagePrevious: "2712",
      brandId: "1",
      directDebit: true,
      direction: "inout",
      activeFrom: "2020-07-27",
      activeUntil: null,
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0000202051",
      bankCode: "12030000",
      alternativeAccountHolder: "Test Test",
      sepaMandate: "EWE-20060748-1000165246-1",
      futureBankingData: [
        {
          activeFrom: "2020-07-27",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "inout",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-20060748-1000165246-1"
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            id: 58206,
            activeFrom: "2020-07-27",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20060748-1000165246-1"
          }
        ],
        out: [
          {
            id: 58206,
            activeFrom: "2020-07-27",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20060748-1000165246-1"
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: "2020-07-27 19:37:18",
      cancellationPreviousProviderConfirmed: "2020-08-23 00:00:00",
      netDeliveryStartSent: "2020-07-28 06:39:41",
      minimumRuntime: "24",
      minimumRuntimeUnit: "months",
      extensionTime: "12",
      extensionTimeUnit: "months",
      cancellationPeriod: "28",
      cancellationPeriodUnit: "days",
      nextCancellationDate: "2025-08-23",
      latestCancelationByCustomer: "2025-07-26",
      externalId: "e02a2dab-c30f-4b44-be39-d49cbb85246b",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "5"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2020-09-11 12:00:00",
              position: "2",
              fieldValueId: "28606"
            }
          ]
        }
      },
      desiredInvoiceDate: "2025-08-23",
      invoicePeriodStartDate: "2024-08-24",
      invoicePeriodEndDate: "2025-08-23",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "kein Mahnverfahren hinterlegt (JDS)",
      meterPricing: "included",
      cityId: "6496",
      additionalValues: []
    },
    contractId: 1000165246,
    notificationType: "GVV-Mahn",
    contract_dunned_receivables: [
      {
        id: 149619409,
        bookingNumber: 252673552,
        payableAt: "2025-02-01",
        chargedDepositForMonth: "2025-01-02",
        type: "deposit",
        grossAmount: 86,
        settledAmount: 0,
        tax: "19.00",
        notice: "Abschlag (Strom) Februar / 2025 Kunden-Nr. 20060748 / 1000165246",
        contractId: 1000165246,
        level: 2,
        levelName: "Mahnung",
        settlementDeadline: "2025-03-14",
        unsettledAmount: 86,
        dunnable: true,
        netAmount: 69.66,
        taxAmount: 16.34
      },
      {
        id: 150629859,
        bookingNumber: 253680014,
        payableAt: "2024-12-07",
        type: "deposit",
        grossAmount: 86,
        settledAmount: 0,
        tax: 0,
        notice: "Manuelle Buchung",
        contractId: 1000165246,
        level: 2,
        levelName: "Mahnung",
        settlementDeadline: "2025-03-14",
        unsettledAmount: 86,
        chargedDepositForMonth: null,
        dunnable: true,
        netAmount: 69.66,
        taxAmount: 16.34
      },
      {
        id: 150629860,
        bookingNumber: 253680015,
        payableAt: "2024-12-09",
        type: "deposit",
        grossAmount: 86,
        settledAmount: 0,
        tax: 19,
        notice: "Manuelle Buchung",
        contractId: 1000165246,
        level: 2,
        levelName: "Mahnung",
        settlementDeadline: "2025-03-14",
        unsettledAmount: 86,
        chargedDepositForMonth: null,
        dunnable: true,
        netAmount: 69.66,
        taxAmount: 16.34
      }
    ],
    contract_total_dunned_unpaid: 258,
    highest_dunning_level: {
      level: 2,
      levelName: "Mahnung"
    },
    additional_fee_amount: 2,
    settlement_deadline: "2025-03-14",
    contract_dunning_additional_receivables: [
      {
        bookingNumber: 253680019,
        payableAt: "2025-01-05",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 150629863,
        netAmount: 2,
        taxAmount: 0
      },
      {
        bookingNumber: 253680020,
        payableAt: "2025-01-05",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 150629864,
        netAmount: 2,
        taxAmount: 0
      }
    ],
    contract_dunnable_net: 208.98,
    contract_dunnable_tax: 49.02,
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE11280400460405354204",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    customer: {
      authorizedAt: null,
      createdAt: "2020-08-26 19:37:17",
      zip: "26789",
      city: "Leer",
      street: "H\xE4ndelstr.",
      houseNumber: "1",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "20060748",
      status: "active",
      externalId: null,
      salutation: "1",
      firstname: "Manuel",
      title: null,
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "12345678",
      phoneHomeAreaCode: "01234",
      phoneHome: "12345678",
      phoneBusinessAreaCode: "1234",
      phoneBusiness: "12345678",
      emailPrivate: "test.anonym@ewe.de",
      emailBusiness: "test.anonym@ewe.de",
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "4"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2022-07-29 09:57:01",
              position: "2",
              fieldValueId: "4415811"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "56424",
      clientId: "3",
      identifier: "50358302947",
      additionalValues: [],
      note: null
    },
    contract_product: {
      contractProductId: "65192",
      createdAt: "2020-07-27 19:37:18",
      productName: "Strom Zuhause+ (24 Monate)",
      productCode: "ST-ZH24XX-PC",
      productVersion: "5",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2020-08-24",
      activeUntil: null,
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_deposit: {
      id: 18482850,
      clientId: 3,
      contractId: 1000165246,
      contractTariffId: 16420674,
      createdAt: "2024-08-24 00:00:30",
      createdBy: null,
      activeFrom: "2024-08-25",
      activeUntil: null,
      updatedAt: "2024-08-24 00:00:30",
      updatedBy: null,
      grossAmount: 86,
      blockedUntil: null,
      alternativeDayOfMonth: "1",
      nextGenerationAt: "2025-02-19",
      ruleId: "11",
      techKey: "default",
      isSplitted: "0",
      depositSplits: [],
      netAmount: 72.27,
      taxRate: 0.19,
      taxAmount: 13.73,
      nextExecution: {
        useAt: "2025-03-03",
        useFor: "2025-02-01",
        generateAt: "2025-02-19",
        sepaGenerateAt: "2025-02-26"
      }
    },
    contract_banking_data: [
      {
        id: "58206",
        iban: "DE02120300000000202051",
        bic: "BYLADEM1001",
        bank: "DEUTSCHE KREDITBANK BERLIN",
        activeFrom: "2020-07-27",
        activeUntil: null,
        sepaMandate: "EWE-20060748-1000165246-1",
        accountHolder: "Test Test",
        direction: "inout",
        directDebit: "1",
        createdAt: "2020-07-27 19:37:18"
      }
    ],
    product_version: {
      productId: "32",
      version: "5",
      status: "deprecated",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "both",
      pricingType: "fixed_pricing",
      usageNtPercentage: "40",
      createdAt: "2011-07-26 16:15:32",
      updatedAt: "2011-07-26 16:15:32",
      releaseRequestedAt: null,
      releasedAt: "2020-08-10 16:15:32",
      deprecatedAt: "2020-12-11 18:38:51",
      lockedAt: null,
      name: "Strom Zuhause+ (24 Monate)",
      validFrom: "2011-03-17",
      validUntil: "9990-12-15",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "24",
      contractInitialDurationType: "months",
      contractExtensionTime: "12",
      contractExtensionTimeType: "months",
      contractCancellationPeriod: "28",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "<p>Stand AGB: 05/2020</p>",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-7.json
var contract_request_customer_reading_7_default = {
  EventId: "438609527",
  EventName: "contract_tariff_change_revoke_rejected",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 84,
    contract: {
      id: "1000221409",
      accountId: "123719",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "26789",
      city: "Leer",
      street: "Hoheellernweg",
      houseNumber: "1",
      floor: null,
      phone: "01234 / 1234578",
      fax: "",
      email: "test.anonym@ewe.de",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "2",
      billing_title: "",
      billing_firstname: "Claudia",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_company: null,
      billing_zip: "26789",
      billing_city: "Leer",
      billing_street: "Hoheellernweg",
      billing_houseNumber: "1",
      billing_phone: "012312345678",
      billing_fax: "",
      billing_email: "",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "1HLY0201130802",
      counterType: "MME",
      counterTypeName: "moderne Messeinrichtung",
      invoice_email: "test.anonym@ewe.de",
      invoice_phone: "01234 / 12345678",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50358198156",
      meterLocation: "DE0004962678900000000000010133582",
      complexSystem: false,
      customerId: "20099590",
      externalCustomerNumber: "",
      customerCommunicationType: "0",
      salutation: "2",
      firstname: "Claudia",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2020-08-23",
      dateOfRevocation: null,
      startDate: "2020-08-03",
      desiredStartDate: "2020-08-03",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-04-30",
      endDate: null,
      desiredEndDate: null,
      orderId: "127851",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "relocation_at",
      signatureDate: "2020-08-08",
      netDeliveryStartConfirmed: "2020-08-09 03:33:00",
      netDeliveryEndConfirmed: null,
      usage: "2466",
      usageNet: "4683",
      usagePrevious: null,
      brandId: "1",
      directDebit: false,
      direction: "inout",
      activeFrom: "2020-08-08",
      activeUntil: null,
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0000202051",
      bankCode: "12030000",
      alternativeAccountHolder: "Test Test",
      sepaMandate: "EWE-20099590-1000221409-1",
      futureBankingData: [
        {
          activeFrom: "2020-08-08",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: false,
          direction: "inout",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-20099590-1000221409-1"
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            id: 103714,
            activeFrom: "2020-08-08",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: false,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20099590-1000221409-1"
          }
        ],
        out: [
          {
            id: 103714,
            activeFrom: "2020-08-08",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: false,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20099590-1000221409-1"
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: null,
      cancellationPreviousProviderConfirmed: null,
      netDeliveryStartSent: "2020-08-08 10:20:07",
      minimumRuntime: "24",
      minimumRuntimeUnit: "months",
      extensionTime: "12",
      extensionTimeUnit: "months",
      cancellationPeriod: "28",
      cancellationPeriodUnit: "days",
      nextCancellationDate: "2025-08-02",
      latestCancelationByCustomer: "2025-07-05",
      externalId: "58e88df6-c833-4a43-acfd-71d55b60b559",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "5"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "Brief",
              createdAt: "2020-11-06 10:17:29",
              position: "2",
              fieldValueId: "253570"
            }
          ]
        }
      },
      desiredInvoiceDate: "2025-08-02",
      invoicePeriodStartDate: "2024-08-03",
      invoicePeriodEndDate: "2025-08-02",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "kein Mahnverfahren hinterlegt (JDS)",
      meterPricing: "included",
      cityId: "6496",
      additionalValues: []
    },
    contractId: 1000221409,
    notificationType: "disconnection_announcement",
    contract_dunned_receivables: [
      {
        id: 146852245,
        bookingNumber: 248523206,
        payableAt: "2024-11-05",
        chargedDepositForMonth: "2024-10-03",
        type: "deposit",
        grossAmount: 80,
        settledAmount: 0,
        tax: 19,
        notice: "Abschlag (Strom) Januar / 2025 Kunden-Nr. 20099590 / 1000221409",
        contractId: 1000221409,
        level: 4,
        levelName: "Sperrank\xFCndigung",
        settlementDeadline: "2025-03-13",
        unsettledAmount: 80,
        dunnable: true,
        netAmount: 64.8,
        taxAmount: 15.2
      },
      {
        id: 150022359,
        bookingNumber: 253075807,
        payableAt: "2024-12-03",
        chargedDepositForMonth: "2024-11-03",
        type: "deposit",
        grossAmount: 80,
        settledAmount: 0,
        tax: 19,
        notice: "Abschlag (Strom) Februar / 2025 Kunden-Nr. 20099590 / 1000221409",
        contractId: 1000221409,
        level: 4,
        levelName: "Sperrank\xFCndigung",
        settlementDeadline: "2025-03-13",
        unsettledAmount: 80,
        dunnable: true,
        netAmount: 64.8,
        taxAmount: 15.2
      },
      {
        id: 150630041,
        bookingNumber: 253680197,
        payableAt: "2024-11-04",
        type: "deposit",
        grossAmount: 200,
        settledAmount: 0,
        tax: 19,
        notice: "Manuelle Buchung",
        contractId: 1000221409,
        level: 4,
        levelName: "Sperrank\xFCndigung",
        settlementDeadline: "2025-03-13",
        unsettledAmount: 200,
        chargedDepositForMonth: null,
        dunnable: true,
        netAmount: 162,
        taxAmount: 38
      }
    ],
    contract_total_dunned_unpaid: 360,
    highest_dunning_level: {
      level: 4,
      levelName: "Sperrank\xFCndigung"
    },
    market_partner_id: 4033872000058,
    market_location_identifier: "50358198156",
    disconnection_fee: 1,
    settlement_deadline: "2025-03-13",
    installmentPlan: {
      id: 171140,
      clientId: 3,
      accountId: 123719,
      isActive: "0",
      useDirectDebit: "0",
      createdAt: "2025-03-06 10:09:53",
      templateId: "13",
      total_receivable_amount: "546.00",
      total_overdue_receivable_amount: "544.00",
      total_installment_amount: "360.00",
      total_settled_installment_amount: "268.00",
      total_unsettled_installment_amount: "360.00",
      excluded_receivables: [
        {
          id: "146852245",
          data: {
            id: "146852245",
            bookingNumber: "248523206",
            createdAt: "2024-10-24 17:59:31",
            type: "deposit",
            energy: "electricity",
            payableAt: "2024-11-05",
            grossAmount: 80,
            settledAmount: 0,
            tax: "19.00",
            notice: "Abschlag (Strom) Januar / 2025 Kunden-Nr. 20099590 / 1000221409",
            dunnable: true,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 80
          },
          additionalData: []
        },
        {
          id: "150022359",
          data: {
            id: "150022359",
            bookingNumber: "253075807",
            createdAt: "2024-11-26 18:05:19",
            type: "deposit",
            energy: "electricity",
            payableAt: "2024-12-03",
            grossAmount: 80,
            settledAmount: 0,
            tax: "19.00",
            notice: "Abschlag (Strom) Februar / 2025 Kunden-Nr. 20099590 / 1000221409",
            dunnable: true,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 80
          },
          additionalData: []
        },
        {
          id: "150630041",
          data: {
            id: "150630041",
            bookingNumber: "253680197",
            createdAt: "2024-12-05 16:20:09",
            type: "deposit",
            energy: "electricity",
            payableAt: "2024-11-04",
            grossAmount: 200,
            settledAmount: 0,
            tax: "19.00",
            notice: "Manuelle Buchung",
            dunnable: true,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 200
          },
          additionalData: []
        },
        {
          id: "150630042",
          data: {
            id: "150630042",
            bookingNumber: "253680198",
            createdAt: "2024-12-05 16:20:09",
            type: "disconnection_fee",
            energy: "electricity",
            payableAt: "2024-11-12",
            grossAmount: 65,
            settledAmount: 0,
            tax: "0.00",
            notice: "Manuelle Buchung",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 65
          },
          additionalData: []
        },
        {
          id: "150630043",
          data: {
            id: "150630043",
            bookingNumber: "253680199",
            createdAt: "2024-12-05 16:20:09",
            type: "reconnection_fee",
            energy: "electricity",
            payableAt: "2024-12-07",
            grossAmount: 115,
            settledAmount: 0,
            tax: "19.00",
            notice: "Manuelle Buchung",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 115
          },
          additionalData: []
        },
        {
          id: "150632252",
          data: {
            id: "150632252",
            bookingNumber: "253682404",
            createdAt: "2025-01-05 08:39:33",
            type: "dunning_fee",
            energy: "electricity",
            payableAt: "2025-01-05",
            grossAmount: 2,
            settledAmount: 0,
            tax: "0.00",
            notice: "Mahngeb\xFChr",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 2
          },
          additionalData: []
        },
        {
          id: "150632271",
          data: {
            id: "150632271",
            bookingNumber: "253682422",
            createdAt: "2025-02-04 09:09:53",
            type: "dunning_fee",
            energy: "electricity",
            payableAt: "2025-02-04",
            grossAmount: 2,
            settledAmount: 0,
            tax: "0.00",
            notice: "Mahngeb\xFChr",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 2
          },
          additionalData: []
        },
        {
          id: "150632310",
          data: {
            id: "150632310",
            bookingNumber: null,
            createdAt: "2025-03-06 10:09:53",
            type: "dunning_fee",
            energy: "electricity",
            payableAt: "2025-03-06",
            grossAmount: 2,
            settledAmount: 0,
            tax: "0.00",
            notice: "Mahngeb\xFChr",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 2
          },
          additionalData: []
        }
      ],
      installments: [
        {
          id: "2019936",
          data: {
            id: 2019936,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-03-17",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019937",
          data: {
            id: 2019937,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-04-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019938",
          data: {
            id: 2019938,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-05-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019939",
          data: {
            id: 2019939,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-06-16",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019940",
          data: {
            id: 2019940,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-07-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019941",
          data: {
            id: 2019941,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-08-18",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019942",
          data: {
            id: 2019942,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-09-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019943",
          data: {
            id: 2019943,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-10-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019944",
          data: {
            id: 2019944,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-11-17",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019945",
          data: {
            id: 2019945,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2025-12-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019946",
          data: {
            id: 2019946,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2026-01-15",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        },
        {
          id: "2019947",
          data: {
            id: 2019947,
            clientId: 3,
            accountId: 123719,
            grossAmount: "30.00",
            settledAmount: "0.00",
            payableAt: "2026-02-16",
            createdAt: "2025-03-06 10:09:53"
          },
          additionalData: []
        }
      ],
      receivables: [
        {
          id: "754698",
          data: {
            id: 754698,
            clientId: 3,
            accountId: 123719,
            receivableId: "146852245",
            initialUnsettledAmount: "80.00",
            account_receivable: {
              id: "146852245",
              data: {
                id: "146852245",
                bookingNumber: "248523206",
                createdAt: "2024-10-24 17:59:31",
                type: "deposit",
                energy: "electricity",
                payableAt: "2024-11-05",
                grossAmount: 80,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) Januar / 2025 Kunden-Nr. 20099590 / 1000221409",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 80
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "754699",
          data: {
            id: 754699,
            clientId: 3,
            accountId: 123719,
            receivableId: "150022359",
            initialUnsettledAmount: "80.00",
            account_receivable: {
              id: "150022359",
              data: {
                id: "150022359",
                bookingNumber: "253075807",
                createdAt: "2024-11-26 18:05:19",
                type: "deposit",
                energy: "electricity",
                payableAt: "2024-12-03",
                grossAmount: 80,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) Februar / 2025 Kunden-Nr. 20099590 / 1000221409",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 80
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "754700",
          data: {
            id: 754700,
            clientId: 3,
            accountId: 123719,
            receivableId: "150630041",
            initialUnsettledAmount: "200.00",
            account_receivable: {
              id: "150630041",
              data: {
                id: "150630041",
                bookingNumber: "253680197",
                createdAt: "2024-12-05 16:20:09",
                type: "deposit",
                energy: "electricity",
                payableAt: "2024-11-04",
                grossAmount: 200,
                settledAmount: 0,
                tax: "19.00",
                notice: "Manuelle Buchung",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 200
              },
              additionalData: []
            }
          },
          additionalData: []
        }
      ]
    },
    contract_dunning_additional_receivables: [
      {
        bookingNumber: 253682404,
        payableAt: "2025-01-05",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 150632252,
        netAmount: 2,
        taxAmount: 0
      },
      {
        bookingNumber: 253682422,
        payableAt: "2025-02-04",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 150632271,
        netAmount: 2,
        taxAmount: 0
      },
      {
        bookingNumber: null,
        payableAt: "2025-03-06",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 150632310,
        netAmount: 2,
        taxAmount: 0
      }
    ],
    contract_dunnable_net: 291.6,
    contract_dunnable_tax: 68.4,
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE11280400460405354204",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    customer: {
      authorizedAt: null,
      createdAt: "2025-03-05 16:14:42",
      zip: "26789",
      city: "Leer",
      street: "Hoheellernweg",
      houseNumber: "1",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "20099590",
      status: "active",
      externalId: "",
      salutation: "2",
      firstname: "Claudia",
      title: "",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "12345678",
      phoneHomeAreaCode: "01234",
      phoneHome: "12345678",
      phoneBusinessAreaCode: "1234",
      phoneBusiness: "12345678",
      emailPrivate: "",
      emailBusiness: "",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "4"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2022-07-29 09:57:01",
              position: "2",
              fieldValueId: "4454042"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "101922",
      clientId: "3",
      identifier: "50358198156",
      additionalValues: [],
      note: null
    },
    contract_product: {
      contractProductId: "121385",
      createdAt: "2020-08-08 10:17:29",
      productName: "Strom Zuhause+ (24 Monate)",
      productCode: "ST-ZH24XX-PC",
      productVersion: "5",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2020-08-03",
      activeUntil: null,
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_deposit: {
      id: 18959844,
      clientId: 3,
      contractId: 1000221409,
      contractTariffId: 16686692,
      createdAt: "2024-08-16 03:00:10",
      createdBy: null,
      activeFrom: "2024-08-17",
      activeUntil: null,
      updatedAt: "2024-08-16 03:00:10",
      updatedBy: null,
      grossAmount: 80,
      blockedUntil: null,
      alternativeDayOfMonth: null,
      nextGenerationAt: "2024-12-16",
      ruleId: "11",
      techKey: "default",
      isSplitted: "0",
      depositSplits: [],
      netAmount: 67.23,
      taxRate: 0.19,
      taxAmount: 12.77,
      nextExecution: {
        useAt: "2025-01-02",
        useFor: "2024-12-01",
        generateAt: "2024-12-16",
        sepaGenerateAt: "2024-12-23"
      }
    },
    contract_banking_data: [
      {
        id: "103714",
        iban: "DE02120300000000202051",
        bic: "BYLADEM1001",
        bank: "DEUTSCHE KREDITBANK BERLIN",
        activeFrom: "2020-08-08",
        activeUntil: null,
        sepaMandate: "EWE-20099590-1000221409-1",
        accountHolder: "Test Test",
        direction: "inout",
        directDebit: "0",
        createdAt: "2020-08-08 10:17:29"
      }
    ],
    product_version: {
      productId: "32",
      version: "5",
      status: "deprecated",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "both",
      pricingType: "fixed_pricing",
      usageNtPercentage: "40",
      createdAt: "2011-03-28 16:15:32",
      updatedAt: "2011-03-28 16:15:32",
      releaseRequestedAt: null,
      releasedAt: "2020-08-10 16:15:32",
      deprecatedAt: "2020-12-11 18:38:51",
      lockedAt: null,
      name: "Strom Zuhause+ (24 Monate)",
      validFrom: "2010-11-17",
      validUntil: "9990-08-17",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "24",
      contractInitialDurationType: "months",
      contractExtensionTime: "12",
      contractExtensionTimeType: "months",
      contractCancellationPeriod: "28",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "<p>Stand AGB: 05/2020</p>",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-8.json
var contract_request_customer_reading_8_default = {
  EventId: "438609527",
  EventName: "contract_tariff_change_revoke_rejected",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 84,
    contract: {
      id: "1003231184",
      accountId: "3133922",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "electricity",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "26419",
      city: "Schortens",
      street: "Osterpiep",
      houseNumber: "1",
      floor: null,
      phone: "01234 / 1234578",
      fax: "",
      email: "test.anonym@ewe.de",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "2",
      billing_title: "",
      billing_firstname: "Sabrina",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_company: "Firma Anonym",
      billing_zip: "26419",
      billing_city: "Schortens",
      billing_street: "Osterpiep",
      billing_houseNumber: "1",
      billing_phone: "01234 / 12345678",
      billing_fax: "",
      billing_email: "test.anonym@ewe.de",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      counterNumber: "1LOG0067197064",
      counterType: "MME",
      counterTypeName: "moderne Messeinrichtung",
      invoice_email: "test.anonym@ewe.de",
      invoice_phone: "01234 / 12345678",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50356125523",
      meterLocation: "DE0004962641900000000000010645953",
      complexSystem: false,
      customerId: "20460254",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "2",
      firstname: "Sabrina",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2024-06-07",
      dateOfRevocation: null,
      startDate: "2024-07-29",
      desiredStartDate: "2024-06-11",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2026-01-29",
      endDate: null,
      desiredEndDate: null,
      orderId: "3183008",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "desired_date",
      signatureDate: "2024-05-22",
      netDeliveryStartConfirmed: "2024-05-24 09:40:00",
      netDeliveryEndConfirmed: null,
      usage: "1823",
      usageNet: "1823",
      usagePrevious: null,
      brandId: "1",
      directDebit: true,
      direction: "in",
      activeFrom: "2024-05-22",
      activeUntil: null,
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0000202051",
      bankCode: "12030000",
      alternativeAccountHolder: "Test Test",
      sepaMandate: "EWE-20460254-1003231184-1",
      futureBankingData: [
        {
          activeFrom: "2024-05-22",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "out",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: ""
        },
        {
          activeFrom: "2024-05-22",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "in",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-20460254-1003231184-1"
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            id: 4412221,
            activeFrom: "2024-05-22",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "in",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20460254-1003231184-1"
          }
        ],
        out: [
          {
            id: 4412220,
            activeFrom: "2024-05-22",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "out",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: ""
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: "2024-05-22 12:40:40",
      cancellationPreviousProviderConfirmed: null,
      netDeliveryStartSent: "2024-05-24 08:19:30",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      nextCancellationDate: "2025-07-28",
      latestCancelationByCustomer: "2025-06-28",
      externalId: "2dd9bda6-29e0-4be0-af05-0c6e085c60f8",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "6"
          },
          MATARIFINFO: {
            technicalKey: "MATARIFINFO",
            createdAt: "2021-06-07 16:37:56",
            name: "Mitarbeiter Infos",
            position: "10"
          },
          DOK001: {
            technicalKey: "DOK001",
            createdAt: "2022-09-20 09:20:49",
            name: "Dokumentensteuerung",
            position: "18"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2024-05-22 12:40:37",
              position: "2",
              fieldValueId: "8548813"
            }
          ],
          MATARIFINFO: [
            {
              name: "Gesellschaft",
              technicalKey: "GESELLSCHAFT",
              type: "text",
              value: "EWE",
              createdAt: "2024-05-22 12:40:37",
              position: "2",
              fieldValueId: "8548814"
            },
            {
              name: "AzureObjectID",
              technicalKey: "AZUREOBJECTID",
              type: "text",
              value: "875ae6eb-7343-48c9-9ead-6b56bc796711",
              createdAt: "2024-05-22 12:40:37",
              position: "3",
              fieldValueId: "8548815"
            }
          ],
          DOK001: [
            {
              name: "Deaktivierung Postversand",
              technicalKey: "DOK002",
              type: "bool",
              value: "1",
              createdAt: "2025-05-08 15:04:36",
              position: "1",
              fieldValueId: "10058844"
            }
          ]
        }
      },
      desiredInvoiceDate: null,
      invoicePeriodStartDate: "2024-07-29",
      invoicePeriodEndDate: "2025-07-28",
      dunningLocked: false,
      dunningLockedUntil: null,
      dunningLockReason: "",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "kein Mahnverfahren hinterlegt (JDS)",
      meterPricing: "included",
      cityId: "6434",
      additionalValues: []
    },
    contractId: 1003231184,
    notificationType: "disconnection_threat",
    contract_dunned_receivables: [
      {
        id: 149110624,
        bookingNumber: 252166232,
        payableAt: "2025-02-21",
        chargedDepositForMonth: "2025-01-01",
        type: "deposit",
        grossAmount: 70,
        settledAmount: 0,
        tax: 19,
        notice: "Abschlag (Strom) Januar / 2025 Kunden-Nr. 20460254 / 1003231184",
        contractId: 1003231184,
        level: 3,
        levelName: "Sperrandrohung",
        settlementDeadline: "2025-05-10",
        unsettledAmount: 70,
        dunnable: true,
        netAmount: 56.7,
        taxAmount: 13.3
      },
      {
        id: 150665020,
        bookingNumber: 253711532,
        payableAt: "2025-03-21",
        chargedDepositForMonth: "2025-02-01",
        type: "deposit",
        grossAmount: 70,
        settledAmount: 0,
        tax: 19,
        notice: "Abschlag (Strom) Februar / 2025 Kunden-Nr. 20460254 / 1003231184",
        contractId: 1003231184,
        level: 3,
        levelName: "Sperrandrohung",
        settlementDeadline: "2025-05-10",
        unsettledAmount: 70,
        dunnable: true,
        netAmount: 56.7,
        taxAmount: 13.3
      },
      {
        id: 152181624,
        bookingNumber: 255217421,
        payableAt: "2025-04-22",
        chargedDepositForMonth: "2025-03-01",
        type: "deposit",
        grossAmount: 70,
        settledAmount: 0,
        tax: 19,
        notice: "Abschlag (Strom) M\xE4rz / 2025 Kunden-Nr. 20460254 / 1003231184",
        contractId: 1003231184,
        level: 3,
        levelName: "Sperrandrohung",
        settlementDeadline: "2025-05-10",
        unsettledAmount: 70,
        dunnable: true,
        netAmount: 56.7,
        taxAmount: 13.3
      }
    ],
    contract_total_dunned_unpaid: 210,
    highest_dunning_level: {
      level: 3,
      levelName: "Sperrandrohung"
    },
    market_location_identifier: "50356125523",
    disconnection_fee: 1,
    settlement_deadline: "2025-05-10",
    additional_fee_amount: 2,
    installmentPlan: {
      id: 177248,
      clientId: 3,
      accountId: 3133922,
      isActive: "0",
      useDirectDebit: "0",
      createdAt: "2025-04-22 09:18:19",
      templateId: "12",
      total_receivable_amount: "214.00",
      total_overdue_receivable_amount: "144.00",
      total_installment_amount: "210.00",
      total_settled_installment_amount: "0.00",
      total_unsettled_installment_amount: "210.00",
      excluded_receivables: [
        {
          id: "153342488",
          data: {
            id: "153342488",
            bookingNumber: "256371022",
            createdAt: "2025-04-19 09:15:53",
            type: "dunning_fee",
            energy: "electricity",
            payableAt: "2025-04-19",
            grossAmount: 2,
            settledAmount: 0,
            tax: "0.00",
            notice: "Mahngeb\xFChr",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 2
          },
          additionalData: []
        },
        {
          id: "153739487",
          data: {
            id: "153739487",
            bookingNumber: "256765963",
            createdAt: "2025-04-21 09:10:47",
            type: "dunning_fee",
            energy: "electricity",
            payableAt: "2025-04-21",
            grossAmount: 2,
            settledAmount: 0,
            tax: "0.00",
            notice: "Mahngeb\xFChr",
            dunnable: false,
            dunningLocked: false,
            dunningLockedUntil: null,
            locks: [],
            deletedLocks: [],
            nextDunningAt: null,
            invoiceId: "0",
            unsettledAmount: 2
          },
          additionalData: []
        }
      ],
      installments: [
        {
          id: "2077818",
          data: {
            id: 2077818,
            clientId: 3,
            accountId: 3133922,
            grossAmount: "35.00",
            settledAmount: "0.00",
            payableAt: "2025-05-15",
            createdAt: "2025-04-22 09:18:19"
          },
          additionalData: []
        },
        {
          id: "2077819",
          data: {
            id: 2077819,
            clientId: 3,
            accountId: 3133922,
            grossAmount: "35.00",
            settledAmount: "0.00",
            payableAt: "2025-06-16",
            createdAt: "2025-04-22 09:18:19"
          },
          additionalData: []
        },
        {
          id: "2077820",
          data: {
            id: 2077820,
            clientId: 3,
            accountId: 3133922,
            grossAmount: "35.00",
            settledAmount: "0.00",
            payableAt: "2025-07-15",
            createdAt: "2025-04-22 09:18:19"
          },
          additionalData: []
        },
        {
          id: "2077821",
          data: {
            id: 2077821,
            clientId: 3,
            accountId: 3133922,
            grossAmount: "35.00",
            settledAmount: "0.00",
            payableAt: "2025-08-18",
            createdAt: "2025-04-22 09:18:19"
          },
          additionalData: []
        },
        {
          id: "2077822",
          data: {
            id: 2077822,
            clientId: 3,
            accountId: 3133922,
            grossAmount: "35.00",
            settledAmount: "0.00",
            payableAt: "2025-09-15",
            createdAt: "2025-04-22 09:18:19"
          },
          additionalData: []
        },
        {
          id: "2077823",
          data: {
            id: 2077823,
            clientId: 3,
            accountId: 3133922,
            grossAmount: "35.00",
            settledAmount: "0.00",
            payableAt: "2025-10-15",
            createdAt: "2025-04-22 09:18:19"
          },
          additionalData: []
        }
      ],
      receivables: [
        {
          id: "776966",
          data: {
            id: 776966,
            clientId: 3,
            accountId: 3133922,
            receivableId: "149110624",
            initialUnsettledAmount: "70.00",
            account_receivable: {
              id: "149110624",
              data: {
                id: "149110624",
                bookingNumber: "252166232",
                createdAt: "2025-02-16 16:31:48",
                type: "deposit",
                energy: "electricity",
                payableAt: "2025-02-21",
                grossAmount: 70,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) Januar / 2025 Kunden-Nr. 20460254 / 1003231184",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 70
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "776967",
          data: {
            id: 776967,
            clientId: 3,
            accountId: 3133922,
            receivableId: "150665020",
            initialUnsettledAmount: "70.00",
            account_receivable: {
              id: "150665020",
              data: {
                id: "150665020",
                bookingNumber: "253711532",
                createdAt: "2025-03-11 12:51:41",
                type: "deposit",
                energy: "electricity",
                payableAt: "2025-03-21",
                grossAmount: 70,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) Februar / 2025 Kunden-Nr. 20460254 / 1003231184",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 70
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "776968",
          data: {
            id: 776968,
            clientId: 3,
            accountId: 3133922,
            receivableId: "152181624",
            initialUnsettledAmount: "70.00",
            account_receivable: {
              id: "152181624",
              data: {
                id: "152181624",
                bookingNumber: "255217421",
                createdAt: "2025-04-08 11:19:51",
                type: "deposit",
                energy: "electricity",
                payableAt: "2025-04-22",
                grossAmount: 70,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Strom) M\xE4rz / 2025 Kunden-Nr. 20460254 / 1003231184",
                dunnable: true,
                dunningLocked: false,
                dunningLockedUntil: null,
                locks: [],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 70
              },
              additionalData: []
            }
          },
          additionalData: []
        }
      ]
    },
    contract_dunning_additional_receivables: [
      {
        bookingNumber: 256371022,
        payableAt: "2025-04-19",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 153342488,
        netAmount: 2,
        taxAmount: 0,
        notice: "Mahngeb\xFChr"
      },
      {
        bookingNumber: 256765963,
        payableAt: "2025-04-21",
        chargedDepositForMonth: null,
        type: "dunning_fee",
        grossAmount: 2,
        settledAmount: 0,
        tax: 0,
        dunnable: false,
        unsettledAmount: 2,
        id: 153739487,
        netAmount: 2,
        taxAmount: 0,
        notice: "Mahngeb\xFChr"
      }
    ],
    contract_dunnable_net: 170.10000000000002,
    contract_dunnable_tax: 39.900000000000006,
    contract_total_unpaid: 216,
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE11280400460405354204",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-05-22 12:30:19",
      zip: "26419",
      city: "Schortens",
      street: "Osterpiep",
      houseNumber: "1",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "20460254",
      status: "active",
      externalId: null,
      salutation: "2",
      firstname: "Sabrina",
      title: null,
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "12345678",
      phoneHomeAreaCode: "01234",
      phoneHome: "12345678",
      phoneBusinessAreaCode: "1234",
      phoneBusiness: "12345678",
      emailPrivate: "test.anonym@ewe.de",
      emailBusiness: "test.anonym@ewe.de",
      adsMail: "1",
      adsPhone: "1",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "5"
          },
          QUALITAET_KUNDENDATEN: {
            technicalKey: "QUALITAET_KUNDENDATEN",
            createdAt: "2023-10-06 13:50:45",
            name: "Qualit\xE4t Kundendaten",
            position: "19"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2022-07-29 10:06:01",
              position: "2",
              fieldValueId: "4812005"
            }
          ],
          QUALITAET_KUNDENDATEN: [
            {
              name: "Qualifizierung E-Mail",
              technicalKey: "QUALITAET_EMAIL",
              type: "date",
              value: "2024-03-12",
              createdAt: "2024-03-12 21:09:12",
              position: "3",
              fieldValueId: "8220881"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "522153",
      clientId: "3",
      identifier: "50356125523",
      additionalValues: [],
      note: null
    },
    contract_product: {
      contractProductId: "4051465",
      createdAt: "2024-05-22 12:40:37",
      productName: "EWE Zuhause+ Strom M (12 Monate)",
      productCode: "ST-ZH12MA-01",
      productVersion: "15",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-05-22",
      activeUntil: null,
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_deposit: {
      id: 17481608,
      clientId: 3,
      contractId: 1003231184,
      contractTariffId: 13026080,
      createdAt: "2024-05-24 10:06:13",
      createdBy: "11",
      activeFrom: "2024-05-22",
      activeUntil: null,
      updatedAt: "2024-09-11 11:11:36",
      updatedBy: "346",
      grossAmount: 70,
      blockedUntil: null,
      alternativeDayOfMonth: "21",
      nextGenerationAt: "2025-05-09",
      ruleId: "11",
      techKey: "default",
      isSplitted: "0",
      depositSplits: [],
      netAmount: 58.82,
      taxRate: 0.19,
      taxAmount: 11.18,
      nextExecution: {
        useAt: "2025-05-21",
        useFor: "2025-04-01",
        generateAt: "2025-05-09",
        sepaGenerateAt: "2025-05-16"
      }
    },
    contract_banking_data: [
      {
        id: "4412221",
        iban: "DE02120300000000202051",
        bic: "BYLADEM1001",
        bank: "DEUTSCHE KREDITBANK BERLIN",
        activeFrom: "2024-05-22",
        activeUntil: null,
        sepaMandate: "EWE-20460254-1003231184-1",
        accountHolder: "Test Test",
        direction: "in",
        directDebit: "1",
        createdAt: "2024-05-22 12:40:37"
      },
      {
        id: "4412220",
        iban: "DE02120300000000202051",
        bic: "BYLADEM1001",
        bank: "DEUTSCHE KREDITBANK BERLIN",
        activeFrom: "2024-05-22",
        activeUntil: null,
        sepaMandate: "",
        accountHolder: "Test Test",
        direction: "out",
        directDebit: "1",
        createdAt: "2024-05-22 12:40:37"
      }
    ],
    product_version: {
      productId: "102",
      version: "15",
      status: "deprecated",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "private",
      pricingType: "fixed_pricing",
      usageNtPercentage: "40",
      createdAt: "2024-05-02 08:33:19",
      updatedAt: "2024-05-02 08:35:36",
      releaseRequestedAt: null,
      releasedAt: "2024-05-02 08:35:36",
      deprecatedAt: "2024-07-24 11:08:16",
      lockedAt: null,
      name: "EWE Zuhause+ Strom M (12 Monate)",
      validFrom: "2022-03-01",
      validUntil: "9999-12-31",
      kind: "contract",
      eco: "eco",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "1",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "1",
      contractCancellationPeriodType: "months",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "<p>AGB Stand 03/2022</p>",
      cmsProperties: "<p>Portfolioupdate&nbsp;</p>\r\n<ul>\r\n<li>Name angepasst auf: EWE Zuhause+ M Strom</li>\r\n<li>Neue AGB's&nbsp;</li>\r\n<li>Vertragsverl&auml;ngerung auf unbestimmte Zeit (aufgrund faire Verbrauchervertr&auml;ge)</li>\r\n<li>K&uuml;ndigungsfrist 1 Monat</li>\r\n<li>Mehrwertberechtigt</li>\r\n</ul>",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/contract/contract-request-customer-reading-9.json
var contract_request_customer_reading_9_default = {
  EventId: "438609527",
  EventName: "contract_installment_plan_activated",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Version: "2.0",
  Content: {
    version: 14,
    contract: {
      id: "1000222370",
      accountId: "124680",
      externalContractId: null,
      bundleContractId: null,
      authorizedAt: null,
      type: "energy",
      energy: "gas",
      isFlatrate: false,
      billing_alternativeAddress: false,
      relocationPossible: true,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      relocationAt: null,
      business: false,
      company: null,
      countryId: "DE",
      zip: "26789",
      city: "Leer",
      street: "Am Hohen Kamp",
      houseNumber: "1",
      floor: null,
      phone: "01234 / 1234578",
      fax: "",
      email: "test.anonym@ewe.de",
      cancelledBy: null,
      cancellationReason: null,
      cancellationTriggeredDate: null,
      cancelledAt: null,
      filingDateCancellation: null,
      cancellationTechKey: null,
      cancellationSource: null,
      billing_salutation: "1",
      billing_title: "",
      billing_firstname: "Berthold",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_company: "Firma Anonym",
      billing_zip: "26789",
      billing_city: "Leer",
      billing_street: "Am Hohen Kamp",
      billing_houseNumber: "1",
      billing_phone: "01234 / 12345678",
      billing_fax: "",
      billing_email: "test.anonym@ewe.de",
      billing_country: "",
      billing_countryAlpha2: "",
      counterNumber: "92565",
      counterType: "BGZ",
      counterTypeName: "Balgengasz\xE4hler",
      invoice_email: "test.anonym@ewe.de",
      invoice_phone: "01234 / 12345678",
      invoice_fax: "",
      meterPointIdentifier: null,
      gridLocation: "",
      marketLocation: "50369943285",
      meterLocation: "DE7000872678900000000000070549189",
      complexSystem: false,
      customerId: "20100267",
      externalCustomerNumber: null,
      customerCommunicationType: "0",
      salutation: "1",
      firstname: "Berthold",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      status: "active",
      statusCode: "5000",
      statusCodeTitle: "In Belieferung",
      revocation: false,
      lastRevocationDate: "2020-11-23",
      dateOfRevocation: null,
      startDate: "2020-11-26",
      desiredStartDate: "2020-11-26",
      simulationTurnus: 6,
      nextInvoiceInformationDate: "2025-05-25",
      endDate: null,
      desiredEndDate: null,
      orderId: "128856",
      nextPossibleCancellationByLfa: null,
      customerSpecification: "earliest_possible_date",
      signatureDate: "2020-11-06",
      netDeliveryStartConfirmed: "2020-11-09 07:48:00",
      netDeliveryEndConfirmed: null,
      usage: "14089",
      usageNet: "15833",
      usagePrevious: "17682",
      brandId: "1",
      directDebit: true,
      direction: "inout",
      activeFrom: "2020-11-06",
      activeUntil: null,
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      replacedBankId: 0,
      bankAccountNumber: "0000202051",
      bankCode: "12030000",
      alternativeAccountHolder: "Test Test",
      sepaMandate: "EWE-20100267-1000222370-1",
      futureBankingData: [
        {
          activeFrom: "2020-11-06",
          activeUntil: null,
          alternativeAccountHolder: "Test Test",
          bank: "DEUTSCHE KREDITBANK BERLIN",
          bankAccountNumber: "0000202051",
          bankCode: "12030000",
          bic: "BYLADEM1001",
          directDebit: true,
          direction: "inout",
          iban: "DE02120300000000202051",
          paymentProvider: "SEPA Bank",
          replacedBankId: null,
          sepaMandate: "EWE-20100267-1000222370-1"
        }
      ],
      InOutActiveBankingData: {
        in: [
          {
            id: 104507,
            activeFrom: "2020-11-06",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20100267-1000222370-1"
          }
        ],
        out: [
          {
            id: 104507,
            activeFrom: "2020-11-06",
            activeUntil: null,
            alternativeAccountHolder: "Test Test",
            bank: "DEUTSCHE KREDITBANK BERLIN",
            bic: "BYLADEM1001",
            directDebit: true,
            direction: "inout",
            iban: "DE02120300000000202051",
            paymentProvider: null,
            replacedBankId: null,
            sepaMandate: "EWE-20100267-1000222370-1"
          }
        ]
      },
      InOutFutureBankingData: {
        in: [],
        out: []
      },
      industry: null,
      previousProvider: "EWE VERTRIEB GmbH",
      customerNumber: null,
      cancellationPreviousProviderSent: "2020-11-06 16:28:16",
      cancellationPreviousProviderConfirmed: "2020-11-25 00:00:00",
      netDeliveryStartSent: "2020-11-09 06:52:42",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "1",
      extensionTimeUnit: "days",
      cancellationPeriod: "1",
      cancellationPeriodUnit: "months",
      nextCancellationDate: "2025-11-25",
      latestCancelationByCustomer: "2025-10-25",
      externalId: "4779350d-df95-4bcd-9567-c78bbca8b733",
      externalOrderId: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "6"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "Brief",
              createdAt: "2020-11-06 16:28:15",
              position: "2",
              fieldValueId: "255536"
            }
          ]
        }
      },
      desiredInvoiceDate: "2025-11-25",
      invoicePeriodStartDate: "2024-11-26",
      invoicePeriodEndDate: "2025-11-25",
      dunningLocked: true,
      dunningLockedUntil: "2025-08-30",
      dunningLockReason: "TestMahnmodul",
      paymentLockedOut: false,
      paymentLockedOutUntil: "",
      paymentLockedIn: false,
      paymentLockedInUntil: "",
      taxRate: null,
      taxRateReason: null,
      taxRatePermission: null,
      energyTaxExemptionRate: null,
      energyTaxExemptionReason: null,
      energyTaxExemptionPermission: null,
      legalCase: null,
      desiredInvoiceReason: null,
      dunningProcedure: "GVV (JDS)",
      meterPricing: "included",
      cityId: "6496",
      additionalValues: []
    },
    contract_changed_installment_plan: {
      id: 180482,
      clientId: 3,
      accountId: 124680,
      isActive: "1",
      useDirectDebit: "1",
      createdAt: "2025-05-22 16:28:55",
      total_receivable_amount: "393.00",
      total_overdue_receivable_amount: "393.00",
      total_installment_amount: "393.00",
      total_settled_installment_amount: "0.00",
      total_unsettled_installment_amount: "393.00",
      excluded_receivables: [],
      installments: [
        {
          id: "2107353",
          data: {
            id: 2107353,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-05-30",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107354",
          data: {
            id: 2107354,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-06-02",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107355",
          data: {
            id: 2107355,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-07-01",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107356",
          data: {
            id: 2107356,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-08-01",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107357",
          data: {
            id: 2107357,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-09-01",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107358",
          data: {
            id: 2107358,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-10-01",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107359",
          data: {
            id: 2107359,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-11-03",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107360",
          data: {
            id: 2107360,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2025-12-01",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107361",
          data: {
            id: 2107361,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2026-01-02",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107362",
          data: {
            id: 2107362,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2026-02-02",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107363",
          data: {
            id: 2107363,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2026-03-02",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        },
        {
          id: "2107364",
          data: {
            id: 2107364,
            clientId: 3,
            accountId: 124680,
            grossAmount: "32.75",
            settledAmount: "0.00",
            payableAt: "2026-04-01",
            createdAt: "2025-05-22 16:28:55"
          },
          additionalData: []
        }
      ],
      receivables: [
        {
          id: "786121",
          data: {
            id: 786121,
            clientId: 3,
            accountId: 124680,
            receivableId: "150402729",
            initialUnsettledAmount: "131.00",
            account_receivable: {
              id: "150402729",
              data: {
                id: "150402729",
                bookingNumber: "253454511",
                createdAt: "2025-03-01 14:55:22",
                type: "deposit",
                energy: "gas",
                payableAt: "2025-03-03",
                grossAmount: 131,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Gas) Februar / 2025 Kunden-Nr. 20100267 / 1000222370",
                dunnable: false,
                dunningLocked: true,
                dunningLockedUntil: "2026-04-23",
                locks: [
                  {
                    id: "2124193",
                    data: {
                      createdAt: "2025-05-22 16:29:00",
                      createdBy: "Hintergrunddienste System",
                      lockReason: {
                        id: "56",
                        data: {
                          id: "56",
                          public: false,
                          techKey: "RATENPLAN",
                          text: "Ratenplan",
                          revenueBlocker: false,
                          isActive: true,
                          maxDunningDuration: "0",
                          clientId: "3",
                          defaultReasonForActions: false,
                          deleted: false,
                          modificationDate: "2024-02-01 15:10:21",
                          daysTillCheck: null,
                          allowDebtCollections: false,
                          type: "dunning_lock_reason",
                          access: [
                            "DunningLock_Standard",
                            "DunningLock_Expert",
                            "DunningLock_CRON"
                          ]
                        },
                        additionalData: []
                      },
                      lockedUntil: "2026-04-23",
                      receivableId: "150402729",
                      unsettledAmount: "131.00"
                    },
                    additionalData: []
                  }
                ],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 131
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "786122",
          data: {
            id: 786122,
            clientId: 3,
            accountId: 124680,
            receivableId: "151763234",
            initialUnsettledAmount: "131.00",
            account_receivable: {
              id: "151763234",
              data: {
                id: "151763234",
                bookingNumber: "254807956",
                createdAt: "2025-03-29 15:58:09",
                type: "deposit",
                energy: "gas",
                payableAt: "2025-04-01",
                grossAmount: 131,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Gas) M\xE4rz / 2025 Kunden-Nr. 20100267 / 1000222370",
                dunnable: false,
                dunningLocked: true,
                dunningLockedUntil: "2026-04-23",
                locks: [
                  {
                    id: "2124194",
                    data: {
                      createdAt: "2025-05-22 16:29:00",
                      createdBy: "Hintergrunddienste System",
                      lockReason: {
                        id: "56",
                        data: {
                          id: "56",
                          public: false,
                          techKey: "RATENPLAN",
                          text: "Ratenplan",
                          revenueBlocker: false,
                          isActive: true,
                          maxDunningDuration: "0",
                          clientId: "3",
                          defaultReasonForActions: false,
                          deleted: false,
                          modificationDate: "2024-02-01 15:10:21",
                          daysTillCheck: null,
                          allowDebtCollections: false,
                          type: "dunning_lock_reason",
                          access: [
                            "DunningLock_Standard",
                            "DunningLock_Expert",
                            "DunningLock_CRON"
                          ]
                        },
                        additionalData: []
                      },
                      lockedUntil: "2026-04-23",
                      receivableId: "151763234",
                      unsettledAmount: "131.00"
                    },
                    additionalData: []
                  }
                ],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 131
              },
              additionalData: []
            }
          },
          additionalData: []
        },
        {
          id: "786123",
          data: {
            id: 786123,
            clientId: 3,
            accountId: 124680,
            receivableId: "153119780",
            initialUnsettledAmount: "131.00",
            account_receivable: {
              id: "153119780",
              data: {
                id: "153119780",
                bookingNumber: "256148316",
                createdAt: "2025-04-18 23:02:44",
                type: "deposit",
                energy: "gas",
                payableAt: "2025-05-02",
                grossAmount: 131,
                settledAmount: 0,
                tax: "19.00",
                notice: "Abschlag (Gas) April / 2025 Kunden-Nr. 20100267 / 1000222370",
                dunnable: false,
                dunningLocked: true,
                dunningLockedUntil: "2026-04-23",
                locks: [
                  {
                    id: "2124195",
                    data: {
                      createdAt: "2025-05-22 16:29:00",
                      createdBy: "Hintergrunddienste System",
                      lockReason: {
                        id: "56",
                        data: {
                          id: "56",
                          public: false,
                          techKey: "RATENPLAN",
                          text: "Ratenplan",
                          revenueBlocker: false,
                          isActive: true,
                          maxDunningDuration: "0",
                          clientId: "3",
                          defaultReasonForActions: false,
                          deleted: false,
                          modificationDate: "2024-02-01 15:10:21",
                          daysTillCheck: null,
                          allowDebtCollections: false,
                          type: "dunning_lock_reason",
                          access: [
                            "DunningLock_Standard",
                            "DunningLock_Expert",
                            "DunningLock_CRON"
                          ]
                        },
                        additionalData: []
                      },
                      lockedUntil: "2026-04-23",
                      receivableId: "153119780",
                      unsettledAmount: "131.00"
                    },
                    additionalData: []
                  }
                ],
                deletedLocks: [],
                nextDunningAt: null,
                invoiceId: "0",
                unsettledAmount: 131
              },
              additionalData: []
            }
          },
          additionalData: []
        }
      ]
    },
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE11280400460405354204",
            bic: "COBADEFFXXX",
            bank: "COMMERZBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    order: {
      id: "128856",
      createdAt: "2020-11-06 16:28:13",
      orderedAt: "2020-11-06 16:28:13",
      status: "done",
      revokedAt: null,
      relevantStreet: "0",
      zip: "26789",
      city: "Leer",
      street: "Am Hohen Kamp",
      houseNumber: "1",
      business: "0",
      company: null,
      customerId: "20100267",
      salutation: "1",
      firstname: "Berthold",
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: "4779350d-df95-4bcd-9567-c78bbca8b733",
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "01234567",
      phoneHomeAreaCode: "0123",
      phoneHome: "01234567",
      phoneBusinessAreaCode: "0123",
      phoneBusiness: "01234567",
      emailPrivate: "test.anonym@ewe.de",
      emailBusiness: "test.anonym@ewe.de",
      researchedCustomer: null,
      energy: "gas",
      billing_alternativeAddress: "0",
      billing_company: null,
      billing_salutation: "1",
      billing_title: null,
      billing_firstname: "Berthold",
      billing_surname: "Anonym",
      billing_careOfRecipient: "",
      billing_zip: "26789",
      billing_country: "",
      billing_countryAlpha2: "",
      billing_city: "Leer",
      billing_street: "Am Hohen Kamp",
      billing_houseNumber: "1",
      billing_fax: "",
      billing_phone: "0123 / 0123456",
      billing_email: "test.anonym@ewe.de",
      relocationAddressTransfer: "",
      iban: "DE02120300000000202051",
      bic: "BYLADEM1001",
      bank: "DEUTSCHE KREDITBANK BERLIN",
      alternativeAccountHolder: null,
      directDebit: true,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "MIGRATION",
      campaignId: "7",
      exportAt: "2020-11-06",
      salesChannel: "any",
      inputChannel: "phone",
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "",
      previousProviderCodeNumber: "9800000200001",
      previousProviderCodeNumberProvider: "dvgw",
      netCodeNumber: "9870008700006",
      netCodeNumberProvider: "dvgw",
      customerNumber: null,
      customerSpecification: "earliest_possible_date",
      relocationAt: null,
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: null,
      provider: "EWE VERTRIEB GmbH",
      providerId: "-7",
      product: "Gas Zuhause+ (24 Monate)",
      productId: "179",
      productCode: "GA-ZH24XX-PC",
      productEco: "0",
      variant: "0",
      productType: "standard",
      priceKey: "GA-ZH24XX-PC",
      counterNumber: "G22135AAA92565",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "17682",
      complexPrice: false,
      productWorkingPrice: "5.63",
      productBasePrice: "185.09",
      overConsumptionWorkingPrice: "0",
      productWorkingPriceNetto: "4.8534",
      productBasePriceNetto: "159.56",
      productBonusNetto: "34.48",
      productInstantBonusNetto: "0",
      energyTax: "0.16",
      productWorkingPriceTax: "0.7766",
      productBasePriceTax: "25.53",
      productBonusTax: "5.52",
      productInstantBonusTax: "0",
      productBonus: "40.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "months_price_excluding_vat_and_new_taxes",
      fixedPriceMonths: "24",
      fixedPriceDate: null,
      cancellationPeriod: "28",
      cancellationPeriodUnit: "days",
      minimumRuntime: "24",
      minimumRuntimeUnit: "months",
      extensionTime: "12",
      extensionTimeUnit: "months",
      ediProcessId: null,
      vpCode: "30571",
      uvpCode: null,
      extendedData: {
        categories: {
          VART: {
            technicalKey: "VART",
            createdAt: "2020-07-07 07:28:24",
            name: "Versandart",
            position: "6"
          }
        },
        values: {
          VART: [
            {
              name: "Versandart",
              technicalKey: "VART",
              type: "select",
              value: "E-Mail",
              createdAt: "2020-11-06 16:28:14",
              position: "2",
              fieldValueId: "255535"
            }
          ]
        }
      },
      createdBy: "12",
      signatureDate: "2020-11-06",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-04-02 12:26:56",
      zip: "26789",
      city: "Leer",
      street: "Am Hohen Kamp",
      houseNumber: "1",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "20100267",
      status: "active",
      externalId: null,
      salutation: "1",
      firstname: "Berthold",
      title: null,
      surname: "Anonym",
      dateOfBirth: "1970-01-01",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0123",
      phoneMobile: "12345678",
      phoneHomeAreaCode: "01234",
      phoneHome: "12345678",
      phoneBusinessAreaCode: "1234",
      phoneBusiness: "12345678",
      emailPrivate: "test.anonym@ewe.de",
      emailBusiness: "test.anonym@ewe.de",
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "5"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2022-07-29 09:57:01",
              position: "2",
              fieldValueId: "4454713"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    market_location: {
      id: "102881",
      clientId: "3",
      identifier: "50369943285",
      additionalValues: [],
      note: null
    },
    contract_product: {
      contractProductId: "3895249",
      createdAt: "2024-04-02 12:26:55",
      productName: "EWE Gas basis 12",
      productCode: "GA-BS12XX-04",
      productVersion: "11",
      productType: "tariff_list",
      excludedTaxesAndLevies: [],
      flexibleAddons: [],
      addOnOf: null,
      mandatoryAddOn: "0",
      activeFrom: "2024-11-26",
      activeUntil: null,
      contractProductStatus: "active",
      quantity: "1",
      externalOrderNumber: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      overwriteUseUsageSplitForElectricity: false,
      additionalTerminationRightBeforeDelivery: false
    },
    contract_banking_data: [
      {
        id: "104507",
        iban: "DE02120300000000202051",
        bic: "BYLADEM1001",
        bank: "DEUTSCHE KREDITBANK BERLIN",
        activeFrom: "2020-11-06",
        activeUntil: null,
        sepaMandate: "EWE-20100267-1000222370-1",
        accountHolder: "Test Test",
        direction: "inout",
        directDebit: "1",
        createdAt: "2020-11-06 16:28:15"
      }
    ],
    product_version: {
      productId: "162",
      version: "11",
      status: "deprecated",
      supplyType: "competitive_supply",
      consumptionType: "universal",
      priceType: "single_price",
      business: "private",
      pricingType: "fixed_pricing",
      usageNtPercentage: null,
      createdAt: "2024-03-07 10:45:02",
      updatedAt: "2024-03-07 10:45:21",
      releaseRequestedAt: null,
      releasedAt: "2024-03-07 10:45:21",
      deprecatedAt: "2024-04-30 11:37:24",
      lockedAt: null,
      name: "EWE Gas basis 12\u200B",
      validFrom: "2023-09-01",
      validUntil: "9999-12-31",
      kind: "contract",
      eco: "fake",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "1",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "1",
      contractCancellationPeriodType: "months",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/invoice/invoice-created-electricity-1.json
var invoice_created_electricity_1_default = {
  EventId: "211430022",
  EventName: "invoice_created_electricity",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Content: {
    version: 3,
    customer: {
      authorizedAt: null,
      createdAt: "2021-01-29 13:10:16",
      zip: "49696",
      city: "Molbergen",
      street: "XXX",
      houseNumber: "3 a",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: "",
      countryId: "48",
      customerId: "20193333",
      status: "active",
      externalId: null,
      salutation: "2",
      firstname: "Annekatrin",
      title: null,
      surname: "XXX",
      dateOfBirth: null,
      availableSentNotification: "1",
      authUserName: "EFFF9C49-9C60-44AC-AB7D-21E8E22B7EDC",
      authEnabled: "1",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: "XXX",
      phoneHome: "XXXX",
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: "XXX",
      emailBusiness: "",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {
          ZAHLUNGSMORAL: {
            technicalKey: "ZAHLUNGSMORAL",
            createdAt: "2018-10-22 13:47:25",
            name: "Inkasso",
            position: "4"
          }
        },
        values: {
          ZAHLUNGSMORAL: [
            {
              name: "Bonit\xE4ts-Score",
              technicalKey: "BONISCORE",
              type: "text",
              value: "A",
              createdAt: "2022-07-29 10:02:01",
              position: "2",
              fieldValueId: "4546964"
            }
          ]
        }
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    invoice: {
      externalInvoice: 0,
      invoiceTriggeredByUser: false,
      invoiceNumber: 2596029,
      bundleInvoiceId: null,
      invoiceDate: "2023-09-09",
      payableAt: "2023-09-18",
      accountVoucherId: 3905889,
      billingAddress: {
        company: "",
        salutation: 2,
        firstName: "Annekatrin",
        surName: "XXX",
        street: "XXX",
        houseNumber: "3 a",
        zip: "49696",
        city: "Molbergen",
        country: 48
      },
      bankingData: {
        id: "521724",
        iban: "XXX",
        bic: "OLBODEH2XXX",
        bank: "OLDENBURGISCHE LANDESBANK AG",
        activeFrom: "2021-07-27",
        activeUntil: null,
        sepaMandate: "EWE-20193333-1000820476-1",
        accountHolder: "Christian G\xF6thert",
        direction: "inout",
        directDebit: "1",
        createdAt: "2021-07-27 13:07:48"
      },
      totalCosts: {
        net: 696.67,
        tax: 132.37,
        gross: 829.04
      },
      invoiceAmount: {
        net: 696.67,
        tax: 132.37,
        gross: 829.04
      },
      amountRemaining: {
        net: -1.61,
        tax: -0.35,
        gross: -1.96
      },
      totalAmountRemaining: {
        net: -1.61,
        tax: -0.35,
        gross: -1.96
      },
      accountBalance: {
        amountOld: 0,
        amountNew: -1.96
      }
    },
    contracts: [
      {
        contract: {
          id: "1000820476",
          accountId: "722939",
          externalContractId: null,
          bundleContractId: null,
          authorizedAt: null,
          type: "energy",
          energy: "electricity",
          isFlatrate: false,
          billing_alternativeAddress: false,
          relocationPossible: true,
          relocationContractId: null,
          relatedContractType: null,
          relatedContractId: null,
          relocationAt: null,
          business: false,
          company: null,
          countryId: "DE",
          zip: "49696",
          city: "Molbergen",
          street: "XXX",
          houseNumber: "3 a",
          floor: null,
          phone: "XXX",
          fax: "",
          email: "XXX",
          cancelledBy: null,
          cancellationReason: null,
          cancellationTriggeredDate: null,
          billing_salutation: "2",
          billing_title: "",
          billing_firstname: "Annekatrin",
          billing_surname: "XXX",
          billing_careOfRecipient: "",
          billing_company: "",
          billing_zip: "49696",
          billing_city: "Molbergen",
          billing_street: "XXX",
          billing_houseNumber: "3 a",
          billing_phone: "XXX",
          billing_email: "XXX",
          billing_country: "Deutschland",
          billing_countryAlpha2: "DE",
          counterNumber: "XXX",
          counterType: "EHZ",
          counterTypeName: "Elektronischer Haushaltsz\xE4hler",
          meterPointIdentifier: null,
          marketLocation: "50363870690",
          meterLocation: "DE0004964969600000000000011918966",
          complexSystem: false,
          customerId: "20193333",
          externalCustomerNumber: null,
          customerCommunicationType: "0",
          salutation: "2",
          firstname: "Annekatrin",
          surname: "XXX",
          dateOfBirth: null,
          status: "active",
          statusCode: "5000",
          statusCodeTitle: "In Belieferung",
          revocation: false,
          dateOfRevocation: null,
          lastRevocationDate: "2021-08-12",
          startDate: "2021-08-13",
          desiredStartDate: "2021-08-13",
          simulationTurnus: 6,
          nextInvoiceInformationDate: "2023-02-12",
          endDate: null,
          desiredEndDate: null,
          orderId: "741706",
          nextPossibleCancellationByLfa: null,
          customerSpecification: "earliest_possible_date",
          signatureDate: "2021-07-27",
          cancelledAt: null,
          filingDateCancellation: null,
          cancellationTechKey: null,
          netDeliveryStartConfirmed: "2021-07-29 04:19:00",
          netDeliveryEndConfirmed: null,
          usage: "2179",
          usageNet: "2231",
          usagePrevious: "1986",
          brandId: "1",
          directDebit: true,
          direction: "inout",
          activeFrom: "2021-07-27",
          activeUntil: null,
          iban: "XXX",
          bic: "OLBODEH2XXX",
          bank: "OLDENBURGISCHE LANDESBANK AG",
          paymentProvider: "SEPA Bank",
          paymentProviderData: [],
          replacedBankId: 0,
          bankAccountNumber: "3009127600",
          bankCode: "28020050",
          alternativeAccountHolder: "Christian G\xF6thert",
          sepaMandate: "EWE-20193333-1000820476-1",
          futureBankingData: [],
          previousProvider: "EWE VERTRIEB GmbH",
          customerNumber: "79354053",
          cancellationPreviousProviderSent: "2021-07-27 13:07:49",
          cancellationPreviousProviderConfirmed: "2021-08-12 00:00:00",
          netDeliveryStartSent: "2021-07-28 17:29:37",
          minimumRuntime: "12",
          minimumRuntimeUnit: "months",
          extensionTime: "1",
          extensionTimeUnit: "days",
          cancellationPeriod: "1",
          cancellationPeriodUnit: "months",
          nextCancellationDate: "2024-08-12",
          latestCancelationByCustomer: "2024-07-12",
          externalId: "5c28a118-a0e9-45d9-a1a1-4a8676a5c726",
          externalOrderId: null,
          extendedData: {
            categories: {
              VART: {
                technicalKey: "VART",
                createdAt: "2020-07-07 07:28:24",
                name: "Versandart",
                position: "5"
              },
              MATARIFINFO: {
                technicalKey: "MATARIFINFO",
                createdAt: "2021-06-07 16:37:56",
                name: "Mitarbeiter Infos",
                position: "9"
              }
            },
            values: {
              VART: [
                {
                  name: "Versandart",
                  technicalKey: "VART",
                  type: "select",
                  value: "E-Mail",
                  createdAt: "2021-07-27 13:07:48",
                  position: "2",
                  fieldValueId: "1514617"
                }
              ],
              MATARIFINFO: [
                {
                  name: "Gesellschaft",
                  technicalKey: "GESELLSCHAFT",
                  type: "text",
                  value: "EWE",
                  createdAt: "2021-07-27 13:07:48",
                  position: "2",
                  fieldValueId: "1514618"
                },
                {
                  name: "AzureObjectID",
                  technicalKey: "AZUREOBJECTID",
                  type: "text",
                  value: "e48b9821-564d-47ad-8cc0-086630db2bf5",
                  createdAt: "2021-07-27 13:07:48",
                  position: "3",
                  fieldValueId: "1514619"
                }
              ]
            }
          },
          desiredInvoiceDate: "2024-08-12",
          invoicePeriodStartDate: "2023-08-13",
          invoicePeriodEndDate: "2024-08-12",
          dunningLocked: false,
          dunningLockedUntil: null,
          dunningLockReason: "",
          paymentLockedOut: false,
          paymentLockedOutUntil: "",
          paymentLockedIn: false,
          paymentLockedInUntil: "",
          taxRate: null,
          taxRateReason: null,
          taxRatePermission: null,
          energyTaxExemptionRate: null,
          energyTaxExemptionReason: null,
          energyTaxExemptionPermission: null,
          legalCase: null,
          desiredInvoiceReason: null,
          dunningProcedure: "CAIGVV",
          meterPricing: "included",
          additionalValues: []
        },
        contractInvoice: {
          startDate: "2022-08-13",
          endDate: "2023-08-12",
          totalCosts: {
            net: 696.67,
            tax: 132.37,
            gross: 829.04
          },
          invoiceAmount: {
            net: 696.67,
            tax: 132.37,
            gross: 829.04
          },
          amountRemaining: {
            net: -1.61,
            tax: -0.35,
            gross: -1.96
          },
          totalAmountRemaining: {
            net: -1.61,
            tax: -0.35,
            gross: -1.96
          },
          correctedInvoicesIncluded: 0,
          invoiceCorrection: 0,
          previousInvoice: {
            accountVoucherId: "975084",
            accountVoucherCreatedAt: "2022-08-25",
            accountVoucherCreatedBy: "1866"
          },
          energyCosts: {
            type: "cost",
            compensatedSummation: false,
            decimalPlaces: 2,
            decimalPlacesForQuantity: 2,
            calculationRelevant: true,
            taxRate: 19,
            taxKey: "M19",
            taxType: "vat_standard",
            amountNet: 696.67,
            amountTax: 132.37,
            amountGross: 829.04,
            amountCompensated: 0,
            additionalData: null,
            taxPeriods: [
              {
                startDate: "2022-08-13",
                endDate: "2023-08-12",
                type: "cost",
                compensatedSummation: true,
                decimalPlaces: 2,
                calculationRelevant: true,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                amountNet: 696.67,
                amountTax: 132.37,
                amountGross: 829.04,
                amountCompensated: 0
              }
            ],
            periods: [
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2022-08-13",
                endDate: "2022-12-31",
                days: 141,
                basePrice: {
                  quantity: 141,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 58.33,
                  amountTax: 11.08,
                  amountGross: 69.41,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 943,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 236.15,
                  amountTax: 44.87,
                  amountGross: 281.02,
                  energyTaxNet: 19.33,
                  energyTaxTax: 3.67,
                  energyTaxGross: 23,
                  amountWithoutEnergyTaxNet: 216.82,
                  amountWithoutEnergyTaxTax: 41.2,
                  amountWithoutEnergyTaxGross: 258.02,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 943,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 236.15,
                      amountTax: 44.87,
                      amountGross: 281.02,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-01-01",
                endDate: "2023-01-23",
                days: 23,
                basePrice: {
                  quantity: 23,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 9.52,
                  amountTax: 1.81,
                  amountGross: 11.33,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 185,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 46.33,
                  amountTax: 8.8,
                  amountGross: 55.13,
                  energyTaxNet: 3.79,
                  energyTaxTax: 0.72,
                  energyTaxGross: 4.51,
                  amountWithoutEnergyTaxNet: 42.54,
                  amountWithoutEnergyTaxTax: 8.08,
                  amountWithoutEnergyTaxGross: 50.62,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 185,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 46.33,
                      amountTax: 8.8,
                      amountGross: 55.13,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-01-24",
                endDate: "2023-02-28",
                days: 36,
                basePrice: {
                  quantity: 36,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 14.89,
                  amountTax: 2.83,
                  amountGross: 17.72,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 517,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 129.47,
                  amountTax: 24.6,
                  amountGross: 154.07,
                  energyTaxNet: 10.6,
                  energyTaxTax: 2.01,
                  energyTaxGross: 12.61,
                  amountWithoutEnergyTaxNet: 118.87,
                  amountWithoutEnergyTaxTax: 22.59,
                  amountWithoutEnergyTaxGross: 141.46,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 517,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 129.47,
                      amountTax: 24.6,
                      amountGross: 154.07,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-03-01",
                endDate: "2023-03-24",
                days: 24,
                basePrice: {
                  quantity: 24,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 9.93,
                  amountTax: 1.89,
                  amountGross: 11.82,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 322,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 80.64,
                  amountTax: 15.32,
                  amountGross: 95.96,
                  energyTaxNet: 6.6,
                  energyTaxTax: 1.25,
                  energyTaxGross: 7.85,
                  amountWithoutEnergyTaxNet: 74.04,
                  amountWithoutEnergyTaxTax: 14.07,
                  amountWithoutEnergyTaxGross: 88.11,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 322,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 80.64,
                      amountTax: 15.32,
                      amountGross: 95.96,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-03-25",
                endDate: "2023-07-10",
                days: 108,
                basePrice: {
                  quantity: 108,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 44.68,
                  amountTax: 8.49,
                  amountGross: 53.17,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 197,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 49.33,
                  amountTax: 9.37,
                  amountGross: 58.7,
                  energyTaxNet: 4.04,
                  energyTaxTax: 0.77,
                  energyTaxGross: 4.81,
                  amountWithoutEnergyTaxNet: 45.29,
                  amountWithoutEnergyTaxTax: 8.6,
                  amountWithoutEnergyTaxGross: 53.89,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 197,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 49.33,
                      amountTax: 9.37,
                      amountGross: 58.7,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-07-11",
                endDate: "2023-07-31",
                days: 21,
                basePrice: {
                  quantity: 21,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 8.69,
                  amountTax: 1.65,
                  amountGross: 10.34,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 10,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 2.5,
                  amountTax: 0.48,
                  amountGross: 2.98,
                  energyTaxNet: 0.21,
                  energyTaxTax: 0.04,
                  energyTaxGross: 0.25,
                  amountWithoutEnergyTaxNet: 2.29,
                  amountWithoutEnergyTaxTax: 0.44,
                  amountWithoutEnergyTaxGross: 2.73,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 10,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 2.5,
                      amountTax: 0.48,
                      amountGross: 2.98,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-08-01",
                endDate: "2023-08-01",
                days: 1,
                basePrice: {
                  quantity: 1,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 0.41,
                  amountTax: 0.08,
                  amountGross: 0.49,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 0,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  energyTaxNet: 0,
                  energyTaxTax: 0,
                  energyTaxGross: 0,
                  amountWithoutEnergyTaxNet: 0,
                  amountWithoutEnergyTaxTax: 0,
                  amountWithoutEnergyTaxGross: 0,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 0,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 0,
                      amountTax: 0,
                      amountGross: 0,
                      amountCompensated: 0
                    }
                  ]
                }
              },
              {
                title: "Strom Zuhause+ M (12 Monate)",
                startDate: "2023-08-02",
                endDate: "2023-08-12",
                days: 11,
                basePrice: {
                  quantity: 11,
                  quantityUnit: "days",
                  unitPriceNet: "151",
                  unitPriceGross: 179.69,
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "base_price",
                  amountNet: 4.55,
                  amountTax: 0.86,
                  amountGross: 5.41,
                  amountCompensated: 0
                },
                workingPriceTotal: {
                  quantity: 5,
                  quantityUnit: "kwh",
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  amountNet: 1.25,
                  amountTax: 0.24,
                  amountGross: 1.49,
                  energyTaxNet: 0.1,
                  energyTaxTax: 0.02,
                  energyTaxGross: 0.12,
                  amountWithoutEnergyTaxNet: 1.15,
                  amountWithoutEnergyTaxTax: 0.22,
                  amountWithoutEnergyTaxGross: 1.37,
                  workingPrices: [
                    {
                      obis: "1-1:1.8.0",
                      description: "HT",
                      quantity: 5,
                      quantityUnit: "kwh",
                      unitPriceNet: "0.25042",
                      unitPriceGross: 0.298,
                      unitPriceFactor: 1,
                      taxRate: 19,
                      taxKey: "M19",
                      taxType: "vat_standard",
                      type: "working_price",
                      amountNet: 1.25,
                      amountTax: 0.24,
                      amountGross: 1.49,
                      amountCompensated: 0
                    }
                  ]
                }
              }
            ]
          },
          energyCharges: {
            type: "other",
            compensatedSummation: false,
            decimalPlaces: 2,
            calculationRelevant: false,
            taxRate: 19,
            taxKey: "M19",
            taxType: "vat_standard",
            amountNet: 313.84,
            amountTax: 59.62,
            amountGross: 373.46,
            amountCompensated: 0,
            additionalData: null,
            KWK: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 7.98,
              amountTax: 1.52,
              amountGross: 9.5,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "KWK",
                  quantity: 943,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00378",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 3.56,
                  amountTax: 0.68,
                  amountGross: 4.24,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 185,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 0.66,
                  amountTax: 0.13,
                  amountGross: 0.79,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 517,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 1.85,
                  amountTax: 0.35,
                  amountGross: 2.2,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 322,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 1.15,
                  amountTax: 0.22,
                  amountGross: 1.37,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 197,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 0.7,
                  amountTax: 0.13,
                  amountGross: 0.83,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 10,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0.04,
                  amountTax: 0.01,
                  amountGross: 0.05,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "KWK",
                  quantity: 5,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00357",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "kwk",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0.02,
                  amountTax: 0,
                  amountGross: 0.02,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            Contribution: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 9.27,
              amountTax: 1.76,
              amountGross: 11.03,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "Contribution",
                  quantity: 943,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00437",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 4.12,
                  amountTax: 0.78,
                  amountGross: 4.9,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 185,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 0.77,
                  amountTax: 0.15,
                  amountGross: 0.92,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 517,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 2.16,
                  amountTax: 0.41,
                  amountGross: 2.57,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 322,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 1.34,
                  amountTax: 0.25,
                  amountGross: 1.59,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 197,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 0.82,
                  amountTax: 0.16,
                  amountGross: 0.98,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 10,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0.04,
                  amountTax: 0.01,
                  amountGross: 0.05,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Contribution",
                  quantity: 5,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00417",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "contribution",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0.02,
                  amountTax: 0,
                  amountGross: 0.02,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            EEGCharges: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 0,
              amountTax: 0,
              amountGross: 0,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "EEG",
                  quantity: 943,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 185,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 517,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 322,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 197,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 10,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EEG",
                  quantity: 5,
                  quantityUnit: "kwh",
                  unitPriceNet: "0",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "eeg_charge",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            Offshore: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 11.25,
              amountTax: 2.14,
              amountGross: 13.39,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "Offshore",
                  quantity: 943,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00419",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 3.95,
                  amountTax: 0.75,
                  amountGross: 4.7,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 185,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 1.09,
                  amountTax: 0.21,
                  amountGross: 1.3,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 517,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 3.06,
                  amountTax: 0.58,
                  amountGross: 3.64,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 322,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 1.9,
                  amountTax: 0.36,
                  amountGross: 2.26,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 197,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 1.16,
                  amountTax: 0.22,
                  amountGross: 1.38,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 10,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0.06,
                  amountTax: 0.01,
                  amountGross: 0.07,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Offshore",
                  quantity: 5,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00591",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "offshore",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0.03,
                  amountTax: 0.01,
                  amountGross: 0.04,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            Interruptible: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 0.03,
              amountTax: 0.01,
              amountGross: 0.04,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "Interruptible",
                  quantity: 943,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.00003",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 0.03,
                  amountTax: 0.01,
                  amountGross: 0.04,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 185,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 517,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 322,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 197,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 10,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Interruptible",
                  quantity: 5,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "interruptible",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            EnergyTax: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 44.67,
              amountTax: 8.48,
              amountGross: 53.15,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "EnergyTax",
                  quantity: 943,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 19.33,
                  amountTax: 3.67,
                  amountGross: 23,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 185,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 3.79,
                  amountTax: 0.72,
                  amountGross: 4.51,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 517,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 10.6,
                  amountTax: 2.01,
                  amountGross: 12.61,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 322,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 6.6,
                  amountTax: 1.25,
                  amountGross: 7.85,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 197,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 4.04,
                  amountTax: 0.77,
                  amountGross: 4.81,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 10,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0.21,
                  amountTax: 0.04,
                  amountGross: 0.25,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "EnergyTax",
                  quantity: 5,
                  quantityUnit: "kwh",
                  unitPriceNet: "0.0205",
                  unitPriceFactor: 1,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "working_price_tax_electricity",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0.1,
                  amountTax: 0.02,
                  amountGross: 0.12,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            Maintenance: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 105.95,
              amountTax: 20.13,
              amountGross: 126.08,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "Maintenance",
                  quantity: 141,
                  quantityUnit: "days",
                  unitPriceNet: "96",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 37.08,
                  amountTax: 7.05,
                  amountGross: 44.13,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 23,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 7.07,
                  amountTax: 1.34,
                  amountGross: 8.41,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 36,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 11.07,
                  amountTax: 2.1,
                  amountGross: 13.17,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 24,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 7.38,
                  amountTax: 1.4,
                  amountGross: 8.78,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 108,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 33.2,
                  amountTax: 6.31,
                  amountGross: 39.51,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 21,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 6.46,
                  amountTax: 1.23,
                  amountGross: 7.69,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 1,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0.31,
                  amountTax: 0.06,
                  amountGross: 0.37,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Maintenance",
                  quantity: 11,
                  quantityUnit: "days",
                  unitPriceNet: "112.21",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "maintenance",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 3.38,
                  amountTax: 0.64,
                  amountGross: 4.02,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            Concessions: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 28.76,
              amountTax: 5.46,
              amountGross: 34.22,
              amountCompensated: 0,
              additionalData: null,
              Ta: {
                type: "other",
                compensatedSummation: false,
                decimalPlaces: 2,
                calculationRelevant: false,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                amountNet: 28.76,
                amountTax: 5.46,
                amountGross: 34.22,
                amountCompensated: 0,
                additionalData: null,
                invoiceItems: [
                  {
                    title: "ConcessionTa",
                    quantity: 943,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2022-08-13",
                    endDate: "2022-12-31",
                    days: 141,
                    amountNet: 12.45,
                    amountTax: 2.37,
                    amountGross: 14.82,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 185,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-01-01",
                    endDate: "2023-01-23",
                    days: 23,
                    amountNet: 2.44,
                    amountTax: 0.46,
                    amountGross: 2.9,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 517,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-01-24",
                    endDate: "2023-02-28",
                    days: 36,
                    amountNet: 6.82,
                    amountTax: 1.3,
                    amountGross: 8.12,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 322,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-03-01",
                    endDate: "2023-03-24",
                    days: 24,
                    amountNet: 4.25,
                    amountTax: 0.81,
                    amountGross: 5.06,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 197,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-03-25",
                    endDate: "2023-07-10",
                    days: 108,
                    amountNet: 2.6,
                    amountTax: 0.49,
                    amountGross: 3.09,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 10,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-07-11",
                    endDate: "2023-07-31",
                    days: 21,
                    amountNet: 0.13,
                    amountTax: 0.02,
                    amountGross: 0.15,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 0,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-08-01",
                    endDate: "2023-08-01",
                    days: 1,
                    amountNet: 0,
                    amountTax: 0,
                    amountGross: 0,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "ConcessionTa",
                    quantity: 5,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0132",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "concession_ta",
                    startDate: "2023-08-02",
                    endDate: "2023-08-12",
                    days: 11,
                    amountNet: 0.07,
                    amountTax: 0.01,
                    amountGross: 0.08,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  }
                ]
              }
            },
            NetworkCarrierFee: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 99.22,
              amountTax: 18.85,
              amountGross: 118.07,
              amountCompensated: 0,
              additionalData: null,
              NetworkCarrierFeeHT: {
                type: "other",
                compensatedSummation: false,
                decimalPlaces: 2,
                calculationRelevant: false,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                amountNet: 99.22,
                amountTax: 18.85,
                amountGross: 118.07,
                amountCompensated: 0,
                additionalData: null,
                invoiceItems: [
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 943,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0418",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2022-08-13",
                    endDate: "2022-12-31",
                    days: 141,
                    amountNet: 39.42,
                    amountTax: 7.49,
                    amountGross: 46.91,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 185,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0484",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-01-01",
                    endDate: "2023-01-23",
                    days: 23,
                    amountNet: 8.95,
                    amountTax: 1.7,
                    amountGross: 10.65,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 517,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0484",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-01-24",
                    endDate: "2023-02-28",
                    days: 36,
                    amountNet: 25.02,
                    amountTax: 4.75,
                    amountGross: 29.77,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 322,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0484",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-03-01",
                    endDate: "2023-03-24",
                    days: 24,
                    amountNet: 15.58,
                    amountTax: 2.96,
                    amountGross: 18.54,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 197,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0484",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-03-25",
                    endDate: "2023-07-10",
                    days: 108,
                    amountNet: 9.53,
                    amountTax: 1.81,
                    amountGross: 11.34,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 10,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0484",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-07-11",
                    endDate: "2023-07-31",
                    days: 21,
                    amountNet: 0.48,
                    amountTax: 0.09,
                    amountGross: 0.57,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 0,
                    quantityUnit: "kwh",
                    unitPriceNet: "0",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-08-01",
                    endDate: "2023-08-01",
                    days: 1,
                    amountNet: 0,
                    amountTax: 0,
                    amountGross: 0,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  },
                  {
                    title: "NetworkCarrierFeeHT",
                    quantity: 5,
                    quantityUnit: "kwh",
                    unitPriceNet: "0.0484",
                    unitPriceFactor: 1,
                    taxRate: 19,
                    taxKey: "M19",
                    taxType: "vat_standard",
                    type: "network_carrier_fee",
                    startDate: "2023-08-02",
                    endDate: "2023-08-12",
                    days: 11,
                    amountNet: 0.24,
                    amountTax: 0.05,
                    amountGross: 0.29,
                    amountCompensated: 0,
                    additionalData: "",
                    additionalDataCollection: []
                  }
                ]
              }
            },
            MeterCharge: {
              type: "other",
              compensatedSummation: false,
              decimalPlaces: 2,
              calculationRelevant: false,
              taxRate: 19,
              taxKey: "M19",
              taxType: "vat_standard",
              amountNet: 6.71,
              amountTax: 1.27,
              amountGross: 7.98,
              amountCompensated: 0,
              additionalData: null,
              invoiceItems: [
                {
                  title: "Metercharge",
                  quantity: 141,
                  quantityUnit: "days",
                  unitPriceNet: "6.53",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  amountNet: 2.52,
                  amountTax: 0.48,
                  amountGross: 3,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 23,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  amountNet: 0.43,
                  amountTax: 0.08,
                  amountGross: 0.51,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 36,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  amountNet: 0.67,
                  amountTax: 0.13,
                  amountGross: 0.8,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 24,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  amountNet: 0.45,
                  amountTax: 0.09,
                  amountGross: 0.54,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 108,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  amountNet: 2.02,
                  amountTax: 0.38,
                  amountGross: 2.4,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 21,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  amountNet: 0.39,
                  amountTax: 0.07,
                  amountGross: 0.46,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 1,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  amountNet: 0.02,
                  amountTax: 0,
                  amountGross: 0.02,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                },
                {
                  title: "Metercharge",
                  quantity: 11,
                  quantityUnit: "days",
                  unitPriceNet: "6.84",
                  unitPriceFactor: 365,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard",
                  type: "network_meter_charge",
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  amountNet: 0.21,
                  amountTax: 0.04,
                  amountGross: 0.25,
                  amountCompensated: 0,
                  additionalData: "",
                  additionalDataCollection: []
                }
              ]
            },
            gridFees: 205.17,
            gridCosts: 211.88,
            totalConcessionFees: 28.76,
            marketCosts: 382.83,
            sharesInTheCosts: 28.53,
            taxesAndCharges: 234.33
          },
          bonus: {
            type: "bonus",
            compensatedSummation: false,
            decimalPlaces: 2,
            decimalPlacesForQuantity: 2,
            calculationRelevant: true,
            taxRate: 19,
            taxKey: "M19",
            taxType: "vat_bonus",
            amountNet: 0,
            amountTax: 0,
            amountGross: 0,
            amountSettledNet: 0,
            amountSettledTax: 0,
            amountSettledGross: 0,
            amountUnsettledNet: 0,
            amountUnsettledTax: 0,
            amountUnsettledGross: 0,
            amountCompensated: 0,
            additionalData: null,
            bonusItems: [
              {
                baseTypes: "",
                compensatedSummation: false,
                type: "absolute",
                bonusAmountGross: 0,
                bonusAmountNet: 0,
                bonusAmountTax: 0,
                technicalType: "flexbonus",
                itemType: null,
                validFrom: "2022-08-13",
                validUntil: "2023-08-12",
                name: "Mitarbeiterbonus",
                identifier: "FLEXMA",
                reason: "Mitarbeiterbonus Einmalig nach Laufzeit",
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_bonus",
                amountNet: 0,
                amountTax: 0,
                amountGross: 0,
                amountCompensated: 0
              }
            ]
          },
          payments: {
            type: "payment",
            compensatedSummation: false,
            decimalPlaces: 2,
            decimalPlacesForQuantity: 2,
            calculationRelevant: false,
            taxRate: 0,
            taxKey: "S0",
            taxType: "vat_none",
            amountNet: -831,
            amountTax: 0,
            amountGross: -831,
            amountSettledNet: 831,
            amountSettledTax: 0,
            amountSettledGross: 831,
            amountUnsettledNet: 0,
            amountUnsettledTax: 0,
            amountUnsettledGross: 0,
            amountCompensated: 0,
            additionalData: null,
            paymentItems: [
              {
                paidAt: "2022-09-01",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2022-10-05",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2022-11-04",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2022-12-14",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-01-02",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-02-01",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-03-02",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-04-03",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-05-02",
                amount: -69,
                amountSettled: 69,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-06-02",
                amount: -70,
                amountSettled: 70,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-07-03",
                amount: -70,
                amountSettled: 70,
                amountUnsettled: 0
              },
              {
                paidAt: "2023-08-01",
                amount: -70,
                amountSettled: 70,
                amountUnsettled: 0
              }
            ]
          },
          depositsAfterInvoice: {
            type: "other",
            compensatedSummation: false,
            decimalPlaces: 2,
            decimalPlacesForQuantity: 2,
            calculationRelevant: false,
            taxRate: 19,
            taxKey: "M19",
            taxType: "vat_standard",
            amountNet: 60.5,
            amountTax: 11.5,
            amountGross: 72,
            amountSettledNet: -60.5,
            amountSettledTax: -11.5,
            amountSettledGross: -72,
            amountUnsettledNet: 0,
            amountUnsettledTax: 0,
            amountUnsettledGross: 0,
            amountCompensated: 0,
            additionalData: null,
            receivables: [
              {
                amountNet: 60.5,
                amountTax: 11.5,
                amountGross: 72,
                amountSettledNet: -60.5,
                amountSettledTax: -11.5,
                amountSettledGross: -72,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-09-01",
                paidAt: "2023-09-04"
              }
            ]
          },
          deposits: {
            type: "prepayment",
            compensatedSummation: false,
            decimalPlaces: 2,
            decimalPlacesForQuantity: 2,
            calculationRelevant: false,
            taxRate: 19,
            taxKey: "M19",
            taxType: "vat_standard",
            amountNet: 698.28,
            amountTax: 132.72,
            amountGross: 831,
            amountSettledNet: -698.28,
            amountSettledTax: -132.72,
            amountSettledGross: -831,
            amountUnsettledNet: 0,
            amountUnsettledTax: 0,
            amountUnsettledGross: 0,
            amountCompensated: 0,
            additionalData: null,
            taxPeriods: [
              {
                type: "prepayment",
                compensatedSummation: false,
                decimalPlaces: 2,
                calculationRelevant: false,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                amountSettledNet: -698.28,
                amountSettledTax: -132.72,
                amountSettledGross: -831,
                amountCompensated: 0
              }
            ],
            receivables: [
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2022-09-01",
                paidAt: "2022-09-01"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2022-10-04",
                paidAt: "2022-10-05"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2022-11-02",
                paidAt: "2022-11-04"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2022-12-01",
                paidAt: "2022-12-14"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-01-02",
                paidAt: "2023-01-02"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-02-01",
                paidAt: "2023-02-01"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-03-01",
                paidAt: "2023-03-02"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-04-03",
                paidAt: "2023-04-03"
              },
              {
                amountNet: 57.98,
                amountTax: 11.02,
                amountGross: 69,
                amountSettledNet: -57.98,
                amountSettledTax: -11.02,
                amountSettledGross: -69,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-05-02",
                paidAt: "2023-05-02"
              },
              {
                amountNet: 58.82,
                amountTax: 11.18,
                amountGross: 70,
                amountSettledNet: -58.82,
                amountSettledTax: -11.18,
                amountSettledGross: -70,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-06-01",
                paidAt: "2023-06-02"
              },
              {
                amountNet: 58.82,
                amountTax: 11.18,
                amountGross: 70,
                amountSettledNet: -58.82,
                amountSettledTax: -11.18,
                amountSettledGross: -70,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-07-03",
                paidAt: "2023-07-03"
              },
              {
                amountNet: 58.82,
                amountTax: 11.18,
                amountGross: 70,
                amountSettledNet: -58.82,
                amountSettledTax: -11.18,
                amountSettledGross: -70,
                amountUnsettledNet: 0,
                amountUnsettledTax: 0,
                amountUnsettledGross: 0,
                taxRate: 19,
                taxKey: "M19",
                taxType: "vat_standard",
                type: "deposit",
                notice: null,
                payableAt: "2023-08-01",
                paidAt: "2023-08-01"
              }
            ]
          },
          energyData: {
            type: "turnus",
            readings: {
              usageHT: 2179,
              usageNT: 0,
              periodsHaveExchangeFactor: false,
              usage: 2179,
              periods: [
                {
                  startDate: "2022-08-13",
                  endDate: "2022-12-31",
                  days: 141,
                  usage: 943,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: "customer",
                  startReadingQualifier: "read",
                  startReadingChannel: "CSS",
                  endReadingOrigin: null,
                  endReadingQualifier: "estimated",
                  endReadingChannel: null,
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 943,
                      usageUnit: "",
                      usageWithoutCorrection: 943,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 3417,
                      endCounterValues: 4360,
                      usageMetered: 943,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-01-01",
                  endDate: "2023-01-23",
                  days: 23,
                  usage: 185,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: null,
                  startReadingQualifier: "estimated",
                  startReadingChannel: null,
                  endReadingOrigin: "customer",
                  endReadingQualifier: "read",
                  endReadingChannel: "CSS",
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 185,
                      usageUnit: "",
                      usageWithoutCorrection: 185,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 4360,
                      endCounterValues: 4545,
                      usageMetered: 185,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-01-24",
                  endDate: "2023-02-28",
                  days: 36,
                  usage: 517,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: "customer",
                  startReadingQualifier: "read",
                  startReadingChannel: "CSS",
                  endReadingOrigin: null,
                  endReadingQualifier: "estimated",
                  endReadingChannel: null,
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 517,
                      usageUnit: "",
                      usageWithoutCorrection: 517,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 4545,
                      endCounterValues: 5062,
                      usageMetered: 517,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  days: 24,
                  usage: 322,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: null,
                  startReadingQualifier: "estimated",
                  startReadingChannel: null,
                  endReadingOrigin: "customer",
                  endReadingQualifier: "read",
                  endReadingChannel: "CSS",
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 322,
                      usageUnit: "",
                      usageWithoutCorrection: 322,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 5062,
                      endCounterValues: 5384,
                      usageMetered: 322,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  days: 108,
                  usage: 197,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: "customer",
                  startReadingQualifier: "read",
                  startReadingChannel: "CSS",
                  endReadingOrigin: "msb",
                  endReadingQualifier: "read",
                  endReadingChannel: "MSCONS",
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 197,
                      usageUnit: "",
                      usageWithoutCorrection: 197,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 5384,
                      endCounterValues: 5581,
                      usageMetered: 197,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  days: 21,
                  usage: 10,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: "msb",
                  startReadingQualifier: "read",
                  startReadingChannel: "MSCONS",
                  endReadingOrigin: null,
                  endReadingQualifier: "estimated",
                  endReadingChannel: null,
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 10,
                      usageUnit: "",
                      usageWithoutCorrection: 10,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 5581,
                      endCounterValues: 5591,
                      usageMetered: 10,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  days: 1,
                  usage: 0,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: null,
                  startReadingQualifier: "estimated",
                  startReadingChannel: null,
                  endReadingOrigin: "customer",
                  endReadingQualifier: "read",
                  endReadingChannel: "CSS",
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 0,
                      usageUnit: "",
                      usageWithoutCorrection: 0,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 5591,
                      endCounterValues: 5591,
                      usageMetered: 0,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                },
                {
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  days: 11,
                  usage: 5,
                  usageUnit: "",
                  counterNumber: "XXX",
                  counterType: "EHZ",
                  counterTypeName: "Elektronischer Haushaltsz\xE4hler",
                  startReadingOrigin: "customer",
                  startReadingQualifier: "read",
                  startReadingChannel: "CSS",
                  endReadingOrigin: "previous_provider",
                  endReadingQualifier: "estimated",
                  endReadingChannel: "SYSTEM",
                  gasCalorificValue: "",
                  gasCondition: "",
                  registers: [
                    {
                      obis: "1-1:1.8.0",
                      billingRegisterType: null,
                      description: null,
                      exchangeFactor: 1,
                      usage: 5,
                      usageUnit: "",
                      usageWithoutCorrection: 5,
                      usageCorrected: 0,
                      externalId: null,
                      startCounterValues: 5591,
                      endCounterValues: 5596,
                      usageMetered: 5,
                      relations: [
                        {
                          rel: "counter",
                          entityType: "counter",
                          id: 599101,
                          counterNumber: "XXXX",
                          jsonPath: "$..contract_counters[?(@.id==599101)]"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            futureReadings: {
              counterNumber: "XXXX",
              counterType: "EHZ",
              counterTypeName: "Elektronischer Haushaltsz\xE4hler",
              registers: [
                {
                  obis: "1-1:1.8.0",
                  description: null,
                  counterValue: 5598,
                  counterValueDate: "2023-08-17"
                }
              ]
            },
            futureDeposits: {
              taxType: "vat_standard",
              deposits: [
                {
                  dueDate: "2023-10-02",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2023-11-02",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2023-12-01",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-01-02",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-02-01",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-03-01",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-04-02",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-05-02",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-06-03",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-07-01",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-08-01",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                },
                {
                  dueDate: "2024-09-02",
                  isAccounted: false,
                  amountNet: 61.34,
                  amountTax: 11.66,
                  amountGross: 73,
                  taxRate: 19,
                  taxKey: "M19",
                  taxType: "vat_standard"
                }
              ]
            },
            comparisonGraph: {
              previousUsageDays: 365,
              previousUsage: 2141,
              currentUsageDays: 365,
              currentUsage: 2179,
              usageForecastDays: 366,
              usageForecast: 2176,
              currentUsageYearly: 2179,
              comparisonTurnusUsage: [
                {
                  turnusStartDate: "2022-08-13",
                  turnusEndDate: "2023-08-12",
                  realUsage: 2179,
                  realStartDate: "2022-08-13",
                  realEndDate: "2023-08-12",
                  realUsageDays: 365,
                  yearlyEnergyUsage: 2179,
                  usageDays: 365,
                  usageDiffPercentage: 1.7749
                },
                {
                  turnusStartDate: "2021-08-13",
                  turnusEndDate: "2022-08-12",
                  realUsage: 2141,
                  realStartDate: "2021-08-13",
                  realEndDate: "2022-08-12",
                  realUsageDays: 365,
                  yearlyEnergyUsage: 2141,
                  usageDays: 365,
                  usageDiffPercentage: null
                }
              ]
            },
            consumption: {
              totalConsumption: 2179,
              averageDailyConsumption: 5.9699,
              samePeriodLastYear: {
                startDate: "2021-08-13",
                endDate: "2022-08-12",
                consumptionUnit: "kWh",
                totalConsumption: 2141,
                averageDailyConsumption: 5.866
              }
            }
          },
          energyCostsAid: {
            amountGross: 0,
            amountNet: 0,
            amountTax: 0,
            quantity: 919.99,
            aidContingent: {
              referenceUsage: 2300,
              aidContingentYearly: 1840,
              aidContingentGrantedRelativeReferenceUsage: 0.4,
              aidContingentGrantedRelativeAidContingentYearly: 0.5
            },
            energyCostsAidRegular: {
              startDate: "2023-03-01",
              endDate: "2023-08-12",
              quantity: 919.99,
              quantityUnit: "kwh",
              amountNet: 0,
              amountTax: 0,
              amountGross: 0,
              periods: [
                {
                  startDate: "2023-03-01",
                  endDate: "2023-03-24",
                  quantity: 153.33,
                  quantityUnit: "kwh",
                  unitPriceNet: 0,
                  unitPriceGross: 0,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  referenceUnitPriceGross: 0
                },
                {
                  startDate: "2023-03-25",
                  endDate: "2023-07-10",
                  quantity: 613.33,
                  quantityUnit: "kwh",
                  unitPriceNet: 0,
                  unitPriceGross: 0,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  referenceUnitPriceGross: 0
                },
                {
                  startDate: "2023-07-11",
                  endDate: "2023-07-31",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: 0,
                  unitPriceGross: 0,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  referenceUnitPriceGross: 0
                },
                {
                  startDate: "2023-08-01",
                  endDate: "2023-08-01",
                  quantity: 153.33,
                  quantityUnit: "kwh",
                  unitPriceNet: 0,
                  unitPriceGross: 0,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  referenceUnitPriceGross: 0
                },
                {
                  startDate: "2023-08-02",
                  endDate: "2023-08-12",
                  quantity: 0,
                  quantityUnit: "kwh",
                  unitPriceNet: 0,
                  unitPriceGross: 0,
                  amountNet: 0,
                  amountTax: 0,
                  amountGross: 0,
                  referenceUnitPriceGross: 0
                }
              ]
            }
          }
        },
        order: {
          id: "741706",
          createdAt: "2021-07-27 13:07:45",
          orderedAt: "2021-07-27 13:07:45",
          status: "done",
          revokedAt: null,
          relevantStreet: "0",
          zip: "49696",
          city: "Molbergen",
          street: "XXXX",
          houseNumber: "3 a",
          business: "0",
          company: null,
          customerId: "20193333",
          salutation: "2",
          firstname: "Annekatrin",
          surname: "XXXX",
          dateOfBirth: null,
          pointOfDeliveryInBasicSupplyArea: "in_area",
          externalId: "5c28a118-a0e9-45d9-a1a1-4a8676a5c726",
          relocationContractId: null,
          relatedContractType: null,
          relatedContractId: null,
          phoneMobileAreaCode: null,
          phoneMobile: null,
          phoneHomeAreaCode: "XXXX",
          phoneHome: "XXXX",
          phoneBusinessAreaCode: null,
          phoneBusiness: null,
          emailPrivate: "XXX",
          emailBusiness: null,
          researchedCustomer: null,
          energy: "electricity",
          billing_alternativeAddress: "0",
          billing_company: null,
          billing_salutation: "2",
          billing_firstname: "Annekatrin",
          billing_surname: "XXXX",
          billing_careOfRecipient: "",
          billing_zip: "49696",
          billing_country: "",
          billing_countryAlpha2: "",
          billing_city: "Molbergen",
          billing_street: "XXXX",
          billing_houseNumber: "3 a",
          billing_fax: "",
          billing_phone: "XXX",
          billing_email: "XXX",
          relocationAddressTransfer: "",
          iban: "XXX",
          bic: "OLBODEH2XXX",
          bank: "OLDENBURGISCHE LANDESBANK AG",
          alternativeAccountHolder: "XXX",
          directDebit: true,
          paymentProvider: "SEPA Bank",
          paymentProviderData: [],
          campaign: "MITARBEITERTARIF",
          campaignId: "25",
          exportAt: "2021-07-27",
          salesChannel: "any",
          inputChannel: null,
          adsMail: "0",
          adsPhone: "0",
          adsPost: "0",
          previousProvider: "EWE VERTRIEB GmbH",
          previousProduct: "",
          previousProviderCodeNumber: "9903324000006",
          previousProviderCodeNumberProvider: "bdew",
          netCodeNumber: "9900496000005",
          netCodeNumberProvider: "bdew",
          customerNumber: "79354053",
          customerSpecification: "earliest_possible_date",
          relocationAt: null,
          desiredDate: null,
          terminatedAt: null,
          basicSupplyAt: null,
          provider: "EWE VERTRIEB GmbH",
          providerId: "-7",
          product: "Strom Zuhause+ M (12 Monate)",
          productId: "383",
          productCode: "ST-ZH12MA-PC",
          productEco: "1",
          variant: "0",
          productType: "standard",
          priceKey: "ST-ZH12MA-PC",
          counterNumber: "XXX",
          marketLocationIdentifier: null,
          usageInclusive: "0",
          usage: "2300",
          complexPrice: false,
          productWorkingPrice: "26.52",
          productBasePrice: "179.69",
          overConsumptionWorkingPrice: "0",
          productWorkingPriceNetto: "22.2857",
          productBasePriceNetto: "151",
          productBonusNetto: "36.97",
          productInstantBonusNetto: "0",
          energyTax: "0.19",
          productWorkingPriceTax: "4.2343",
          productBasePriceTax: "28.69",
          productBonusTax: "7.03",
          productInstantBonusTax: "0",
          productBonus: "44.000000",
          productBonusPercent: "0",
          productInstantBonus: "0",
          fixedPriceType: "energy",
          fixedPriceMonths: "12",
          fixedPriceDate: null,
          cancellationPeriod: "28",
          cancellationPeriodUnit: "days",
          minimumRuntime: "12",
          minimumRuntimeUnit: "months",
          extensionTime: "12",
          extensionTimeUnit: "months",
          ediProcessId: null,
          vpCode: "22222",
          uvpCode: null,
          extendedData: {
            categories: {
              VART: {
                technicalKey: "VART",
                createdAt: "2020-07-07 07:28:24",
                name: "Versandart",
                position: "5"
              },
              MATARIFINFO: {
                technicalKey: "MATARIFINFO",
                createdAt: "2021-06-07 16:37:56",
                name: "Mitarbeiter Infos",
                position: "9"
              }
            },
            values: {
              VART: [
                {
                  name: "Versandart",
                  technicalKey: "VART",
                  type: "select",
                  value: "E-Mail",
                  createdAt: "2021-07-27 13:07:47",
                  position: "2",
                  fieldValueId: "1514612"
                }
              ],
              MATARIFINFO: [
                {
                  name: "Gesellschaft",
                  technicalKey: "GESELLSCHAFT",
                  type: "text",
                  value: "EWE",
                  createdAt: "2021-07-27 13:07:47",
                  position: "2",
                  fieldValueId: "1514613"
                },
                {
                  name: "AzureObjectID",
                  technicalKey: "AZUREOBJECTID",
                  type: "text",
                  value: "XXX",
                  createdAt: "2021-07-27 13:07:47",
                  position: "3",
                  fieldValueId: "1514614"
                }
              ]
            }
          },
          createdBy: "12",
          signatureDate: "2021-07-27",
          notifier: null,
          waitForConfirmationUntil: null,
          confirmedAt: null,
          additionalValues: [],
          flexbonus: [],
          brand: {
            id: "1",
            data: {
              id: "1",
              name: "EWE",
              isDeleted: "0",
              createdBy: "16",
              createdAt: "2018-10-12 07:25:29"
            },
            additionalData: []
          }
        },
        order_status: {
          id: "741706",
          changedAt: "2021-07-27 13:07:48",
          statusCode: "6000"
        },
        customer: {
          authorizedAt: null,
          createdAt: "2021-01-29 13:10:16",
          zip: "49696",
          city: "Molbergen",
          street: "XXXX",
          houseNumber: "3 a",
          country: "DE",
          countryName: "Deutschland",
          business: "0",
          unknown: "0",
          company: "",
          countryId: "48",
          customerId: "20193333",
          status: "active",
          externalId: null,
          salutation: "2",
          firstname: "Annekatrin",
          title: null,
          surname: "XXX",
          dateOfBirth: null,
          availableSentNotification: "1",
          authUserName: "EFFF9C49-9C60-44AC-AB7D-21E8E22B7EDC",
          authEnabled: "1",
          accountUsername: null,
          accountUseremail: null,
          phoneMobileAreaCode: null,
          phoneMobile: null,
          phoneHomeAreaCode: "XXX",
          phoneHome: "XXX",
          phoneBusinessAreaCode: null,
          phoneBusiness: null,
          emailPrivate: "XXX",
          emailBusiness: "",
          adsMail: "0",
          adsPhone: "0",
          adsPost: "0",
          customerCommunicationType: "0",
          extendedData: {
            categories: {
              ZAHLUNGSMORAL: {
                technicalKey: "ZAHLUNGSMORAL",
                createdAt: "2018-10-22 13:47:25",
                name: "Inkasso",
                position: "4"
              }
            },
            values: {
              ZAHLUNGSMORAL: [
                {
                  name: "Bonit\xE4ts-Score",
                  technicalKey: "BONISCORE",
                  type: "text",
                  value: "A",
                  createdAt: "2022-07-29 10:02:01",
                  position: "2",
                  fieldValueId: "4546964"
                }
              ]
            }
          },
          customerGroups: [],
          customer_insolvencies: []
        },
        contract_status: {
          id: "1000820476",
          changedAt: "2021-08-13 00:15:43",
          statusCode: "5000"
        },
        market_partner: {
          id: "8858",
          partnerId: "9900496000005",
          type: "net",
          externalId: "",
          organization: "EWE NETZ GmbH",
          phone: "",
          activeFrom: null,
          activeUntil: null,
          zip: "26133",
          city: "Oldenburg",
          street: "Cloppenburger Str.",
          energy: "electricity",
          iban: "DE02280400460402349500",
          bic: "COBADEFFXXX",
          accountingAllocationIndicator: "affiliated_with_tax"
        },
        market_location_network_carrier: {
          partnerId: "9900496000005",
          organization: "EWE NETZ GmbH",
          zip: "26133",
          city: "Oldenburg",
          street: "Cloppenburger Str.",
          houseNumber: "302",
          activeFrom: "2021-08-13",
          activeUntil: null,
          year: null,
          basePriceNetto: null,
          meterChargeNetto: null,
          workingPriceNetto: null,
          concessionTa: null,
          concessionSa: null,
          concessionTs: null,
          registerCourt: "Amtsgericht Oldenburg",
          registerNumber: "HRB5236"
        },
        market_location: {
          id: "569675",
          clientId: "3",
          identifier: "50363870690",
          additionalValues: [],
          note: null
        },
        market_location_classifications: [
          {
            id: "365932",
            activeFrom: "2021-08-13",
            activeUntil: null,
            metrologicalClassification: "Z53",
            accountingMethodRight: null,
            marketLocationId: "569675"
          }
        ],
        meter_location: {
          id: "568628",
          clientId: "3",
          identifier: "DE0004964969600000000000011918966"
        },
        meter_locations_list: [
          {
            id: "568628",
            clientId: "3",
            identifier: "DE0004964969600000000000011918966"
          }
        ],
        market_location_measuring_point_operators: [
          {
            zip: "26133",
            city: "Oldenburg",
            street: "Cloppenburger Str.",
            houseNumber: "302",
            organization: "EWE NETZ GmbH",
            partnerId: "9904455000006",
            measuringPointOperatorType: "gMSB",
            activeFrom: "2021-08-13",
            activeUntil: null,
            registerCourt: "Amtsgericht Oldenburg",
            registerNumber: "HRB5236",
            viaNne: "1",
            invoicingOfMme: null
          }
        ],
        meter_location_measuring_point_operators: [
          {
            zip: "26133",
            city: "Oldenburg",
            street: "Cloppenburger Str.",
            houseNumber: "302",
            organization: "EWE NETZ GmbH",
            partnerId: "9904455000006",
            measuringPointOperatorType: "gMSB",
            activeFrom: "2021-08-13",
            activeUntil: null,
            registerCourt: "Amtsgericht Oldenburg",
            registerNumber: "HRB5236"
          }
        ],
        contract_tariff: {
          createdAt: "2023-07-05 09:10:54",
          product: "EWE Zuhause+ Strom M (12 Monate)",
          productCode: "ST-ZH12MA-01",
          activeFrom: "2023-08-13",
          activeUntil: null,
          productEco: "1",
          productType: "standard",
          activeFromOriginal: null,
          basePrice: 199.55,
          meterCharge: "0",
          complexPrice: false,
          workingPrice: 30.83,
          overConsumptionWorkingPrice: "0",
          usageCustomer: "2141",
          productBonus: "0.000000",
          productBonusPercent: "0",
          instantBonus: "0",
          instantBonusDate: "2021-09-10",
          includeBonusInDepositCalculation: "0",
          fixedPriceType: "months_price_excluding_vat_and_new_taxes",
          fixedPriceDate: null,
          fixedPriceMonths: "12",
          priceKey: "ST-ZH12MA-01",
          priceAdjustmentOf: null,
          billingPeriod: "12",
          minimumRuntime: "12",
          extensionTime: "1",
          cancellationPeriod: "1",
          contractProductId: "3144103",
          waitForConfirmationUntil: null,
          confirmedAt: null,
          energyTax: 0.19,
          depositDivisor: "12",
          tariffChangeDate: null,
          basePriceNetto: 167.69,
          workingPriceNetto: 25.9076,
          productBonusNetto: 0,
          instantBonusNetto: 0,
          basePriceTax: 31.86,
          workingPriceTax: 4.9224,
          productBonusTax: 0,
          instantBonusTax: 0,
          instantBonusTaxRate: 19,
          additionalValues: [],
          calculatedFixedPriceDate: "2024-08-12",
          meterPricing: "included",
          flexbonus: [],
          minimumConsumption: null,
          additionalTerminationRightBeforeDelivery: false
        },
        contract_product: {
          contractProductId: "3144103",
          createdAt: "2023-07-05 09:10:55",
          productName: "EWE Zuhause+ Strom M (12 Monate)",
          productCode: "ST-ZH12MA-01",
          productVersion: "12",
          productType: "tariff_list",
          excludedTaxesAndLevies: [],
          flexibleAddons: [],
          addOnOf: null,
          mandatoryAddOn: "0",
          activeFrom: "2023-08-13",
          activeUntil: null,
          contractProductStatus: "active",
          quantity: "1",
          externalOrderNumber: null,
          waitForConfirmationUntil: null,
          confirmedAt: null,
          overwriteUseUsageSplitForElectricity: false,
          additionalTerminationRightBeforeDelivery: false
        },
        contract_properties: [
          {
            propertyKey: "counting_procedure"
          },
          {
            propertyKey: "current_banking_data_id",
            propertyValue: 521724
          },
          {
            propertyKey: "invoice_id_last_non_reversed",
            propertyValue: 3767737
          },
          {
            propertyKey: "loc_thermal",
            propertyValue: {
              type: null,
              identifier: null,
              serviceProvider: null,
              serviceProviderType: null
            }
          },
          {
            propertyKey: "transition_process_started",
            propertyValue: 1
          }
        ],
        contract_deposit: {
          id: 13579629,
          clientId: 3,
          contractId: 1000820476,
          contractTariffId: 10110848,
          createdAt: "2023-09-09 15:05:13",
          createdBy: null,
          activeFrom: "2023-09-10",
          activeUntil: null,
          updatedAt: "2023-09-09 15:05:13",
          updatedBy: null,
          grossAmount: 73,
          blockedUntil: null,
          alternativeDayOfMonth: null,
          nextGenerationAt: "2023-09-19",
          ruleId: "11",
          techKey: "default",
          isSplitted: "0",
          depositSplits: [],
          netAmount: 61.34,
          taxRate: 0.19,
          taxAmount: 11.66,
          nextExecution: {
            useAt: "2023-10-02",
            useFor: "2023-09-01",
            generateAt: "2023-09-19",
            sepaGenerateAt: "2023-09-27"
          }
        },
        contract_counter: {
          createdAt: "2021-07-29 16:57:25",
          createdByAgent: "0",
          id: "599101",
          counterNumber: "XXX",
          counterSize: null,
          activeFrom: "2021-08-13 00:00:00",
          activeUntil: null,
          type: "EHZ",
          typeName: "Elektronischer Haushaltsz\xE4hler",
          energyDirection: "ZRZ",
          dataAcquisition: "MMR",
          tariffCount: "ETZ",
          exchangeType: null,
          exchangeValue: "1",
          registers: [
            {
              activeFrom: "2021-08-13 00:00:00",
              activeUntil: null,
              obis: "1-1:1.8.0",
              description: null,
              digits: "6",
              precision: "0",
              llc: "Z59",
              billingrelevant: true
            }
          ],
          additionalValues: []
        },
        contract_counters: [
          {
            createdAt: "2021-07-29 16:57:25",
            createdByAgent: "0",
            id: "599101",
            counterNumber: "XXX",
            counterSize: null,
            activeFrom: "2021-08-13 00:00:00",
            activeUntil: null,
            type: "EHZ",
            typeName: "Elektronischer Haushaltsz\xE4hler",
            energyDirection: "ZRZ",
            dataAcquisition: "MMR",
            tariffCount: "ETZ",
            exchangeType: null,
            exchangeValue: "1",
            registers: [
              {
                activeFrom: "2021-08-13 00:00:00",
                activeUntil: null,
                obis: "1-1:1.8.0",
                description: null,
                digits: "6",
                precision: "0",
                llc: "Z59",
                billingrelevant: true
              }
            ],
            additionalValues: []
          }
        ],
        contract_banking_data: [
          {
            id: "521724",
            iban: "XXXX",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            activeFrom: "2021-07-27",
            activeUntil: null,
            sepaMandate: "EWE-20193333-1000820476-1",
            accountHolder: "Christian G\xF6thert",
            direction: "inout",
            directDebit: "1",
            createdAt: "2021-07-27 13:07:48"
          }
        ],
        payment_provider: {
          id: "1",
          isDefault: "1",
          name: "SEPA Bank",
          sepaActive: "0",
          creditorId: ""
        },
        product_version: {
          productId: "94",
          version: "3",
          status: "deprecated",
          supplyType: "competitive_supply",
          consumptionType: "household_electricity",
          priceType: "single_price",
          business: "private",
          pricingType: "fixed_pricing",
          usageNtPercentage: "40",
          createdAt: "2021-06-22 10:21:10",
          updatedAt: "2021-06-22 10:24:19",
          releaseRequestedAt: null,
          releasedAt: "2021-06-22 10:24:19",
          deprecatedAt: "2021-08-06 12:20:01",
          lockedAt: null,
          name: "Strom Zuhause+ M (12 Monate)",
          validFrom: "2021-06-15",
          validUntil: "9999-12-31",
          kind: "contract",
          eco: "eco",
          invoiceBase: "reading",
          contractInvoiceCycle: "interval",
          contractInvoiceCycleInterval: "12",
          contractInvoiceCycleIntervalType: "months",
          contractInitialDuration: "12",
          contractInitialDurationType: "months",
          contractExtensionTime: "12",
          contractExtensionTimeType: "months",
          contractCancellationPeriod: "28",
          contractCancellationPeriodType: "days",
          erpExternalId: null,
          erpWeight: null,
          erpStatisticGroup: null,
          erpVolume: null,
          erpVariantGroupCode: null,
          erpProductLink: null,
          erpManufacturer: null,
          erpManufacturerNumber: null,
          erpAccount: null,
          erpAllowSplitAmount: "0",
          cmsAgb: "",
          cmsProperties: "",
          cmsDescriptionInternal: "",
          cmsDescriptionExternal: "",
          cmsFileId: null,
          noteFreetext: "",
          everyTimeCancellable: "0",
          relocationProhibited: "0",
          meterPricing: "Inklusive",
          brand: {
            id: "1",
            data: {
              id: "1",
              name: "EWE",
              isDeleted: "0",
              createdBy: "16",
              createdAt: "2018-10-12 07:25:29"
            },
            additionalData: []
          },
          additionalTerminationRightBeforeDelivery: false,
          billingRuleTemplateId: null
        }
      }
    ],
    additionalInformation: {
      EEGSavings: [
        {
          startDate: "2022-08-13",
          endDate: "2022-12-31",
          quantity: 943,
          quantityUnit: "kwh",
          unitPriceNet: 0.03723,
          amountNet: 35.11,
          amountTax: 6.67,
          amountGross: 41.78
        }
      ]
    },
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "EWE VERTRIEB GmbH",
      street: "Cloppenburger Stra\xDFe 310",
      zip: "26133",
      city: "Oldenburg",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        }
      ]
    }
  }
};

// src/examples/order/order-status-open-1.json
var order_status_open_1_default = {
  EventId: "211430022",
  EventName: "order_status_open",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-01-16 17:05:47",
  CreatedFrom: "PowerCloud",
  Content: {
    version: 8,
    order: {
      id: "1966681",
      createdAt: "2024-01-16 17:05:46",
      orderedAt: "2024-01-16 17:05:46",
      status: "open",
      revokedAt: null,
      relevantStreet: "1",
      zip: "77746",
      city: "Schutterwald",
      street: "Ahornweg",
      houseNumber: "5",
      business: "0",
      company: null,
      customerId: "21292309",
      salutation: "1",
      firstname: "Max",
      surname: "Mustermann",
      dateOfBirth: "1980-10-10",
      pointOfDeliveryInBasicSupplyArea: "out_of_area",
      externalId: null,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: "0160",
      phoneMobile: "0123456",
      phoneHomeAreaCode: "",
      phoneHome: "",
      phoneBusinessAreaCode: "",
      phoneBusiness: "",
      emailPrivate: null,
      emailBusiness: "debug@powercloud.de",
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "0",
      billing_company: "",
      billing_salutation: "1",
      billing_firstname: "Max",
      billing_surname: "Mustermann",
      billing_careOfRecipient: "",
      billing_zip: "77746",
      billing_country: "Deutschland",
      billing_countryAlpha2: "DE",
      billing_city: "Schutterwald",
      billing_street: "Ahornweg",
      billing_houseNumber: "5",
      billing_fax: "",
      billing_phone: "0160 / 0123456",
      billing_email: "debug@powercloud.de",
      relocationAddressTransfer: "none",
      iban: "DE34200400612345533292",
      bic: "",
      bank: "",
      alternativeAccountHolder: "",
      directDebit: false,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "standard",
      campaignId: "3",
      exportAt: "2024-01-16",
      salesChannel: "any",
      inputChannel: "phone",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      previousProvider: "Vattenfall Europe Sales GmbH",
      previousProduct: "Basis Privatstrom",
      previousProviderCodeNumber: "9904383000003",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900580000002",
      netCodeNumberProvider: "bdew",
      customerNumber: "6848648",
      customerSpecification: "earliest_possible_date",
      relocationAt: null,
      desiredDate: "2024-03-01",
      terminatedAt: null,
      basicSupplyAt: null,
      provider: "EWE VERTRIEB GmbH",
      providerId: "-4",
      product: "Strom Solo",
      productId: "152",
      productCode: "E-SOLO_A",
      productEco: "0",
      variant: "1",
      productType: "standard",
      priceKey: "E-SOLO_A",
      counterNumber: "447795065",
      marketLocationIdentifier: "50356575885",
      usageInclusive: "0",
      usage: "3500",
      complexPrice: false,
      productWorkingPrice: "29.7155",
      productBasePrice: "173.24",
      overConsumptionWorkingPrice: "0",
      productWorkingPriceNetto: "24.971",
      productBasePriceNetto: "145.58",
      productBonusNetto: "0",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productWorkingPriceTax: "4.7445",
      productBasePriceTax: "27.66",
      productBonusTax: "0",
      productInstantBonusTax: "0",
      productBonus: "0.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "months_full_price_excluding_vat",
      fixedPriceMonths: "12",
      fixedPriceDate: null,
      cancellationPeriod: "28",
      cancellationPeriodUnit: "days",
      minimumRuntime: "12",
      minimumRuntimeUnit: "months",
      extensionTime: "12",
      extensionTimeUnit: "months",
      ediProcessId: null,
      vpCode: null,
      uvpCode: null,
      extendedData: {
        categories: {},
        values: {}
      },
      createdBy: "9",
      signatureDate: "2024-01-16",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: [],
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      }
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-01-16 17:05:47",
      zip: "77746",
      city: "Schutterwald",
      street: "Ahornweg",
      houseNumber: "5",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "21292309",
      status: "prospective",
      externalId: null,
      salutation: "1",
      firstname: "Max",
      title: "",
      surname: "Mustermann",
      dateOfBirth: "1980-10-10",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: "0160",
      phoneMobile: "0123456",
      phoneHomeAreaCode: "",
      phoneHome: "",
      phoneBusinessAreaCode: "",
      phoneBusiness: "",
      emailPrivate: null,
      emailBusiness: "debug@powercloud.de",
      adsMail: "0",
      adsPhone: "0",
      adsPost: "0",
      customerCommunicationType: "0",
      extendedData: {
        categories: {},
        values: {}
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE81280200501446416800",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    product_version: {
      id: "1598",
      createdBy: "413",
      calculationId: "152",
      importId: null,
      genericId: null,
      updatedBy: "413",
      assignedTo: "621",
      releaseRequestedBy: null,
      releasedBy: "413",
      deprecatedBy: null,
      lockedBy: null,
      brandId: "1",
      productId: "1",
      version: "20",
      status: "released",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "both",
      pricingType: "fixed_pricing",
      usageNtPercentage: null,
      createdAt: "2020-12-28 10:43:27",
      updatedAt: "2020-12-28 10:43:27",
      releaseRequestedAt: null,
      releasedAt: "2022-09-23 10:43:27",
      deprecatedAt: null,
      lockedAt: null,
      name: "Strom Solo",
      validFrom: "2010-11-19",
      validUntil: "9992-02-06",
      kind: "contract",
      eco: "none",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "12",
      contractInitialDurationType: "months",
      contractExtensionTime: "12",
      contractExtensionTimeType: "months",
      contractCancellationPeriod: "28",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      brand: {
        id: "1",
        data: {
          id: "1",
          name: "EWE",
          isDeleted: "0",
          createdBy: "16",
          createdAt: "2018-10-12 07:25:29"
        },
        additionalData: []
      },
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: null
    }
  }
};

// src/examples/order/order-status-open-2.json
var order_status_open_2_default = {
  EventId: "408571950",
  EventName: "order_status_open",
  Environment: "test",
  TenantId: "3",
  CreatedAt: "2024-02-16 09:44:07",
  CreatedFrom: "PowerCloud",
  Content: {
    version: 9,
    order: {
      id: "2969873",
      createdAt: "2024-02-16 09:44:03",
      orderedAt: "2024-02-16 09:44:04",
      status: "open",
      revokedAt: null,
      relevantStreet: "0",
      zip: "26125",
      city: "Oldenburg",
      street: "Wei\xDFenmoorstr.",
      houseNumber: "100b",
      business: "0",
      company: null,
      customerId: "21714123",
      salutation: "2",
      firstname: "Mittag",
      surname: "Caren",
      dateOfBirth: "1964-03-31",
      pointOfDeliveryInBasicSupplyArea: "in_area",
      externalId: null,
      relocationContractId: null,
      relatedContractType: null,
      relatedContractId: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      researchedCustomer: null,
      energy: "electricity",
      billing_alternativeAddress: "0",
      billing_company: null,
      billing_salutation: "2",
      billing_firstname: "Mittag",
      billing_surname: "Caren",
      billing_careOfRecipient: "",
      billing_zip: "26125",
      billing_country: "",
      billing_countryAlpha2: "",
      billing_city: "Oldenburg",
      billing_street: "Wei\xDFenmoorstr.",
      billing_houseNumber: "100b",
      billing_fax: "",
      billing_phone: null,
      billing_email: null,
      relocationAddressTransfer: "",
      iban: null,
      bic: null,
      bank: null,
      alternativeAccountHolder: null,
      directDebit: false,
      paymentProvider: "SEPA Bank",
      paymentProviderData: [],
      campaign: "HOMEPAGE",
      campaignId: "5",
      exportAt: "2024-02-16",
      salesChannel: "online",
      inputChannel: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      previousProvider: "EWE VERTRIEB GmbH",
      previousProduct: "EWE Strom comfort",
      previousProviderCodeNumber: "9903324000006",
      previousProviderCodeNumberProvider: "bdew",
      netCodeNumber: "9900496000005",
      netCodeNumberProvider: "bdew",
      customerNumber: null,
      customerSpecification: "relocation_at",
      relocationAt: "2024-02-10",
      desiredDate: null,
      terminatedAt: null,
      basicSupplyAt: null,
      provider: "EWE",
      providerId: "-7",
      product: "Netto Preis Produkt",
      productId: "2543",
      productCode: "NETTOPREISPRODUKT",
      productEco: "0",
      variant: "0",
      productType: "standard",
      priceKey: "ST-COMFXX-PC",
      counterNumber: "5653564297",
      marketLocationIdentifier: null,
      usageInclusive: "0",
      usage: "2500",
      complexPrice: false,
      productWorkingPrice: "36.97",
      productBasePrice: "199.55",
      overConsumptionWorkingPrice: "0",
      productWorkingPriceNetto: "31.0672",
      productBasePriceNetto: "167.69",
      productBonusNetto: "0",
      productInstantBonusNetto: "0",
      energyTax: "0.19",
      productWorkingPriceTax: "5.9028",
      productBasePriceTax: "31.86",
      productBonusTax: "0",
      productInstantBonusTax: "0",
      productBonus: "0.000000",
      productBonusPercent: "0",
      productInstantBonus: "0",
      fixedPriceType: "none",
      fixedPriceMonths: null,
      fixedPriceDate: null,
      cancellationPeriod: "0",
      cancellationPeriodUnit: "days",
      minimumRuntime: "0",
      minimumRuntimeUnit: "days",
      extensionTime: "0",
      extensionTimeUnit: "days",
      ediProcessId: null,
      vpCode: null,
      uvpCode: null,
      extendedData: {
        categories: {},
        values: {}
      },
      createdBy: "12",
      signatureDate: "2024-02-10",
      notifier: null,
      waitForConfirmationUntil: null,
      confirmedAt: null,
      additionalValues: [],
      flexbonus: []
    },
    customer: {
      authorizedAt: null,
      createdAt: "2024-02-16 09:44:07",
      zip: "26125",
      city: "Oldenburg",
      street: "Wei\xDFenmoorstr.",
      houseNumber: "100b",
      country: "DE",
      countryName: "Deutschland",
      business: "0",
      unknown: "0",
      company: null,
      countryId: "48",
      customerId: "21714123",
      status: "prospective",
      externalId: null,
      salutation: "2",
      firstname: "Mittag",
      title: null,
      surname: "Caren",
      dateOfBirth: "1964-03-31",
      availableSentNotification: "1",
      authEnabled: "0",
      accountUsername: null,
      accountUseremail: null,
      phoneMobileAreaCode: null,
      phoneMobile: null,
      phoneHomeAreaCode: null,
      phoneHome: null,
      phoneBusinessAreaCode: null,
      phoneBusiness: null,
      emailPrivate: null,
      emailBusiness: null,
      adsMail: null,
      adsPhone: null,
      adsPost: null,
      customerCommunicationType: "0",
      extendedData: {
        categories: {},
        values: {}
      },
      customerGroups: [],
      customer_insolvencies: []
    },
    client: {
      providerId: "4999999999999",
      providerIdProvider: "iln",
      providerIdGas: "4888888888888",
      providerIdGasProvider: "iln",
      companyName: "test",
      street: "test",
      zip: "77855",
      city: "Achern",
      sepaBankAccountId: null,
      creditorId: "DE86ZZZ00000023447",
      alternativeAccountHolder: "",
      bankaccounts: [
        {
          id: "5",
          data: {
            id: "5",
            type: "",
            iban: "DE43280200501426292700",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "6",
          data: {
            id: "6",
            type: "",
            iban: "DE59280200501422112100",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "EWE VERTRIEB GmbH",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "7",
          data: {
            id: "7",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "8",
          data: {
            id: "8",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        },
        {
          id: "15",
          data: {
            id: "15",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "16",
          data: {
            id: "16",
            type: "",
            iban: "",
            bic: "",
            bank: "",
            alternativeAccountHolder: null,
            paymentProvider: null
          },
          additionalData: []
        },
        {
          id: "17",
          data: {
            id: "17",
            type: "",
            iban: "DE81280200501446416800",
            bic: "OLBODEH2XXX",
            bank: "OLDENBURGISCHE LANDESBANK AG",
            alternativeAccountHolder: "",
            paymentProvider: "SEPA Bank"
          },
          additionalData: []
        }
      ]
    },
    product_version: {
      productId: "214",
      version: "1",
      status: "released",
      supplyType: "competitive_supply",
      consumptionType: "household_electricity",
      priceType: "single_price",
      business: "private",
      pricingType: "fixed_pricing",
      usageNtPercentage: "40",
      createdAt: "2024-01-26 15:07:35",
      updatedAt: "2024-02-16 09:42:16",
      releaseRequestedAt: null,
      releasedAt: "2024-02-16 09:42:16",
      deprecatedAt: null,
      lockedAt: null,
      name: "Netto Preis Produkt",
      validFrom: "2000-01-01",
      validUntil: "2050-01-31",
      kind: "contract",
      eco: "none",
      invoiceBase: "reading",
      contractInvoiceCycle: "interval",
      contractInvoiceCycleInterval: "12",
      contractInvoiceCycleIntervalType: "months",
      contractInitialDuration: "0",
      contractInitialDurationType: "days",
      contractExtensionTime: "0",
      contractExtensionTimeType: "days",
      contractCancellationPeriod: "0",
      contractCancellationPeriodType: "days",
      erpExternalId: null,
      erpWeight: null,
      erpStatisticGroup: null,
      erpVolume: null,
      erpVariantGroupCode: null,
      erpProductLink: null,
      erpManufacturer: null,
      erpManufacturerNumber: null,
      erpAccount: null,
      erpAllowSplitAmount: "0",
      cmsAgb: "",
      cmsProperties: "",
      cmsDescriptionInternal: "",
      cmsDescriptionExternal: "",
      cmsFileId: null,
      noteFreetext: "",
      everyTimeCancellable: "0",
      relocationProhibited: "0",
      meterPricing: "Inklusive",
      additionalTerminationRightBeforeDelivery: false,
      billingRuleTemplateId: "3"
    }
  }
};

// src/examples/index.ts
var orderExamples = {
  orderStatusOpen1: order_status_open_1_default,
  orderStatusOpen2: order_status_open_2_default
};
var contractExamples = {
  contractRequestCustomerReading1: contract_request_customer_reading_1_default,
  contractRequestCustomerReading2: contract_request_customer_reading_2_default,
  contractRequestCustomerReading3: contract_request_customer_reading_3_default,
  contractRequestCustomerReading4: contract_request_customer_reading_4_default,
  contractRequestCustomerReading5: contract_request_customer_reading_5_default,
  contractRequestCustomerReading6: contract_request_customer_reading_6_default,
  contractRequestCustomerReading7: contract_request_customer_reading_7_default,
  contractRequestCustomerReading8: contract_request_customer_reading_8_default,
  contractRequestCustomerReading9: contract_request_customer_reading_9_default,
  contractRequestCustomerReading10: contract_request_customer_reading_10_default
};
var invoiceExamples = {
  invoiceCreatedElectricity1: invoice_created_electricity_1_default
};
var powercloudEventExamples = {
  order: orderExamples,
  contract: contractExamples,
  invoice: invoiceExamples
};
function getExampleByEventName(eventName) {
  if (eventName.startsWith("order_")) {
    return Object.values(orderExamples);
  } else if (eventName.startsWith("contract_")) {
    return Object.values(contractExamples);
  } else if (eventName.startsWith("invoice_")) {
    return Object.values(invoiceExamples);
  }
  return [];
}
function getAllExamples() {
  return [
    ...Object.values(orderExamples),
    ...Object.values(contractExamples),
    ...Object.values(invoiceExamples)
  ];
}

// src/generators/PowercloudEventGenerator.ts
import { faker as faker6 } from "@faker-js/faker";

// src/generators/CustomerGenerator.ts
import { faker as faker3 } from "@faker-js/faker";

// src/generators/shared/addressGenerator.ts
import { faker } from "@faker-js/faker";

// src/generators/shared/constants.ts
var ENVIRONMENTS = ["test", "production"];
var TENANT_IDS = ["3"];
var CREATED_FROM = ["PowerCloud"];
var ORDER_EVENT_NAMES = ["order_status_open"];
var CONTRACT_EVENT_NAMES = [
  "contract_request_customer_reading",
  "contract_change_customer_bank_data",
  "contract_deposit_changed",
  "contract_tariff_change_revoke_rejected",
  "contract_installment_plan_activated",
  "contract_installment_plan_ended"
];
var INVOICE_EVENT_NAMES = ["invoice_created_electricity"];
var ENERGY_TYPES = ["electricity", "gas"];
var SALUTATIONS = ["1", "2"];
var CUSTOMER_COMMUNICATION_TYPES = ["0", "1", "2"];
var BUSINESS_FLAGS = ["0", "1"];
var BOOLEAN_STRING_FLAGS = ["0", "1"];
var COUNTRIES = ["DE"];
var COUNTRY_NAMES = ["Deutschland"];
var GERMAN_CITIES = [
  { city: "Moers", zip: "47447" },
  { city: "Schutterwald", zip: "77746" },
  { city: "Oldenburg", zip: "26121" },
  { city: "Bremen", zip: "28195" },
  { city: "Hamburg", zip: "20095" },
  { city: "Berlin", zip: "10115" },
  { city: "M\xFCnchen", zip: "80331" }
];
var GERMAN_STREETS = [
  "Hauptstra\xDFe",
  "Bahnhofstra\xDFe",
  "Kirchstra\xDFe",
  "Schulstra\xDFe",
  "Dorfstra\xDFe",
  "Lindenstra\xDFe",
  "Gartenstra\xDFe",
  "Friedhofstra\xDFe",
  "Ahornweg",
  "Feuerbachstr."
];
var GERMAN_AREA_CODES = [
  "030",
  "040",
  "069",
  "089",
  "0221",
  "0211",
  "0231",
  "0511",
  "0721",
  "04441"
];
var GERMAN_BANKS = [
  "DEUTSCHE KREDITBANK BERLIN",
  "UNICREDIT BANK - HYPOVEREINSBANK",
  "COMMERZBANK AG",
  "DEUTSCHE BANK AG",
  "SPARKASSE"
];
var PAYMENT_PROVIDERS = ["SEPA Bank", "SEPA"];
var BRANDS = [{ id: "1", name: "EWE" }];
var CONTRACT_TYPES = ["energy"];
var CONTRACT_STATUSES = ["active", "inactive"];
var ORDER_STATUSES = ["open", "closed", "cancelled"];
var EXTENDED_DATA_CATEGORIES = {
  VART: {
    technicalKey: "VART",
    name: "Versandart",
    position: "6"
  },
  ZAHLUNGSMORAL: {
    technicalKey: "ZAHLUNGSMORAL",
    name: "Inkasso",
    position: "5"
  }
};
var VERSANDART_VALUES = ["E-Mail", "Brief"];
var BONISCORE_VALUES = ["A", "B", "C", "D"];
var COUNTER_TYPES = ["MME", "AMM"];
var COUNTER_TYPE_NAMES = [
  "moderne Messeinrichtung",
  "Analoger Messeinrichtung"
];
var DUNNING_PROCEDURES = ["DUMMY (JDS)", "Standard"];
var METER_PRICING = ["included", "Inklusive"];
var SUPPLY_TYPES = ["competitive_supply", "basic_supply"];
var CONSUMPTION_TYPES = [
  "household_electricity",
  "business_electricity"
];
var PRICE_TYPES = ["single_price", "double_price"];
var PRICING_TYPES = ["fixed_pricing", "variable_pricing"];
var CAMPAIGNS = ["MIGRATION", "STANDARD", "PREMIUM"];
var SALES_CHANNELS = ["Online", "Telefon", "Haust\xFCr"];
var INPUT_CHANNELS = ["Web", "Call Center", "Field Sales"];

// src/generators/shared/addressGenerator.ts
function generateGermanAddress() {
  const cityData = faker.helpers.arrayElement(GERMAN_CITIES);
  const street = faker.helpers.arrayElement(GERMAN_STREETS);
  const houseNumber = faker.number.int({ min: 1, max: 999 }).toString();
  return {
    zip: cityData.zip,
    city: cityData.city,
    street,
    houseNumber,
    countryId: faker.helpers.arrayElement(COUNTRIES),
    country: faker.helpers.arrayElement(COUNTRIES),
    countryName: faker.helpers.arrayElement(COUNTRY_NAMES),
    floor: faker.helpers.maybe(
      () => faker.number.int({ min: 1, max: 10 }).toString(),
      { probability: 0.2 }
    )
  };
}
function generateBillingAddress() {
  const address = generateGermanAddress();
  return {
    billing_zip: address.zip,
    billing_city: address.city,
    billing_street: address.street,
    billing_houseNumber: address.houseNumber,
    billing_country: address.countryName,
    billing_countryAlpha2: address.countryId
  };
}
function generateBasicAddress() {
  const cityData = faker.helpers.arrayElement(GERMAN_CITIES);
  const street = faker.helpers.arrayElement(GERMAN_STREETS);
  const houseNumber = faker.number.int({ min: 1, max: 999 }).toString();
  return {
    zip: cityData.zip,
    city: cityData.city,
    street,
    houseNumber,
    countryId: faker.helpers.arrayElement(COUNTRIES)
  };
}

// src/generators/shared/dateGenerator.ts
import { faker as faker2 } from "@faker-js/faker";
function formatDate(date, format) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  if (format === "timestamp") {
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day}`;
}
function generatePowerCloudTimestamp(options) {
  const date = faker2.date.between({
    from: options?.from || /* @__PURE__ */ new Date("2020-01-01"),
    to: options?.to || /* @__PURE__ */ new Date()
  });
  return formatDate(date, "timestamp");
}
function generatePowerCloudDate(options) {
  const date = faker2.date.between({
    from: options?.from || /* @__PURE__ */ new Date("1950-01-01"),
    to: options?.to || /* @__PURE__ */ new Date()
  });
  return formatDate(date, "date");
}
function generateDateOfBirth() {
  const date = faker2.date.between({
    from: /* @__PURE__ */ new Date("1930-01-01"),
    to: /* @__PURE__ */ new Date("2005-12-31")
  });
  return formatDate(date, "date");
}
function generateFutureDate(fromNow) {
  const from = /* @__PURE__ */ new Date();
  if (fromNow) {
    from.setDate(from.getDate() + fromNow);
  }
  const date = faker2.date.between({
    from,
    to: new Date(Date.now() + 365 * 24 * 60 * 60 * 1e3)
    // 1 year from now
  });
  return formatDate(date, "date");
}
function generatePastDate(daysAgo) {
  const to = /* @__PURE__ */ new Date();
  if (daysAgo) {
    to.setDate(to.getDate() - daysAgo);
  }
  const date = faker2.date.between({
    from: new Date(Date.now() - 365 * 24 * 60 * 60 * 1e3),
    // 1 year ago
    to
  });
  return formatDate(date, "date");
}

// src/generators/CustomerGenerator.ts
function generateCustomerExtendedData() {
  return {
    categories: {
      ZAHLUNGSMORAL: {
        technicalKey: EXTENDED_DATA_CATEGORIES.ZAHLUNGSMORAL.technicalKey,
        createdAt: generatePowerCloudTimestamp(),
        name: EXTENDED_DATA_CATEGORIES.ZAHLUNGSMORAL.name,
        position: EXTENDED_DATA_CATEGORIES.ZAHLUNGSMORAL.position
      }
    },
    values: {
      ZAHLUNGSMORAL: [
        {
          name: "Bonit\xE4ts-Score",
          technicalKey: "BONISCORE",
          type: "text",
          value: faker3.helpers.arrayElement(BONISCORE_VALUES),
          createdAt: generatePowerCloudTimestamp(),
          position: "2",
          fieldValueId: faker3.string.numeric(7)
        }
      ]
    }
  };
}
var customerIdCounter = 2e7;
function generateCustomer(overrides = {}) {
  const address = generateGermanAddress();
  return {
    authorizedAt: overrides.authorizedAt ?? null,
    createdAt: overrides.createdAt ?? generatePowerCloudTimestamp(),
    // Address fields
    zip: overrides.zip ?? address.zip,
    city: overrides.city ?? address.city,
    street: overrides.street ?? address.street,
    houseNumber: overrides.houseNumber ?? address.houseNumber,
    country: overrides.country ?? address.country,
    countryName: overrides.countryName ?? address.countryName,
    business: overrides.business ?? faker3.helpers.arrayElement(BUSINESS_FLAGS),
    unknown: overrides.unknown ?? faker3.helpers.arrayElement(BUSINESS_FLAGS),
    company: overrides.company ?? (faker3.helpers.maybe(() => faker3.company.name(), { probability: 0.3 }) || "Firma Anonym"),
    countryId: overrides.countryId ?? address.countryId,
    customerId: overrides.customerId ?? (++customerIdCounter).toString(),
    status: overrides.status ?? faker3.helpers.arrayElement(["active", "inactive"]),
    externalId: overrides.externalId ?? null,
    // Personal details
    salutation: overrides.salutation ?? faker3.helpers.arrayElement(SALUTATIONS),
    firstname: overrides.firstname ?? faker3.person.firstName(),
    title: overrides.title ?? (faker3.helpers.maybe(() => faker3.person.prefix(), { probability: 0.2 }) || null),
    surname: overrides.surname ?? faker3.person.lastName(),
    dateOfBirth: overrides.dateOfBirth ?? generateDateOfBirth(),
    // Notifications and auth
    availableSentNotification: overrides.availableSentNotification ?? faker3.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    authUserName: overrides.authUserName ?? faker3.internet.userName(),
    authEnabled: overrides.authEnabled ?? faker3.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    accountUsername: overrides.accountUsername ?? null,
    accountUseremail: overrides.accountUseremail ?? null,
    // Phone contacts
    phoneMobileAreaCode: overrides.phoneMobileAreaCode ?? (faker3.helpers.maybe(() => "0160", { probability: 0.7 }) || ""),
    phoneMobile: overrides.phoneMobile ?? (faker3.helpers.maybe(() => faker3.string.numeric(7), {
      probability: 0.7
    }) || ""),
    phoneHomeAreaCode: overrides.phoneHomeAreaCode ?? faker3.helpers.arrayElement(["01234", "02345", "03456"]),
    phoneHome: overrides.phoneHome ?? faker3.string.numeric(8),
    phoneBusinessAreaCode: overrides.phoneBusinessAreaCode ?? (faker3.helpers.maybe(() => "1234", { probability: 0.3 }) || ""),
    phoneBusiness: overrides.phoneBusiness ?? (faker3.helpers.maybe(() => faker3.string.numeric(8), {
      probability: 0.3
    }) || ""),
    // Email contacts
    emailPrivate: overrides.emailPrivate ?? faker3.internet.email(),
    emailBusiness: overrides.emailBusiness ?? faker3.internet.email(),
    // Marketing preferences
    adsMail: overrides.adsMail ?? faker3.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    adsPhone: overrides.adsPhone ?? faker3.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    adsPost: overrides.adsPost ?? faker3.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    customerCommunicationType: overrides.customerCommunicationType ?? faker3.helpers.arrayElement(CUSTOMER_COMMUNICATION_TYPES),
    // Extended data and related arrays
    extendedData: overrides.extendedData ?? generateCustomerExtendedData(),
    customerGroups: overrides.customerGroups ?? [],
    customer_insolvencies: overrides.customer_insolvencies ?? []
  };
}

// src/generators/OrderGenerator.ts
import { faker as faker5 } from "@faker-js/faker";

// src/generators/shared/bankingGenerator.ts
import { faker as faker4 } from "@faker-js/faker";
function generateGermanIBAN() {
  const bankCode = faker4.string.numeric(8);
  const accountNumber = faker4.string.numeric(10);
  const checkDigits = faker4.string.numeric(2);
  return `DE${checkDigits}${bankCode}${accountNumber}`;
}
function generateGermanBIC() {
  const bankCode = faker4.string.alpha(4).toUpperCase();
  const location = faker4.helpers.arrayElement(["001", "M01", "XXX"]);
  return `${bankCode}DE${location}`;
}
function generateSepaMandate(customerId, contractId) {
  const customer = customerId || faker4.string.numeric(8);
  const contract = contractId || faker4.string.numeric(10);
  const sequence = faker4.number.int({ min: 1, max: 9 });
  return `EWE-${customer}-${contract}-${sequence}`;
}
function generateBankingData(options) {
  const iban = generateGermanIBAN();
  const bic = generateGermanBIC();
  const bank = faker4.helpers.arrayElement(GERMAN_BANKS);
  return {
    directDebit: options?.directDebit ?? faker4.datatype.boolean({ probability: 0.8 }),
    // Most customers use direct debit
    iban: options?.iban ?? iban,
    bic: options?.bic ?? bic,
    bank: options?.bank ?? bank,
    alternativeAccountHolder: options?.alternativeAccountHolder ?? faker4.person.fullName(),
    sepaMandate: options?.sepaMandate ?? generateSepaMandate(options?.customerId, options?.contractId),
    paymentProvider: options?.paymentProvider ?? faker4.helpers.arrayElement(PAYMENT_PROVIDERS),
    direction: options?.direction ?? "inout",
    activeFrom: options?.activeFrom ?? faker4.date.recent().toISOString().split("T")[0],
    activeUntil: options?.activeUntil ?? void 0,
    replacedBankId: options?.replacedBankId ?? void 0
  };
}
function generateFutureBankingData() {
  return faker4.helpers.maybe(() => [generateBankingData()], { probability: 0.1 }) || [];
}

// src/generators/OrderGenerator.ts
var orderIdCounter = 19e5;
function generateOrderExtendedData() {
  const vartValue = faker5.helpers.arrayElement(VERSANDART_VALUES);
  const zsturValue = faker5.helpers.arrayElement(["0", "1"]);
  return {
    categories: {
      VART: {
        technicalKey: "VART",
        createdAt: generatePowerCloudTimestamp(),
        name: "Versandart",
        position: "1"
      }
    },
    values: {
      VART: [
        {
          name: "Versandart",
          technicalKey: "VART",
          type: "text",
          value: vartValue,
          createdAt: generatePowerCloudTimestamp(),
          position: "1",
          fieldValueId: faker5.string.numeric(6)
        }
      ],
      ZSTURVORHANDEN: [
        {
          name: "Kundenvorteil genutzt",
          technicalKey: "ZSTURVORHANDEN",
          type: "text",
          value: zsturValue,
          createdAt: generatePowerCloudTimestamp(),
          position: "2",
          fieldValueId: faker5.string.numeric(6)
        }
      ]
    }
  };
}
function generateOrder(overrides = {}) {
  const address = generateGermanAddress();
  const billingAddress = generateBillingAddress();
  const banking = generateBankingData({ customerId: overrides.customerId });
  const timestamp = generatePowerCloudTimestamp();
  const workingPriceNetto = faker5.number.float({
    min: 20,
    max: 40,
    multipleOf: 1e-3
  });
  const basePriceNetto = faker5.number.float({
    min: 100,
    max: 200,
    multipleOf: 0.01
  });
  const energyTax = 0.19;
  const workingPriceTax = workingPriceNetto * energyTax;
  const basePriceTax = basePriceNetto * energyTax;
  return {
    id: overrides.id ?? (++orderIdCounter).toString(),
    createdAt: overrides.createdAt ?? timestamp,
    orderedAt: overrides.orderedAt ?? timestamp,
    status: overrides.status ?? faker5.helpers.arrayElement(ORDER_STATUSES),
    revokedAt: overrides.revokedAt,
    relevantStreet: overrides.relevantStreet ?? faker5.helpers.arrayElement(["0", "1"]),
    // Basic address fields
    zip: overrides.zip ?? address.zip,
    city: overrides.city ?? address.city,
    street: overrides.street ?? address.street,
    houseNumber: overrides.houseNumber ?? address.houseNumber,
    business: overrides.business ?? faker5.helpers.arrayElement(BUSINESS_FLAGS),
    company: overrides.company ?? (faker5.helpers.maybe(() => faker5.company.name(), { probability: 0.3 }) || void 0),
    customerId: overrides.customerId ?? faker5.string.numeric(8),
    // Personal details
    salutation: overrides.salutation ?? faker5.helpers.arrayElement(SALUTATIONS),
    firstname: overrides.firstname ?? faker5.person.firstName(),
    surname: overrides.surname ?? faker5.person.lastName(),
    dateOfBirth: overrides.dateOfBirth ?? generateDateOfBirth(),
    pointOfDeliveryInBasicSupplyArea: overrides.pointOfDeliveryInBasicSupplyArea ?? faker5.helpers.arrayElement(["in_area", "out_of_area", "unknown"]),
    externalId: overrides.externalId ?? null,
    // Contract relations
    relocationContractId: overrides.relocationContractId ?? null,
    relatedContractType: overrides.relatedContractType ?? null,
    relatedContractId: overrides.relatedContractId ?? null,
    // Phone contacts
    phoneMobileAreaCode: overrides.phoneMobileAreaCode ?? faker5.helpers.arrayElement([
      "0160",
      "0170",
      "0171",
      "0172",
      "0173",
      "0174",
      "0175",
      "0176",
      "0177",
      "0178",
      "0179"
    ]),
    phoneMobile: overrides.phoneMobile ?? faker5.string.numeric(7),
    phoneHomeAreaCode: overrides.phoneHomeAreaCode ?? (faker5.helpers.maybe(
      () => faker5.helpers.arrayElement(GERMAN_AREA_CODES),
      { probability: 0.7 }
    ) || ""),
    phoneHome: overrides.phoneHome ?? (faker5.helpers.maybe(() => faker5.string.numeric(7), {
      probability: 0.7
    }) || ""),
    phoneBusinessAreaCode: overrides.phoneBusinessAreaCode ?? (faker5.helpers.maybe(
      () => faker5.helpers.arrayElement(GERMAN_AREA_CODES),
      { probability: 0.3 }
    ) || ""),
    phoneBusiness: overrides.phoneBusiness ?? (faker5.helpers.maybe(() => faker5.string.numeric(7), {
      probability: 0.3
    }) || ""),
    // Email contacts
    emailPrivate: overrides.emailPrivate ?? void 0,
    emailBusiness: overrides.emailBusiness ?? faker5.internet.email(),
    researchedCustomer: overrides.researchedCustomer ?? void 0,
    energy: overrides.energy ?? faker5.helpers.arrayElement(ENERGY_TYPES),
    // Billing address fields
    billing_alternativeAddress: overrides.billing_alternativeAddress ?? faker5.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    billing_company: overrides.billing_company ?? "",
    billing_salutation: overrides.billing_salutation ?? faker5.helpers.arrayElement(SALUTATIONS),
    billing_firstname: overrides.billing_firstname ?? faker5.person.firstName(),
    billing_surname: overrides.billing_surname ?? faker5.person.lastName(),
    billing_careOfRecipient: overrides.billing_careOfRecipient ?? "",
    billing_zip: overrides.billing_zip ?? billingAddress.billing_zip,
    billing_country: overrides.billing_country ?? billingAddress.billing_country,
    billing_countryAlpha2: overrides.billing_countryAlpha2 ?? billingAddress.billing_countryAlpha2,
    billing_city: overrides.billing_city ?? billingAddress.billing_city,
    billing_street: overrides.billing_street ?? billingAddress.billing_street,
    billing_houseNumber: overrides.billing_houseNumber ?? billingAddress.billing_houseNumber,
    billing_fax: overrides.billing_fax ?? "",
    billing_phone: overrides.billing_phone ?? `${faker5.helpers.arrayElement(GERMAN_AREA_CODES)} / ${faker5.string.numeric(7)}`,
    billing_email: overrides.billing_email ?? faker5.internet.email(),
    relocationAddressTransfer: overrides.relocationAddressTransfer ?? faker5.helpers.arrayElement(["none", "full", "partial"]),
    // Banking details
    iban: overrides.iban ?? banking.iban,
    bic: overrides.bic ?? banking.bic,
    bank: overrides.bank ?? banking.bank,
    alternativeAccountHolder: overrides.alternativeAccountHolder ?? "",
    directDebit: overrides.directDebit ?? banking.directDebit,
    paymentProvider: overrides.paymentProvider ?? faker5.helpers.arrayElement(PAYMENT_PROVIDERS),
    paymentProviderData: overrides.paymentProviderData ?? [],
    // Campaign and sales
    campaign: overrides.campaign ?? faker5.helpers.arrayElement(CAMPAIGNS).toLowerCase(),
    campaignId: overrides.campaignId ?? faker5.number.int({ min: 1, max: 10 }).toString(),
    exportAt: overrides.exportAt ?? generatePowerCloudDate(),
    salesChannel: overrides.salesChannel ?? faker5.helpers.arrayElement(SALES_CHANNELS).toLowerCase(),
    inputChannel: overrides.inputChannel ?? faker5.helpers.arrayElement(INPUT_CHANNELS).toLowerCase(),
    // Marketing preferences
    adsMail: overrides.adsMail ?? faker5.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    adsPhone: overrides.adsPhone ?? faker5.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    adsPost: overrides.adsPost ?? faker5.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    // Provider information
    previousProvider: overrides.previousProvider ?? faker5.helpers.arrayElement([
      "Vattenfall Europe Sales GmbH",
      "E.ON Energie Deutschland GmbH",
      "RWE Vertrieb AG"
    ]),
    previousProduct: overrides.previousProduct ?? faker5.helpers.arrayElement([
      "Basis Privatstrom",
      "Grundversorgung",
      "Standard Tarif"
    ]),
    previousProviderCodeNumber: overrides.previousProviderCodeNumber ?? faker5.string.numeric(13),
    previousProviderCodeNumberProvider: overrides.previousProviderCodeNumberProvider ?? "bdew",
    netCodeNumber: overrides.netCodeNumber ?? faker5.string.numeric(13),
    netCodeNumberProvider: overrides.netCodeNumberProvider ?? "bdew",
    customerNumber: overrides.customerNumber ?? faker5.string.numeric(7),
    customerSpecification: overrides.customerSpecification ?? faker5.helpers.arrayElement([
      "earliest_possible_date",
      "specific_date",
      "relocation"
    ]),
    // Dates
    relocationAt: overrides.relocationAt ?? null,
    desiredDate: overrides.desiredDate ?? generateFutureDate(30),
    terminatedAt: overrides.terminatedAt ?? null,
    basicSupplyAt: overrides.basicSupplyAt ?? null,
    // Product details
    provider: overrides.provider ?? "EWE VERTRIEB GmbH",
    providerId: overrides.providerId ?? "-4",
    product: overrides.product ?? faker5.helpers.arrayElement(["Strom Solo", "Gas Solo", "Kombi Tarif"]),
    productId: overrides.productId ?? faker5.number.int({ min: 100, max: 200 }).toString(),
    productCode: overrides.productCode ?? `${faker5.helpers.arrayElement(["E", "G"])}-${faker5.string.alpha(4).toUpperCase()}_A`,
    productEco: overrides.productEco ?? faker5.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    variant: overrides.variant ?? faker5.number.int({ min: 1, max: 3 }).toString(),
    productType: overrides.productType ?? faker5.helpers.arrayElement(["standard", "eco", "premium"]),
    priceKey: overrides.priceKey ?? `${faker5.helpers.arrayElement(["E", "G"])}-${faker5.string.alpha(4).toUpperCase()}_A`,
    counterNumber: overrides.counterNumber ?? faker5.string.numeric(9),
    marketLocationIdentifier: overrides.marketLocationIdentifier ?? faker5.string.numeric(11),
    usageInclusive: overrides.usageInclusive ?? faker5.helpers.arrayElement(BOOLEAN_STRING_FLAGS),
    usage: overrides.usage ?? faker5.number.int({ min: 1500, max: 8e3 }).toString(),
    complexPrice: overrides.complexPrice ?? false,
    // Pricing details
    productWorkingPrice: overrides.productWorkingPrice ?? (workingPriceNetto + workingPriceTax).toFixed(4),
    productBasePrice: overrides.productBasePrice ?? (basePriceNetto + basePriceTax).toFixed(2),
    overConsumptionWorkingPrice: overrides.overConsumptionWorkingPrice ?? "0",
    productWorkingPriceNetto: overrides.productWorkingPriceNetto ?? workingPriceNetto.toFixed(3),
    productBasePriceNetto: overrides.productBasePriceNetto ?? basePriceNetto.toFixed(2),
    productBonusNetto: overrides.productBonusNetto ?? "0",
    productInstantBonusNetto: overrides.productInstantBonusNetto ?? "0",
    energyTax: overrides.energyTax ?? energyTax.toString(),
    productWorkingPriceTax: overrides.productWorkingPriceTax ?? workingPriceTax.toFixed(4),
    productBasePriceTax: overrides.productBasePriceTax ?? basePriceTax.toFixed(2),
    productBonusTax: overrides.productBonusTax ?? "0",
    productInstantBonusTax: overrides.productInstantBonusTax ?? "0",
    productBonus: overrides.productBonus ?? "0.000000",
    productBonusPercent: overrides.productBonusPercent ?? "0",
    productInstantBonus: overrides.productInstantBonus ?? "0",
    // Contract terms
    fixedPriceType: overrides.fixedPriceType ?? faker5.helpers.arrayElement([
      "months_full_price_excluding_vat",
      "months_full_price_including_vat",
      "no_fixed_price"
    ]),
    fixedPriceMonths: overrides.fixedPriceMonths ?? faker5.helpers.arrayElement(["12", "24", "36"]),
    fixedPriceDate: overrides.fixedPriceDate ?? null,
    cancellationPeriod: overrides.cancellationPeriod ?? faker5.helpers.arrayElement(["28", "30", "60"]),
    cancellationPeriodUnit: overrides.cancellationPeriodUnit ?? "days",
    minimumRuntime: overrides.minimumRuntime ?? faker5.helpers.arrayElement(["12", "24"]),
    minimumRuntimeUnit: overrides.minimumRuntimeUnit ?? "months",
    extensionTime: overrides.extensionTime ?? faker5.helpers.arrayElement(["12", "24"]),
    extensionTimeUnit: overrides.extensionTimeUnit ?? "months",
    // Process identifiers
    ediProcessId: overrides.ediProcessId ?? null,
    vpCode: overrides.vpCode ?? null,
    uvpCode: overrides.uvpCode ?? null,
    // Extended data and related
    extendedData: overrides.extendedData ?? generateOrderExtendedData(),
    createdBy: overrides.createdBy ?? faker5.number.int({ min: 1, max: 1e3 }).toString(),
    signatureDate: overrides.signatureDate ?? generatePowerCloudDate(),
    notifier: overrides.notifier ?? null,
    waitForConfirmationUntil: overrides.waitForConfirmationUntil ?? null,
    confirmedAt: overrides.confirmedAt ?? null,
    additionalValues: overrides.additionalValues ?? [],
    flexbonus: overrides.flexbonus ?? [],
    brand: overrides.brand ?? {
      id: BRANDS[0].id,
      data: {
        id: BRANDS[0].id,
        name: BRANDS[0].name,
        isDeleted: "0",
        createdBy: faker5.string.numeric(2),
        createdAt: generatePowerCloudTimestamp()
      },
      additionalData: []
    }
  };
}

// src/generators/PowercloudEventGenerator.ts
var eventIdCounter = 1e8;
function generateProductVersion(overrides = {}) {
  const timestamp = generatePowerCloudTimestamp();
  return {
    productId: overrides.productId ?? faker6.string.numeric(1),
    version: overrides.version ?? faker6.string.numeric(1),
    status: overrides.status ?? faker6.helpers.arrayElement(["active", "deprecated", "locked"]),
    supplyType: overrides.supplyType ?? faker6.helpers.arrayElement(SUPPLY_TYPES),
    consumptionType: overrides.consumptionType ?? faker6.helpers.arrayElement(CONSUMPTION_TYPES),
    priceType: overrides.priceType ?? faker6.helpers.arrayElement(PRICE_TYPES),
    business: overrides.business ?? faker6.helpers.arrayElement(["both", "private", "business"]),
    pricingType: overrides.pricingType ?? faker6.helpers.arrayElement(PRICING_TYPES),
    usageNtPercentage: overrides.usageNtPercentage ?? null,
    createdAt: overrides.createdAt ?? timestamp,
    updatedAt: overrides.updatedAt ?? timestamp,
    releaseRequestedAt: overrides.releaseRequestedAt ?? null,
    releasedAt: overrides.releasedAt ?? timestamp,
    deprecatedAt: overrides.deprecatedAt ?? (faker6.helpers.maybe(() => generatePowerCloudTimestamp(), {
      probability: 0.3
    }) || null),
    lockedAt: overrides.lockedAt ?? null,
    name: overrides.name ?? `${faker6.commerce.productName()} (${faker6.helpers.arrayElement(["12", "24"])} Monate)`,
    validFrom: overrides.validFrom ?? "2018-07-14",
    validUntil: overrides.validUntil ?? "9999-10-02",
    kind: overrides.kind ?? "contract",
    eco: overrides.eco ?? faker6.helpers.arrayElement(["eco", "standard"]),
    invoiceBase: overrides.invoiceBase ?? "reading",
    contractInvoiceCycle: overrides.contractInvoiceCycle ?? "interval",
    contractInvoiceCycleInterval: overrides.contractInvoiceCycleInterval ?? "12",
    contractInvoiceCycleIntervalType: overrides.contractInvoiceCycleIntervalType ?? "months",
    contractInitialDuration: overrides.contractInitialDuration ?? "12",
    contractInitialDurationType: overrides.contractInitialDurationType ?? "months",
    contractExtensionTime: overrides.contractExtensionTime ?? "12",
    contractExtensionTimeType: overrides.contractExtensionTimeType ?? "months",
    contractCancellationPeriod: overrides.contractCancellationPeriod ?? "28",
    contractCancellationPeriodType: overrides.contractCancellationPeriodType ?? "days",
    erpExternalId: overrides.erpExternalId ?? null,
    erpWeight: overrides.erpWeight ?? null,
    erpStatisticGroup: overrides.erpStatisticGroup ?? null,
    erpVolume: overrides.erpVolume ?? null,
    erpVariantGroupCode: overrides.erpVariantGroupCode ?? null,
    erpProductLink: overrides.erpProductLink ?? null,
    erpManufacturer: overrides.erpManufacturer ?? null,
    erpManufacturerNumber: overrides.erpManufacturerNumber ?? null,
    erpAccount: overrides.erpAccount ?? null,
    erpAllowSplitAmount: overrides.erpAllowSplitAmount ?? "0",
    cmsAgb: overrides.cmsAgb ?? "",
    cmsProperties: overrides.cmsProperties ?? "",
    cmsDescriptionInternal: overrides.cmsDescriptionInternal ?? "",
    cmsDescriptionExternal: overrides.cmsDescriptionExternal ?? "",
    cmsFileId: overrides.cmsFileId ?? null,
    noteFreetext: overrides.noteFreetext ?? "",
    everyTimeCancellable: overrides.everyTimeCancellable ?? "0",
    relocationProhibited: overrides.relocationProhibited ?? "0",
    meterPricing: overrides.meterPricing ?? "Inklusive",
    brand: overrides.brand ?? {
      id: BRANDS[0].id,
      data: {
        id: BRANDS[0].id,
        name: BRANDS[0].name,
        isDeleted: "0",
        createdBy: faker6.string.numeric(2),
        createdAt: timestamp
      },
      additionalData: []
    },
    additionalTerminationRightBeforeDelivery: overrides.additionalTerminationRightBeforeDelivery ?? false,
    billingRuleTemplateId: overrides.billingRuleTemplateId ?? null
  };
}
function generateEventBase(overrides = {}) {
  return {
    messageId: overrides.messageId ?? faker6.string.uuid(),
    EventId: overrides.EventId ?? (++eventIdCounter).toString(),
    EventName: overrides.EventName ?? faker6.helpers.arrayElement([
      ...ORDER_EVENT_NAMES,
      ...CONTRACT_EVENT_NAMES
    ]),
    Environment: overrides.Environment ?? faker6.helpers.arrayElement(ENVIRONMENTS),
    Version: overrides.Version ?? 2,
    EventInstance: overrides.EventInstance ?? faker6.string.uuid(),
    TenantId: overrides.TenantId ?? faker6.helpers.arrayElement(TENANT_IDS),
    CreatedAt: overrides.CreatedAt ?? generatePowerCloudTimestamp(),
    CreatedFrom: overrides.CreatedFrom ?? faker6.helpers.arrayElement(CREATED_FROM)
  };
}
function generateOrderEvent(overrides = {}) {
  const baseEvent = generateEventBase({
    ...overrides,
    EventName: overrides.EventName ?? faker6.helpers.arrayElement(ORDER_EVENT_NAMES)
  });
  const customer = generateCustomer(overrides.Content?.customer);
  const order = generateOrder({
    customerId: customer.customerId ?? "",
    ...overrides.Content?.order
  });
  const productVersion = generateProductVersion(
    overrides.Content?.product_version
  );
  return {
    ...baseEvent,
    Content: {
      version: overrides.Content?.version ?? faker6.number.int({ min: 1, max: 10 }),
      customer,
      order,
      product_version: productVersion
    }
  };
}
function generateContractEvent(overrides = {}) {
  const baseEvent = generateEventBase({
    ...overrides,
    EventName: overrides.EventName ?? faker6.helpers.arrayElement(CONTRACT_EVENT_NAMES)
  });
  const customer = generateCustomer(overrides.Content?.customer);
  const order = generateOrder({
    customerId: customer.customerId ?? "",
    ...overrides.Content?.order
  });
  const productVersion = generateProductVersion(
    overrides.Content?.product_version
  );
  return {
    ...baseEvent,
    Content: {
      version: overrides.Content?.version ?? faker6.number.int({ min: 1, max: 20 }),
      customer,
      order,
      product_version: productVersion
      // TODO: Add contract, market_location, and other contract-specific fields
      // when their generators are implemented
    }
  };
}
function generatePowercloudEvent(type = "order", overrides) {
  switch (type) {
    case "order":
      return generateOrderEvent(overrides);
    case "contract":
      return generateContractEvent(overrides);
    case "invoice":
      throw new Error("Invoice event generation not yet implemented");
    default:
      return generateOrderEvent(overrides);
  }
}
export {
  AccountPaymentSchema,
  AccountSettledReceivableSchema,
  AddressFieldsSchema,
  AllEventNamesSchema,
  BONISCORE_VALUES,
  BOOLEAN_STRING_FLAGS,
  BRANDS,
  BUSINESS_FLAGS,
  BankingDataSchema,
  BrandDataSchema,
  BrandSchema,
  CAMPAIGNS,
  CONSUMPTION_TYPES,
  CONTRACT_EVENT_NAMES,
  CONTRACT_STATUSES,
  CONTRACT_TYPES,
  COUNTER_TYPES,
  COUNTER_TYPE_NAMES,
  COUNTRIES,
  COUNTRY_NAMES,
  CREATED_FROM,
  CUSTOMER_COMMUNICATION_TYPES,
  ClientSchema,
  ContractCounterSchema,
  ContractDepositSchema,
  ContractDisconnectionFeeSchema,
  ContractDunnedReceivableSchema,
  ContractDunningAdditionalReceivableSchema,
  ContractEventContentSchema,
  ContractEventNamesSchema,
  ContractProductSchema,
  ContractSchema,
  ContractTariffChangeNextProductSchema,
  ContractTariffRevokeDateSchema,
  ContractTariffRevokedSchema,
  CustomerCommunicationType,
  CustomerCommunicationTypeSchema,
  CustomerSchema,
  DUNNING_PROCEDURES,
  ENERGY_TYPES,
  ENVIRONMENTS,
  EXTENDED_DATA_CATEGORIES,
  EventTypesSchema,
  ExtendedDataCustomerSchema,
  ExtendedDataSchema,
  ExtendedDataWithVartSchema,
  ExtendedDatumCategorySchema,
  ExtendedDatumSchema,
  GERMAN_AREA_CODES,
  GERMAN_BANKS,
  GERMAN_CITIES,
  GERMAN_STREETS,
  HighestDunningLevelSchema,
  INPUT_CHANNELS,
  INVOICE_EVENT_NAMES,
  InstallmentPlanSchema,
  InvoiceEventContentSchema,
  InvoiceEventNamesSchema,
  METER_PRICING,
  MarketLocationNetworkCarrierSchema,
  MarketLocationSchema,
  ORDER_EVENT_NAMES,
  ORDER_STATUSES,
  OrderEventContentSchema,
  OrderEventNamesSchema,
  OrderSchema,
  PAYMENT_PROVIDERS,
  PRICE_TYPES,
  PRICING_TYPES,
  PowercloudContractEventSchema,
  PowercloudEventSchema,
  PowercloudInvoiceEventSchema,
  PowercloudOrderEventSchema,
  ProductAddOnSchema,
  ProductVersionSchema,
  SALES_CHANNELS,
  SALUTATIONS,
  SUPPLY_TYPES,
  SalutationSchema,
  TENANT_IDS,
  VERSANDART_VALUES,
  VersandartSchema,
  contract_request_customer_reading_1_default as contractExample1,
  contract_request_customer_reading_10_default as contractExample10,
  contract_request_customer_reading_2_default as contractExample2,
  contract_request_customer_reading_3_default as contractExample3,
  contract_request_customer_reading_4_default as contractExample4,
  contract_request_customer_reading_5_default as contractExample5,
  contract_request_customer_reading_6_default as contractExample6,
  contract_request_customer_reading_7_default as contractExample7,
  contract_request_customer_reading_8_default as contractExample8,
  contract_request_customer_reading_9_default as contractExample9,
  contractExamples,
  generateBankingData,
  generateBasicAddress,
  generateBillingAddress,
  generateContractEvent,
  generateCustomer,
  generateDateOfBirth,
  generateFutureBankingData,
  generateFutureDate,
  generateGermanAddress,
  generateGermanBIC,
  generateGermanIBAN,
  generateOrder,
  generateOrderEvent,
  generatePastDate,
  generatePowerCloudDate,
  generatePowerCloudTimestamp,
  generatePowercloudEvent,
  generateSepaMandate,
  getAllExamples,
  getExampleByEventName,
  invoice_created_electricity_1_default as invoiceExample1,
  invoiceExamples,
  order_status_open_1_default as orderExample1,
  order_status_open_2_default as orderExample2,
  orderExamples,
  powercloudEventExamples
};
